module.exports = {
  alarms: 'Сигнали тривоги',
  contacts: 'Контакти',
  groups: 'Групи',
  settings: 'Налаштування',
  notificationsTab: 'Сповіщення',
  specifyTimeInFutureForAlarm: 'Тривога не може бути в минулому.',
  specifyTimeInFutureForPreReminder:
    'Попереднє нагадування про тривогу залишилося в минулому.',
  specifyNameForGroup: "Назва групи є обов'язковою.",
  updatingGroupName: 'Оновлення інформації про групу.',
  unableToEditGroupName:
    'Не вдалося оновити інформацію про групу. Будь ласка, спробуйте ще раз через деякий час.',
  selectSmallerImage:
    'Зображення більше 10 МБ. Виберіть зображення меншого розміру.',
  sendingVerificationCode:
    'Надішліть код підтвердження на адресу {{formattedMobileNumber}}.',
  verifyingCode: 'Перевірка коду.',
  creatingUserProfile: 'Налаштування...',
  unabeToCreateUserProfile:
    'Наразі не вдалося створити обліковий запис. Будь ласка, спробуйте ще раз через кілька хвилин.',
  unableToSendVerificationCode:
    'Не вдалося надіслати код підтвердження. {{error}}',
  unableToVerifyCode: 'Не вдалося перевірити код. {{error}}',
  unableToRegisterUserWithoutMobileNumber:
    'Не вдалося виконати налаштування. {{error}}',
  permissionDeniedToAccessCameraIos:
    'Galarm не має дозволу на доступ до камери. \n\nПерейдіть до Налаштування > Galarm і дозвольте доступ до камери.',
  permissionDeniedToAccessCameraAndroid:
    'Galarm не має дозволу на доступ до камери.\n\nПерейдіть до Налаштування > Програми > Galarm > Дозволи та дозвольте доступ до камери.',
  permissionDeniedToAccessPhotosIos:
    'Galarm не має дозволу на доступ до фотографій.\n\nПерейдіть до Налаштування > Galarm і дозвольте доступ до фотографій.',
  permissionDeniedToAccessPhotosAndroid:
    'Galarm не має дозволу на доступ до фотографій.\n\nПерейдіть до Налаштування > Програми > Galarm > Дозволи та дозвольте доступ до сховища.',
  permissionDeniedToAccessCalendarIos:
    'Galarm не має дозволу на доступ до календаря.\nПерейдіть до Налаштування > Календарі та дозвольте доступ до Galarm.',
  permissionDeniedToAccessCalendarAndroid:
    'Galarm не має дозволу на доступ до календаря.\nПерейдіть до Налаштування > Програми > Galarm > Дозволи і дозвольте доступ до Календаря.',
  verificationCodeSent:
    'Код підтвердження надішліть на адресу {{formattedMobileNumber}}.',
  rateTheApp:
    'Ми сподіваємося, що Galarm буде корисним для вас. Будь ласка, знайдіть хвилинку, щоб оцінити нас в Play Store. Дякуємо за вашу підтримку.',
  backgroundAppRefreshDisabledPermission:
    'Будильники можуть не дзвонити, тому що Galarm не має дозволу на оновлення фонових додатків.\n\nНатисніть "Увімкнути" та увімкніть "Оновлення фонових програм".',
  selectedGroupUnselected:
    'Ви можете вибрати групу або набір контактів як учасників. Вибрана раніше група буде знята з вибору. Продовжити?',
  selectedContactsUnselected:
    'Ви можете вибрати групу або набір контактів як учасників. Попередньо вибрані контакти будуть скасовані. Продовжити?',
  notificationsDisabledIos:
    'Будильники не дзвонитимуть, оскільки Galarm не має дозволу на показ сповіщень.\n\nПерейдіть до Налаштування > Galarm > Сповіщення та увімкніть "Сповіщення", "Звуки" та "Банери".',
  notificationsDisabledAndroid:
    'Сповіщення про тривоги не з\'являтимуться на екрані.\n\nНатисніть "Увімкнути", виберіть "Сповіщення" і дозвольте сповіщення.',
  alarmNotificationChannelDisabled:
    'Сповіщення про тривоги не з\'являтимуться на екрані. \n\nНатисніть "Увімкнути", щоб дозволити сповіщення про тривоги з\'являтися на екрані.',
  alarmLockScreenNotificationlDisabled:
    'Сповіщення про тривоги не відображатимуться на екрані блокування. \n\nНатисніть "Увімкнути", щоб дозволити показувати сповіщення про тривоги на екрані блокування.',
  alarmWillNotRingDueToNotificationsDisabledIos:
    'Будильники не дзвонитимуть, оскільки сповіщення вимкнено.\n\nПерейдіть до Налаштування > Будильник > Сповіщення та увімкніть "Сповіщення", "Звуки" та "Банери".',
  alarmWillNotRingDueToCriticalAlertsDisabledIos:
    'Будильники не дзвонитимуть, якщо телефон вимкнено, оскільки критичні оповіщення вимкнено.\n\nПерейдіть до Налаштування > Будильник > Сповіщення та увімкніть "Критичні сповіщення".',
  alarmWillNotRingDueToNotificationsDisabledAndroid:
    'Тривога не з\'явиться на екрані, оскільки сповіщення вимкнено.\n\nНатисніть "Увімкнути", виберіть "Сповіщення" та увімкніть сповіщення.',
  noNotificationsScheduledAlarmInPast:
    'Тривога в минулому. Сповіщення не заплановані.',
  alarmOverAllowedLimit: {
    zero: '\nВи досягли ліміту тривог {{limit}} тривог.\n\nБудь ласка, видаліть або повторно використайте існуючу тривогу.',
    one: 'Ви досягли ліміту тривог {{limit}} тривог.\n\nУ вас є 1 неактивний тривожний сигнал, який ви можете видалити або використати повторно.',
    other:
      'Ви досягли ліміту тривог {{limit}} тривог.\n\nУ вас є {{count}} неактивних тривог, які ви можете видалити або використати повторно.'
  },
  alarmAlreadyConfirmed: 'Ви вже підтвердили.',
  alarmAlreadyDeclined: 'Ти вже відмовився.',
  participantMovedToPosition: '{{name}} перенесено на позицію {{count}}.',
  memberIsFirstParticpant: '{{name}} перший учасник.',
  memberIsLastParticpant: '{{name}} останній учасник.',
  cantContinueWithRegistrationWhenOffline:
    'Неможливо продовжити реєстрацію, оскільки пристрій перебуває в режимі офлайн.',
  cantContinueWithRegistrationWhenOfflineWithTryAgain:
    'Неможливо продовжити реєстрацію, оскільки пристрій перебуває в режимі офлайн. Переконайтеся, що ви підключені до Інтернету.',
  confirmBlockContact:
    'Ви більше не будете отримувати тривоги від {{name}}. Продовжувати?',
  confirmUnblockContact:
    'Розблокування {{name}} також відновить заблоковані тривоги з них. Приступити?',
  unblockingContact: 'Розблокування {{name}} та відновлення тривог.',
  unableToUnblockContact: 'Не вдається розблокувати контакт. {{error}}',
  blockingContact: 'Блокування {{name}}.',
  unableToBlockContact: 'Неможливо заблокувати контакт. {{error}}',
  cantAddContactToAlarmBecauseBlocked:
    'Ви заблокували {{name}}. Розблокуйте їх, щоб додати до учасників тривоги.',
  cantAddContactToGroupBecauseBlocked:
    'Ви заблокували {{name}}. Розблокуйте їх, щоб приєднатися до групи.',
  sendMessageNotAllowedForPastAlarms:
    'Повідомлення не можна надсилати за неактивними тривогами.',
  nameIsRequired: "Ім'я обов'язкове.",
  confirmDisableGroupAlarm:
    'Вимкнення групового будильника також вимкне будильник для інших учасників. Приступити?',
  removeMemberFromGroup: 'Ви хочете видалити {{name}} з цієї групи?',
  leaveGroupConfirm: 'Ви хочете покинути цю групу?',
  deviceOffline:
    'Пристрій перебуває в режимі офлайн. Переконайтеся, що ви підключені до Інтернету, і спробуйте ще раз.',
  mustBeOnlineForEnhancedAutoSnoozeCount:
    'Ви повинні бути онлайн, щоб зберегти будильник з кількістю відкладань більше ніж 2.',
  cantUpdateTimezoneForAllAlarms:
    'Не вдається оновити часовий пояс для наявних тривог',
  cantUpdateRingtonesForAllAlarms:
    'Не вдається оновити налаштування звуку та вібрації для наявних будильників',
  cantUpdateGroupDefaulConfigWhenOffline:
    'Змінену конфігурацію групи не буде застосовано до майбутніх тривог, оскільки пристрій перебуває в режимі офлайн.',
  specifyFeedback: "Потрібен зворотній зв'язок.",
  specifyEmailId: "Адреса електронної пошти обов'язкова.",
  specifyValidEmailId: 'Адреса електронної пошти не є дійсною.',
  specifyProblem: "Опис проблеми є обов'язковим.",
  appInstalledUsingSameNumberOnDifferentPhone:
    'Ви встановили Galarm на інший пристрій, використовуючи той самий номер. Додаток на цьому пристрої скинуто.',
  invalidUid:
    'Цей обліковий запис користувача більше не існує. Додаток Galarm на цьому пристрої скинуто.',
  accountDeleted: 'Ваш обліковий запис видалено.',
  deleteAccount: 'Видалити мій обліковий запис',
  deletingAccount: 'Видалення облікового запису',
  howCanWeImprove: 'Нам шкода, що ви йдете. Як ми можемо покращити?',
  noMusicAlert: 'Музичних файлів не знайдено.',
  noLongerAvailableMusic:
    '{{fileName}} більше не доступний. Рингтон змінено на {{defaultRingtoneName}}',
  userInactiveTitle: 'З поверненням!',
  userInactiveMessage:
    'Створюйте будильники для важливих справ і ніколи не пропускайте їх.',
  createAlarm: 'Створити тривогу',
  updatedAppAvailable: 'Доступна нова версія додатку.',
  alarmOccurrenceDisabled: 'Вимкнено для цієї події',
  ownAlarmOccurrenceDone: {
    zero: 'Зроблено за адресою {{timeString}}',
    one: 'Відмітити виконано на сайті {{timeString}} на {{dateString}}'
  },
  ownAlarmOccurrenceSkipped: {
    zero: 'Пропущено в {{timeString}}',
    one: 'Пропущено на {{timeString}} на {{dateString}}'
  },
  enabledAlarmsCount: {
    one: 'Увімкнено 1 тривогу.',
    other: '{{count}} тривоги увімкнено.'
  },
  enabledAndNotEnabledAlarmsCount: {
    one: '1 тривогу увімкнено. Тривоги, які не виникатимуть у майбутньому, залишаються вимкненими.',
    other:
      '{{count}} тривоги увімкнено. Тривоги, які не виникатимуть у майбутньому, залишаються вимкненими.'
  },
  disabledAlarmsCount: {
    one: '1 тривогу вимкнено.',
    other: '{{count}} тривоги вимкнено.'
  },
  ownAlarmOccurrenceUnacknowledged: 'Не відповіли',
  participantAlarmOccurrenceDone: {
    zero: 'Відмічено, що виконано {{participantName}} за адресою {{timeString}}',
    one: 'Зроблено {{participantName}} за адресою {{timeString}} на {{dateString}}'
  },
  participantAlarmOccurrenceSkipped: {
    zero: 'Пропущено {{participantName}} за адресою {{timeString}}',
    one: 'Пропущено {{participantName}} на {{timeString}} на {{dateString}}'
  },
  participantAlarmOccurrenceUnacknowledged: '{{participantName}} не відповів.',
  groupAlarmOccurrenceConfirmed: {
    zero: 'Підтверджено на {{timeString}}',
    one: 'Підтверджено на сайті {{timeString}} {{dateString}}'
  },
  groupAlarmOccurrenceDeclined: {
    zero: 'Відхилено в {{timeString}}',
    one: 'Відхилено на {{timeString}} на {{dateString}}'
  },
  warning: 'Попередження',
  info: 'Інформація',
  confirm: 'Підтвердити',
  error: 'Помилка.',
  cantUploadImage: 'Не вдається завантажити зображення',
  cantDeleteImage: 'Не вдається видалити зображення',
  cantEditGroup: 'Не вдається редагувати групу',
  cantAddNewContact: 'Не вдається додати новий контакт',
  cantDeleteContact: 'Не вдається видалити контакт',
  cantEditContact: 'Не можу редагувати контакт',
  cantSaveAlarm: 'Не вдається зберегти тривогу',
  cantSaveGroup: 'Не вдається зберегти групу',
  cantReloadContacts: 'Не вдається перезавантажити контакти',
  cantTakePhoto: 'Не можна фотографувати',
  cantExportToCalendar: 'Не вдається експортувати до календаря',
  cantOpenPhotoLibrary: 'Не вдається відкрити фототеку',
  cantDeleteAlarmHistory: 'Не вдається видалити історію тривог',
  cannotDuplicateAlarm: 'Неможливо продублювати тривогу',
  upgradeToPremiumToDuplicateAlarm:
    'Оновіть тарифний план до Преміум, щоб створювати більше групових та дружніх тривог.',
  confirmAcceptAlarm: 'Прийняти тривогу?',
  confirmRejectAlarm: 'Сигнал тривоги?',
  deleteAlarm: 'Видалити тривогу?',
  restoreAlarmConfirmation: 'Відновити тривогу?',
  respondToRepeatingAlarm: {
    zero: 'Ви додані як одержувач тривоги {{alarmName}} за допомогою {{alarmCreatorName}}. Ви будете отримувати сповіщення на {{alarmTimeString}} {{alarmRepetitionString}} починаючи з {{alarmDateString}}',
    one: 'Ви додані як учасник тривоги {{alarmName}} за допомогою {{alarmCreatorName}}. Ви будете отримувати сповіщення на {{alarmTimeString}} {{alarmRepetitionString}} починаючи з {{alarmDateString}}'
  },
  respondToOneTimeAlarm: {
    zero: 'Ви додані як одержувач тривоги {{alarmName}} за допомогою {{alarmCreatorName}}. Ви отримаєте сповіщення на {{alarmTimeString}} {{alarmDateString}}',
    one: 'Ви додані як учасник тривоги {{alarmName}} за допомогою {{alarmCreatorName}}. Ви отримаєте сповіщення на {{alarmTimeString}} {{alarmDateString}}'
  },
  cantMoveMemberUp: 'Неможливо перемістити {{name}} вгору',
  cantMoveMemberDown: 'Неможливо перемістити {{name}} вниз',
  decline: 'Відхилити',
  cantEditProfile: 'Не можу редагувати профіль',
  cantSelectContact: 'Не вдається вибрати контакт',
  cantSendMessage: 'Не вдається надіслати повідомлення',
  cantSendVerificationCode: 'Не вдається надіслати код підтвердження',
  confirmBlockContactTitle: 'Підтвердити контакт з блоком',
  confirmUnblockContactTitle: 'Підтвердити розблокування контакту',
  cantSaveProfile: 'Не вдається зберегти профіль',
  cantBlockContact: 'Неможливо заблокувати контакт',
  cantUnblockContact: 'Не вдається розблокувати контакт',
  cantLoadEarlierMessages: 'Не вдається завантажити попередні повідомлення',
  cantRestoreAlarm: 'Не вдається відновити будильник',
  cantSendFeedback: 'Не можу надіслати відгук',
  cantSubmitProblem: 'Не вдається відправити проблему',
  cantDeletePastAlarmsInBulk: 'Неможливо видалити неактивні тривоги масово',
  cantAddNewGroup: 'Не вдається додати нову групу',
  alreadySnoozing: 'Вже дрімає',
  markAlarmUndone:
    'Ви позначили цю тривогу як "Виконано" {{durationString}} назад. Відмінити?',
  markAlarmUnskipped:
    'Ви пропустили цей будильник {{durationString}} тому. Відмінити?',
  cantUndo: 'Не можна скасувати',
  fetchMusicFromPhone: 'Пошук доступної музики.',
  enableAllAlarmsInCategory: 'Увімкнути всі тривоги в цій категорії?',
  disableAllAlarmsInCategory: 'Вимкнути всі тривоги в цій категорії?',
  allAlarmsAlreadyEnabled: 'Усі тривоги в цій категорії вже увімкнено.',
  allAlarmsAlreadyDisabled: 'Усі тривоги в цій категорії вже вимкнено.',
  time: 'Час',
  timeForBuddy: 'Час для Бадді',
  timeForYou: 'Нагадайте мені за адресою',
  name: "Ім'я",
  title: 'Назва',
  notes: 'Примітки',
  repeat: 'Повторити',
  preReminder: 'Попереднє нагадування',
  remove: 'Видалити',
  considerEventsEndingWith:
    'Налаштувати будильники для подій, що закінчуються на',
  considerEventsContaining: 'Налаштувати будильники для подій, що містять',
  eventsEndingWith: 'Події, що закінчуються на',
  eventsContaining: 'Події, що містять',
  preReminderShortAlert: '{{duration}} Попереднє нагадування',
  preReminderTitle: '{{alarmName}} за адресою {{date}}',
  preReminderGroupHelperText:
    'Це попереднє нагадування призначене лише для вас. Інші учасники тривоги можуть встановити власні нагадування, як тільки отримають тривогу.',
  addPreReminder: 'Додати попереднє нагадування',
  helperTextForPreReminder:
    'Натисніть кнопку скидання вгорі, щоб видалити попереднє нагадування.',
  edit: 'Редагувати',
  delete: 'Видалити',
  creator: 'Творець',
  useAsDefaultGroupConfiguration: 'Застосувати до майбутніх тривог',
  done: 'Зроблено.',
  selectAll: 'Вибрати все',
  skipped: 'Пропущено.',
  save: 'Зберегти',
  members: 'Члени',
  mobileNumber: 'Номер телефону',
  enter: 'Увійдіть',
  addMembers: 'Додати членів',
  respond: 'Відповісти',
  yes: 'Так.',
  no: 'Ні.',
  notAvailable: 'Недоступно',
  cancel: 'Скасувати',
  participants: 'Учасники та учасниці',
  takePhoto: 'Зробити фото',
  chooseFromLibrary: 'Виберіть з бібліотеки',
  resendCode: 'Повторно надіслати код',
  register: 'Зареєструватися',
  inviteFriends: 'Поділіться цим додатком',
  invite: 'Запросити',
  incorrectNumber: 'Неправильний номер?',
  date: 'Дата',
  cascadingAlarmInterval: 'Час між оповіщеннями учасників',
  ringParticipantAlarmsByDefault: 'Дзвонити на тривоги, не приймаючи виклик',
  alarmRingtone: 'Сигнал будильника',
  pickASong: 'Виберіть музику з телефону',
  privacyPolicy: 'Політика конфіденційності',
  sendFeedback: "Зворотній зв'язок",
  galarmWeb: 'Galarm Web',
  galarmEnterprise: 'Galarm Pro',
  galarmAdmin: 'Адміністратор Galarm',
  troubleshooting: 'Усунення несправностей',
  alarmDidntRingHelp: 'Допоможіть! Мій будильник не дзвонив.',
  autoStartSettingHelperText:
    'Якщо у вашому телефоні налаштовано автоматичний запуск, переконайтеся, що він увімкнений для Galarm.',
  batteryOptimizationHelperText: 'Вимкнути оптимізацію батареї для Galarm',
  troubleshootingHelperText:
    'Наступні налаштування можуть перешкоджати тому, щоб будильники спрацьовували належним чином. Будь ласка, перевірте ці налаштування.',
  getMoreHelpText: 'Все ще маєте проблеми?',
  autoStartSetting: 'Автозапуск',
  batteryOptimization: 'Оптимізація роботи акумулятора',
  battery: 'Батарея',
  rateTheAppSettings: 'Оцініть цей додаток',
  about: 'Про компанію та допомога',
  leaveGroup: 'Залишити групу',
  removeGroup: 'Видалити групу',
  viewMember: 'Вигляд {{memberName}}',
  removeMember: 'Видалити {{memberName}}',
  changeMemberState: 'Змінити, хто може сповіщати {{memberName}}',
  changeYourGroupState: 'Змініть того, хто може вас сповіщати',
  numMembersInGroup: 'Члени: {{count}}',
  notifications: 'Сповіщення додатків вимкнено',
  backgroundAppRefresh: 'Фонове оновлення програми вимкнено',
  groupsInCommon: 'Спільні групи',
  alarmsInCommon: 'Спільні тривоги',
  close: 'Закрити',
  responsePending: 'Ваша відповідь?',
  later: 'Пізніше.',
  install: 'Встановити',
  all: 'Усе.',
  numYears: {
    one: '1 рік',
    other: '{{count}} років'
  },
  numMonths: {
    one: '1 місяць',
    other: '{{count}} місяці'
  },
  numDays: {
    one: '1 день',
    other: '{{count}} днів'
  },
  hours: {
    one: '1 година',
    other: '{{count}} годин'
  },
  minutes: {
    one: '1 хвилина',
    other: '{{count}} хвилини'
  },
  seconds: {
    one: '1 секунда',
    other: '{{count}} секунди'
  },
  minutesSmall: '{{count}} хв',
  secondsSmall: '{{count}} секунду.',
  hoursAfter: {
    one: 'Через 1 годину після',
    other: '{{count}} через кілька годин після того.'
  },
  minutesAfter: {
    one: 'Через 1 хвилину після',
    other: '{{count}} через кілька хвилин після того, як'
  },
  hoursAfterBuddy: {
    one: '1 година після приятеля',
    other: '{{count}} через кілька годин після того, як Бадді'
  },
  minutesAfterBuddy: {
    one: '1 хвилина після приятеля',
    other: '{{count}} через кілька хвилин після того, як Бадді'
  },
  longerThanAnHour: '> 1 години',
  licenses: 'Ліцензування третіх осіб',
  version: 'Версія',
  termsOfService: 'Умови надання послуг',
  showPrivacyPolicy: '> Політика конфіденційності',
  showTermsOfService: '> Умови надання послуг',
  showLicenses: '> Ліцензування третіх осіб',
  change: 'Зміна',
  snooze: 'Засинай.',
  somethingWentWrong: 'Щось пішло не так. Будь ласка, оновіть сторінку.',
  ringOnVibrate: 'Дзвінок без звуку',
  vibrate: 'Вібруй',
  ringOnEarphoneOnly: 'Дзвінок будильника тільки для навушників',
  ringOnSpeakerAndEarphone: 'Сигнал дзвінка на динаміку та навушниках',
  whenEarphoneIsConnected: 'Коли підключені навушники',
  tapGesture: 'Натисніть',
  slideGesture: 'Слайд',
  silent: 'Тихо.',
  volume: 'Обсяг',
  soundAndVibration: 'Звук і вібрація',
  advancedSettings: 'Додаткові налаштування',
  gestureToDismissAnAlarm: 'Жест для скидання будильника',
  someNotificationsAreMuted: 'Деякі сповіщення вимкнено',
  allNotificationsEnabled: 'Усі сповіщення ввімкнено',
  notificationSettings: 'Налаштування сповіщень',
  missedAlarmsPlacement: 'Розташування пропущених будильників',
  missedAlarmsPlacementTooltipMessage:
    'Виберіть, де пропущені будильники відображатимуться у списку будильників.',
  showMissedAlarmsOnTop: 'Показувати зверху',
  showMissedAlarmsAfterUpcoming: 'Показувати після майбутніх будильників',
  showMissedAlarmsNotification: 'Показувати сповіщення зверху',
  hideMissedAlarms: 'Не показувати пропущені будильники',
  galarmWebNotifications: 'Веб-сповіщення Galarm',
  alarmsfromOthersNotifications: 'Сповіщення про тривоги учасників',
  sharedAlarmNotifications: 'Спільні сповіщення про тривоги',
  alarmChatNotifictions: 'Сповіщення в чаті про тривоги',
  groupNotifications: 'Групові сповіщення',
  alarmAcknowledgementNotifications: 'Сповіщення про підтвердження тривог',
  send: 'Надіслати',
  prev: 'Попередній',
  snoozing: '{{timeString}}',
  snoozingStatus: 'Відкладено',
  specifySnoozeDuartion: 'Вкажіть тривалість повтору',
  chooseDifferentDuration: 'Виберіть іншу тривалість',
  noCalendarsFound: 'Календарів на пристрої не знайдено.',
  eventWillEndAt: 'Подія завершиться за посиланням {{timeString}}.',
  selectDurationWithinTheSameDay: 'Подія не може перетинати межу дня.',
  cannotMapRepeatTypeInTheDeviceCalendar:
    'Неможливо "Експортувати до календаря", оскільки параметр "Повтор" вашого будильника не підтримується календарем.',
  alarmSavedToCalendar: 'Будильник успішно збережено до календаря.',
  faq: 'Поширені запитання',
  searchingFaqs: "Пошук пов'язаних статей довідки...",
  faqsMayHelp:
    'Ми знайшли деякі статті допомоги, які можуть відповісти на ваше запитання:',
  noFaqsFound: "Не знайдено пов'язаних статей допомоги.",
  sendFeedbackAnyway: 'Все одно надіслати відгук',
  editFeedback: 'Редагувати відгук',
  submitProblemAnyway: 'Все одно надіслати проблему',
  editProblem: 'Редагувати проблему',
  openSettings: 'Відкрийте Налаштування',
  openAppSettings: 'Відкрийте налаштування програми',
  alreadyDone: 'Зроблено.',
  enableAutoStart: 'Увімкнути автозапуск',
  restrictedApps: 'Програми з обмеженим доступом',
  unmonitoredApps: 'Неконтрольовані програми',
  enableProtected: 'Захищені програми',
  manageAppLaunch: 'Керування запуском програми',
  unblockContact: 'Розблокувати контакт',
  blockContact: 'Блок-контакт',
  call: 'Дзвони. {{name}}',
  text: 'Текст {{name}}',
  chat: 'Чат',
  ok: 'ГАРАЗД.',
  stopSnooze: 'Зупинити дрімоту',
  emailId: 'Ваша електронна адреса',
  feedback: "Зворотній зв'язок",
  submit: 'Надіслати',
  reportAProblem: 'Повідомити про проблему',
  enableAlarm: 'Увімкнути тривогу',
  restoreAlarm: 'Відновити тривогу',
  deletePastAlarms: 'Видалення неактивних тривог',
  accept: 'Прийняти',
  defaultPersonalAlarmName: 'Персональне нагадування',
  defaultGroupAlarmName: 'Груповий захід',
  defaultRecipientAlarmName: 'Будильник друга',
  search: 'Пошук',
  recent: 'Нещодавно',
  upcoming: 'Найближчим часом',
  missed: 'Промахнувся.',
  expired: 'Пропущено',
  past: 'Минуле',
  active: 'Активний',
  inactive: 'Неактивний',
  allAlarms: 'Всі тривоги',
  myAlarms: 'Мої будильники',
  participantAlarms: 'Тривоги учасників',
  pendingParticipantAlarms: 'Нові тривоги від інших',
  alarmsWithUnreadChatMessages: 'Тривоги з новим чатом',
  systemNotifications: 'Системні повідомлення',
  missedAlarms: 'Пропущені тривоги',
  missedAlarmsInCategory: '{{name}} Пропущені тривоги',
  showMissedAlarms: 'Показати пропущені тривоги',
  recentlyDeletedAlarms: 'Нещодавно видалені тривоги',
  searchAlarms: 'Пошукові тривоги',
  searchTasks: 'Завдання пошуку',
  startTypingToSearchTasks: 'Почніть вводити, щоб знайти завдання',
  noTasksFoundForSearch:
    'Не знайдено завдань, що відповідають "{{searchText}}"',
  participant: 'Учасник',
  you: 'Ти.',
  none: 'Ні.',
  onceOnly: 'Тільки один раз.',
  weekdays: 'Будні дні',
  weekends: 'Вихідні дні',
  everyDayString: 'Щодня',
  everySunday: 'Щонеділі',
  everyMonday: 'Щопонеділка',
  everyTuesday: 'Щовівторка',
  everyWednesday: 'Щосереди',
  everyThursday: 'Щочетверга',
  everyFriday: "Щоп'ятниці",
  everySaturday: 'Щосуботи',
  sunday: 'Неділя',
  monday: 'Понеділок',
  tuesday: 'Вівторок',
  wednesday: 'Середа',
  thursday: 'Четвер',
  friday: "П'ятниця",
  saturday: 'Субота',
  january: 'Січень',
  february: 'Лютий',
  march: 'Березень',
  april: 'Квітень',
  may: 'Травень',
  june: 'Червень',
  july: 'Липень',
  august: 'Серпень',
  september: 'Вересень',
  october: 'Жовтень',
  november: 'Листопад',
  december: 'Грудень',
  jan: 'Ян',
  feb: 'Лютий',
  mar: 'Мар',
  apr: 'Квітень',
  shortMay: 'Травень',
  jun: 'Джун',
  jul: 'Джул',
  aug: 'Серпень',
  sep: 'Sep',
  oct: 'Жовтень',
  nov: 'Листопад',
  dec: 'Грудень',
  sun: 'Нд',
  mon: 'Пн',
  tue: 'Вт',
  wed: 'Ср',
  thu: 'Чт',
  fri: 'Пт',
  sat: 'Сб',
  first: '1-й',
  second: '2-й',
  third: '3-й',
  fourth: '4-й',
  fifth: '5-й',
  every: 'Кожен',
  oddNumberedDays: 'Непарні дати',
  evenNumberedDays: 'Парні дати',
  noParticipants: 'Немає учасників',
  typeYourMessage: 'Введіть своє повідомлення',
  cantPostMessageToPastAlarm:
    'Неможливо надіслати повідомлення до неактивної тривоги',
  groupName: 'Група: {{name}}',
  confirmed: 'підтверджено',
  declined: 'відхилено',
  Done: 'Зроблено.',
  Skip: 'Пропустити.',
  Confirm: 'Підтвердити',
  Decline: 'Відхилити',
  Accept: 'Прийняти',
  today: 'сьогодні',
  on: 'на',
  recipientAlarm: 'Будильник друга',
  recipient: 'Одержувач',
  remindMeAfter: 'Нагадай мені.',
  remindMeIn: 'Нагадайте мені в',
  newRecipientAlarm: 'Новий будильник для друзів',
  editRecipientAlarm: 'Редагувати будильник друга',
  newInstantAlarm: 'Новий миттєвий сигнал',
  instantAlarms: 'Миттєві сигнали',
  noTaskAlarms: `Немає будильників завдань

Будильники завдань встановлюються з завдань і списків завдань.`,
  taskAlarmName: 'Завдання: {{alarmName}}',
  noInstantAlarms: `Немає миттєвих сповіщень

Миттєві сповіщення можна використовувати для негайного сповіщення контакту або групи у разі надзвичайних ситуацій або термінових завдань.`,
  alarmDone: 'Тривогу позначено як Виконано',
  alarmSkipped: 'Тривога пропущена',
  undo: 'Відмінити',
  enterVerificationCode: 'Будь ласка, введіть 4-значний код нижче:',
  initializing: 'Ініціалізація',
  tryAgain: 'Спробуйте ще раз',
  nMore: '+ {{count}} більше',
  enableNotification: 'Увімкнути',
  enableAlarmNotificationChannel: 'Увімкнути',
  enableBackgroundAppRefresh: 'Увімкнути',
  viewImpactedAlarms: 'Сигнали тривоги',
  viewImpactedGroups: 'Групи',
  dismiss: 'Звільнити.',
  minsInterval: '+ {{count}}m',
  secsInterval: '+ {{count}}s',
  hoursInterval: '+ {{count}}h',
  daysInterval: '+ {{count}}d',
  snoozeUnitHours: 'Години',
  snoozeUnitMinutes: 'Хвилини',
  snoozeUnitDays: 'Дні',
  selectMinutes: 'Виберіть хвилини',
  selectHours: 'Виберіть години',
  selectDays: 'Виберіть дні',
  selectHoursAndMinutes: 'Виберіть години та хвилини',
  enterDuration: 'Тривалість',
  snoozeUnit: 'Одиниця',
  specifySnoozeUnit: 'Вкажіть одиницю виміру будильника',
  specifySnoozeDuration: 'Вкажіть тривалість повтору',
  duration: 'Тривалість',
  quickAlarmName: {
    zero: '{{minutes}} хвилинне нагадування',
    one: '{{hours}} годинне нагадування',
    other: '{{hours}} година {{minutes}} хв нагадування'
  },
  alarmTitleForGoogleVoiceTimerCommand: '{{durationString}} нагадування',
  addedAlarmFromVoiceCommand:
    'Додано тривогу для {{alarmName}} за адресою {{dateString}}',
  addedTimerFromVoiceCommand: 'Додано таймер для {{duration}}',
  clear: 'Чисто',
  ringtoneDuration: 'Тривалість мелодії дзвінка',
  chooseDuration:
    'Виберіть тривалість. Торкніться кілька разів, щоб підсумувати.',
  newAlarm: 'Новий сигнал тривоги',
  quickAlarm: 'Коротке нагадування',
  quickAlarmWillRingAt: 'Сигнал тривоги пролунає на {{timeString}}.',
  alarmWithSnoozeAt: 'Будильник задзвонить далі {{timeString}}',
  preReminderWillRingAt: {
    zero: 'Попереднє нагадування про цю тривогу пролунає \nна {{timeString}}.',
    one: 'Попереднє нагадування про будильник пролунає \nна {{timeString}} напередодні.',
    other:
      'Попереднє нагадування про будильник пролунає \nна {{timeString}} {{count}} за кілька днів до цього.'
  },
  random: 'Випадковість',
  enableAllAlarms: 'Увімкнути всі тривоги',
  disableAllAlarms: 'Вимкнути всі будильники',
  deleteAllAlarms: 'Видалити всі тривоги',
  hideCategory: 'Приховати категорію',
  unhideCategory: 'Розкрити категорію',
  dontShowHiddenCategories: 'Не показувати приховані категорії',
  showHiddenCategories: 'Показати приховані категорії',
  welcomeAlarmsTitle: 'Починаємо!',
  welcomeAlarmsMessage: 'Ось кілька найпоширеніших сигналів тривоги:',
  onboardingAlarms: 'Тривоги при посадці на борт',
  hiddenAlarmCategories: 'Приховані категорії',
  restorePurchases: 'Відновлення покупок',
  noAvailablePurchasesFound:
    'Для вашого облікового запису не знайдено доступних покупок.\n\nБудь ласка, надішліть нам відгук через "Налаштування > Зворотній зв\'язок", якщо у вас є дійсна покупка, яку ви не можете відновити.',
  restoringPurchases: 'Відновлення покупок',
  fetchingContacts: 'Перевірка контактів, які використовують Galarm',
  enterNameAndUploadPhotoForUser:
    "Введіть своє ім'я нижче та за бажанням завантажте фотографію профілю",
  enterNameAndUploadPhotoForGroup:
    "Введіть ім'я нижче та за бажанням завантажте групову фотографію",
  noContactsWithAppInstalled: 'Ніхто з ваших контактів не користується Galarm.',
  galarmContacts: {
    one: '1 контакт Galarm',
    other: '{{count}} Контакти Galarm'
  },
  contactsPendingInvitation: {
    one: '1 запрошення на розгляді',
    other: '{{count}} очікують на запрошення'
  },
  otherContacts: {
    one: '1 інший контакт',
    other: '{{count}} інші контакти'
  },
  over100Contacts: 'Понад 100 інших контактів',
  noAlarms:
    'У вас немає жодного будильника. Натисніть +, щоб додати новий будильник.',
  noContactsWeb: {
    one: 'Ми не знайшли жодного контакту, який би використовував Galarm. Або у нас немає дозволу на доступ до ваших контактів, або ніхто з ваших контактів не використовує Galarm. Ви можете синхронізувати свої контакти з мобільного додатку.\n\nВи можете додавати контакти, які використовують Galarm, до своїх будильників різними способами, щоб скористатися перевагами додатку',
    other:
      'Будь ласка, зареєструйтесь у мобільному додатку, щоб почати додавати контакти до своїх тривог.'
  },
  viewingAlarmsInCommon: 'Тривоги, що мають спільні ознаки з {{name}}',
  viewingGroupsInCommon: 'Групи, що мають спільні риси з {{contactName}}',
  changeGroupMemberConfigTextForCascadingAlarm:
    'Активні учасники будуть сповіщені в порядку, що відображається на екрані.',
  changeGroupMemberConfigTextForSimultaneousAlarm:
    'Лише активні учасники отримають сповіщення.',
  changeGroupMemberStateText: {
    zero: 'Змінити учасників, які можуть сповіщати вас про створення тривоги для групи "{{groupName}}".\n\nВи отримаєте сповіщення, тільки якщо тривогу буде створено користувачами з відповідними правами.',
    one: 'Змінити учасників, які можуть сповіщати {{memberName}} про створення тривоги для групи "{{groupName}}".\n\n{{memberName}} буде сповіщено, лише якщо тривогу створено користувачами з відповідними правами.'
  },
  allowed: 'Дозволено',
  notAllowed: 'Не дозволено',
  changeStatus: 'Допущені учасники',
  noUpcomingAlarms: 'Немає майбутніх тривог',
  showMore: 'Показати більше',
  nMorePastAlarms: {
    one: 'Ще 1 неактивна тривога',
    other: '{{count}} більше неактивних тривог'
  },
  shareAppMessage:
    'Я роблю всі свої справи вчасно, створюючи для них нагадування за допомогою додатку Galarm. За допомогою цього додатку ми також можемо включати один одного в наші нагадування. Я рекомендую завантажити цей інноваційний додаток для будильників і нагадувань. {{downloadLink}}',
  addingMembers: 'Додавання членів.',
  unableToAddMembers: 'Не вдалося додати користувача. {{error}}',
  removingMember: 'Виймаю член.',
  unableToRemoveMember: 'Не вдалося видалити користувача. {{error}}',
  leavingGroup: 'Група відходить.',
  unableToLeaveGroup: 'Неможливо вийти з групи. {{error}}',
  expiredPersonalAlarmForCreator: {
    zero: 'Термін дії цього тривожного сигналу закінчився {{durationString}} тому. Натисніть "Готово", щоб завершити тривогу.',
    one: 'Термін дії цієї тривоги закінчився {{durationString}} тому. Натисніть "Готово", щоб завершити тривогу і повідомити учасників.',
    other:
      'Термін дії цієї тривоги закінчився {{durationString}} тому. Натисніть "Готово", щоб завершити тривогу і повідомити учасників.'
  },
  donePersonalAlarmForCreator:
    'Термін дії цієї тривоги закінчився {{durationString}} тому. Тривогу позначено як виконану.',
  skippedPersonalAlarmForCreator:
    'Термін дії будильника закінчився {{durationString}} років тому. Ви пропустили будильник.',
  expiredGroupAlarm:
    'Термін дії цієї тривоги закінчився {{durationString}} тому. Будь ласка, підтвердіть свою участь.',
  expiredPersonalAlarmForParticipant:
    'Термін дії цієї тривоги закінчився {{durationString}} років тому. Будь ласка, нагадайте {{creatorName}}.',
  alarmDurationAndroid:
    'Відтепер будильник встановлений на {{durationString}}.',
  alarmDurationIos: 'Відтепер будильник встановлений на {{durationString}}.',
  alarmFeedbackHeader:
    'Ви будете надсилати частину інформації про цю тривогу для цілей налагодження. Будь-які особисті дані, такі як назва тривоги, примітки або учасники, не будуть передаватися.',
  privacyPolicyHeader:
    "Повага до вашого приватного життя - наш головний пріоритет. Як і ви, ми цінуємо конфіденційність, тому хочемо, щоб ви знали, що ми нікому не передаємо вашу особисту інформацію, окрім випадків, коли вона необхідна для встановлення програми або коли цього вимагає закон. У всіх випадках ми ніколи не продаємо вашу інформацію. Це дуже просто!\n \nСтворені вами тривоги можна переглянути лише на вашому пристрої та, якщо тривога включає інших учасників, на пристроях цих учасників.\n \nМи отримуємо доступ до адресної книги/списку контактів вашого телефону лише для заповнення вкладки контактів у Galarm. Ми не зберігаємо цей список для будь-яких інших цілей. Ми поважаємо те, що це ваша адресна книга!\n \nМи отримуємо доступ до вашої камери і фотографій тільки для того, щоб ви могли встановити гарне зображення профілю. Це зображення відображається як ваш аватар або як зображення профілю групи, яку ви редагуєте. Інші користувачі Galarm, які є учасниками встановлених вами будильників, зможуть бачити це зображення.\n\nМи надсилаємо публічний IP-адресу вашого пристрою та його унікальний ідентифікатор з усіма запитами, наприклад, при запиті та перевірці коду під час реєстрації. Ця інформація не пов'язана з вашим обліковим записом і використовується лише для визначення будь-якої потенційної зловмисної активності.\n \nБудь ласка, перегляньте повну політику конфіденційності, щоб дізнатися більше про інформацію, яку ми збираємо і як ми її використовуємо.",
  termsOfServiceHeader:
    'Використовуючи додаток Galarm, ви погоджуєтеся з нашими Умовами надання послуг, які регулюють ваш доступ і використання цього мобільного додатку, а також функцій і послуг, які він пропонує. \n\nДевіз Galarm простий - допомогти вам ніколи не пропустити жодної події!  Незалежно від того, чи це налаштування персональних будильників для оповіщення про пробудження, вчасного прибуття на зустрічі, встановлення нагадувань про такі заходи, як вчасний прийом ліків, чи створення групових будильників для організації групових заходів, таких як походи в кіно, спортивні заходи та вечірки, Galarm дозволяє вам мати соціальний будильник, щоб нагадувати один одному, відслідковувати статус один одного та спілкуватися.\n\nБудь ласка, використовуйте Galarm тільки якщо ви згодні з цими умовами. Нижче наведено посилання на неї.',
  acknowledgedPersonalAlarm:
    'Ви позначили тривогу "Виконано" {{durationString}} років тому.',
  skippedPersonalAlarm: 'Ви пропустили будильник {{durationString}} тому.',
  authenticatingWithServer: "З'єднання...",
  selectParticipantsForPersonalAlarm:
    'Виберіть групу або групу людей, які будуть дублювати ваш персональний будильник.',
  selectParticipantsForGroupAlarm:
    'Виберіть групу або набір людей для вашої групової діяльності.',
  acknowledgedGroupAlarm:
    'Ви {{acknowledgedAsString}} цю тривогу {{durationString}} назад.',
  acknowledgedExpiredGroupAlarm:
    'Термін дії цієї тривоги закінчився {{durationString}} тому. Ви {{acknowledgedAsString}} цю тривогу.',
  acknowledgedPersonalAlarmForParticipant:
    '{{creatorName}} позначив тривогу "Виконано" {{durationString}} тому.',
  acknowledgedExpiredPersonalAlarmForParticipant:
    'Термін дії цієї тривоги закінчився {{durationString}} років тому. {{creatorName}} позначив тривогу як "Виконано".',
  entityNotFound:
    'Упс! Нам не вдалося знайти вибраний {{entityType}}. Можливо, ми все ще шукаємо його, або він був видалений.',
  goBack: 'Повернутися',
  uploadingImageToServer: 'Завантаження зображення на сервер.',
  deletingImageFromServer: 'Видалення зображення з сервера',
  errorUploadingImageToServer:
    'Помилка завантаження зображення на сервер. Будь ласка, повторіть спробу пізніше.',
  unableToRemoveGroup: 'Не вдалося видалити групу. {{error}}',
  addingGroup: 'Додавання групи.',
  editingGroup: 'Редакційна група.',
  unableToAddGroup: 'Не вдалося додати групу. {{error}}',
  unableToEditGroup: 'Неможливо відредагувати групу. {{error}}',
  thanksForFeedback: 'Дякуємо, що допомагаєте нам вдосконалюватися.',
  licensesHeader:
    'Galarm включає програмне забезпечення, ліцензоване третіми сторонами. Будь ласка, відвідайте нашу сторінку Ліцензування третіх сторін для отримання відповідної інформації про авторство та ліцензування.',
  alarmAlreadyInSnooze: 'Ви отримаєте нагадування в {{durationString}}.',
  carrierChargesMayApply: 'Може стягуватися плата за перевезення.',
  verficationCodeInfo:
    'Ви отримаєте текстове повідомлення або телефонний дзвінок з 4-значним кодом.',
  verficationCodeInfoWhatsApp:
    'Ви отримаєте повідомлення у WhatsApp з 4-значним кодом.',
  selectCascadingInterval:
    'Перший учасник отримає сповіщення {{firstParticipantDurationString}} після часу спрацювання будильника, другий учасник отримає сповіщення {{secondParticipantDurationString}} після часу спрацювання будильника і так далі, якщо ви не позначите будильник як виконаний.',
  reorderParticipantsScreenDescription:
    'Учасники отримають сповіщення у вказаному порядку.',
  noMembers: 'Немає членів',
  selectedGroupDescription: {
    zero: '{{numActiveMembers}} учасники',
    one: '{{numActiveMembers}} активний та {{numInactiveMembers}} неактивний учасник',
    other:
      '{{numActiveMembers}} активні та {{numInactiveMembers}} неактивні учасники'
  },
  groupAlarmWillRingAtSameTime:
    'Всі учасники будуть сповіщені на сайті {{timeString}}.',
  welcomeToGalarm: 'Ласкаво просимо до Galarm',
  checkingConnection: "Перевірка з'єднання",
  deletePastAlarmsTitle: 'Видалити неактивні тривоги, старіші за',
  deletePastAlarmsOption: {
    zero: '{{option}} (0 тривог)',
    one: '{{option}} (1 тривога)',
    other: '{{option}} ({{count}} alarms)'
  },
  deletePastAlarmsNotificationMessage:
    'У вас є кілька неактивних будильників. Будь ласка, видаліть ті будильники, які вам більше не потрібні.',
  chooseSnoozeInterval: 'Нагадайте мені про це в',
  personalAlarmDescription:
    'Використовуйте персональний будильник, щоб прокинутися, прийняти ліки або виконати будь-яке інше завдання. За бажанням ви можете додати учасників, які отримуватимуть сповіщення, якщо ви пропустите будильник, щоб вони могли нагадати вам про це. Учасники також отримують сповіщення, коли ви позначаєте будильник як виконаний.',
  groupAlarmDescription:
    'Використовуйте груповий будильник для групових заходів, таких як прогулянки, вечірки або будь-які інші події. Сигнал спрацьовує одночасно для всіх учасників, і вони можуть підтвердити свою участь.',
  instantAlarmDescription:
    'Використовуйте цей будильник, щоб попередити контакт або групу контактів про навчальну тривогу, початок гри, термінове завдання/зустріч та інші події, які потребують негайної уваги.',
  recipientAlarmDescription:
    'Створюйте будильники для когось іншого ("приятеля"), щоб нагадувати йому про справи, які потрібно зробити. Ви отримаєте сповіщення, щоб нагадати приятелю, якщо він пропустить будильник. Ви також отримаєте сповіщення, коли приятель позначить будильник як виконаний.\n  \nЗверніть увагу, що будильники створюються у вашому часовому поясі.',
  whatsThis: 'Що це?',
  alarmCurrentlyDisabled: 'Наразі цей сигнал тривоги вимкнено',
  alarmCurrentlyRejected: 'Наразі цей сигнал тривоги відхилено',
  currentlyTypingUsers: {
    one: '{{currentlyTypingUsers}} друкує...',
    other: '{{currentlyTypingUsers}} друкують...'
  },
  noSearchResultsFound: 'Не знайдено жодного {{type}} ',
  noGroupsCreated: 'Ви не створили жодної групи.',
  noGroupsWeb: {
    one: 'Ви не створили жодної групи.',
    other:
      'Будь ласка, зареєструйтесь у мобільному додатку, щоб почати створювати групи та додавати їх до тривог.'
  },
  internalErrorDuringRegistration:
    'Під час реєстрації користувача сталася внутрішня помилка. Будь ласка, спробуйте ще раз через кілька хвилин',
  selectRecipientAlarmInterval: {
    zero: 'Ви отримаєте сповіщення одночасно з одержувачем',
    one: 'Ви отримаєте сповіщення {{durationString}} після закінчення часу тривоги, якщо одержувач не позначить тривогу як "Виконано".',
    other:
      'Ви отримаєте сповіщення {{durationString}} після закінчення часу тривоги, якщо одержувач не позначить тривогу як "Виконано".'
  },
  selectRecipient: 'Виберіть одержувача',
  acknowledgedExpiredRecipientAlarm:
    'Термін дії цього тривожного сигналу закінчився {{durationString}} років тому. Ви позначили цей тривожний сигнал як "Виконано".',
  skippedExpiredRecipientAlarm:
    'Термін дії будильника закінчився {{durationString}} тому. Ви пропустили цей сигнал тривоги.',
  expiredRecipientAlarm:
    'Термін дії цієї тривоги закінчився {{durationString}} тому. Натисніть "Готово", щоб завершити тривогу та повідомити {{creatorName}}.',
  acknowledgedRecipientAlarm:
    'Ви позначили цю тривогу як "Виконано" {{durationString}} років тому.',
  skippedRecipientAlarm: 'Ви пропустили цей сигнал {{durationString}} тому.',
  acknowledgedExpiredRecipientAlarmForCreator:
    'Термін дії цієї тривоги закінчився {{durationString}} років тому. {{recipientName}} позначив тривогу як "Виконано".',
  skippedExpiredRecipientAlarmForCreator:
    'Термін дії цієї тривоги закінчився {{durationString}} тому. {{recipientName}} пропустив тривогу.',
  expiredRecipientAlarmForCreator:
    'Термін дії цієї тривоги закінчився {{durationString}} років тому. Будь ласка, нагадайте {{recipientName}}.',
  acknowledgedRecipientAlarmForCreator:
    '{{recipientName}} позначив тривогу "Виконано" {{durationString}} тому.',
  selectRecipientForRecipientAlarm: 'Виберіть одержувача тривоги',
  selectAtLeastOneParticipantForGroupAlarm:
    'Додайте принаймні одного учасника до тривоги',
  addAtLeastOneMemberToGroup: 'Додайте принаймні одного учасника до групи',
  atTheSameTime: 'У той же час',
  myself: 'Я сам.',
  group: 'Група',
  someoneElse: 'Хтось інший.',
  participantsAreNotified: 'Учасники отримують сповіщення.',
  creatorIsNotified: '{{creatorName}} буде повідомлено.',
  membersAddedToGroup: {
    one: '{{memberNames}} додано до групи {{groupName}}.',
    other: '{{memberNames}} додаються до групи {{groupName}}.'
  },
  memberRemovedFromGroup:
    '{{memberName}} видалено з групи {{groupName}}, що могло вплинути на деякі з ваших тривог.',
  youRemovedFromGroup:
    'Вас видалено з групи {{groupName}}, що могло вплинути на деякі з ваших тривог.',
  memberLeftGroup:
    '{{memberName}} ліва група {{groupName}}, яка могла вплинути на деякі з ваших тривог.',
  youLeftGroup:
    'Ви вийшли з групи {{groupName}}, що могло вплинути на деякі з ваших тривог.',
  groupLeft: 'Ви вийшли з групи {{groupName}}.',
  memberMovedToADifferentTimezone:
    '{{memberName}} переїхали в інший часовий пояс, що могло вплинути на деякі з ваших будильників.',
  memberDstChanged: {
    zero: '{{memberName}} перестали дотримуватися переходу на літній час. Відповідні оповіщення були оновлені.',
    one: '{{memberName}} перейшли на літній час. Відповідні сповіщення були оновлені.'
  },
  impactedAlarms: 'Порушена сигналізація:',
  alwaysRingParticipantAlarmsOn:
    'Будильники від інших людей дзвонитимуть, якщо ви їх не відхилите.',
  alwaysRingParticipantAlarmsOff:
    'Сигнали від інших не дзвонитимуть, якщо ви їх не приймете.',
  agreeToTermsOfServiceAndPrivacyPolicy:
    'Продовжуючи, ви приймаєте Умови надання послуг та Політику конфіденційності Galarm.',
  deleteAccountWarningHeader:
    'Попередження: Ця дія є незворотною. Видалення вашого облікового запису буде:',
  deleteAccountDeleteAlarms: '- Видаліть усі створені вами тривоги',
  deleteAccountDeleteRecipientAlarms:
    '- Видалити всі тривоги друзів, в яких ви є одержувачем',
  deleteAccountRemoveFromGroups: '- Видалити вас з усіх груп',
  cancelSubscriptionWarning:
    'У вас є активна преміум-підписка. Видалення вашого облікового запису не скасує її автоматично. Будь ласка, скасуйте підписку, щоб уникнути майбутніх стягнень.',
  deleteAccountWarningFooter: {
    zero: 'Якщо ви змінюєте телефон, ви можете просто встановити додаток на новий телефон і зареєструватися, використовуючи той самий номер. Ви можете видалити додаток на цьому телефоні.\n\nПісля видалення облікового запису ви не зможете його відновити.',
    one: 'Якщо ви змінюєте телефон, ви можете просто встановити додаток на новий телефон і зареєструватися, використовуючи той самий номер. Ви можете видалити додаток на цьому телефоні.\n\nПісля видалення облікового запису ви не зможете його відновити. Ви можете керувати своєю активною підпискою на послуги Galarm в Play Store.',
    other:
      'Якщо ви змінюєте телефон, ви можете просто встановити програму на новий телефон і видалити програму на цьому телефоні.\n\nПісля видалення облікового запису ви не зможете його відновити. Ви можете керувати своєю активною підпискою на Galarm в App Store.'
  },
  typeConfirmationStringToDeleteAccount:
    'Введіть {{confirmationString}}, щоб видалити свій обліковий запис',
  unableToDeleteAccount: 'Не вдалося видалити обліковий запис. {{error}}',
  impactedGroups: 'Постраждалі групи:',
  memberDeletedAccount:
    '{{memberName}} видалив свій обліковий запис, що могло вплинути на деякі з ваших тривог та груп.',
  confirmCountryCodeAndEnterNumber:
    'Будь ласка, підтвердіть код вашої країни та введіть номер телефону.',
  confirmCountryCodeAndEnterNumberForExistingUser:
    'Будь ласка, підтвердіть код вашої країни та введіть номер телефону, який ви використовували під час попередньої реєстрації.',
  requiredPermissionsDisabledWarningIos:
    'Сповіщення вимкнено. Будильники не дзвонять. Торкніться, щоб виправити.',
  requiredPermissionsDisabledWarningAndroid:
    'Galarm не має необхідних дозволів для надсилання тривог. Натисніть, щоб виправити.',
  notificationChannelPopupDisabledWarningAndroid:
    "Сповіщення про тривоги не з'являються на екрані. Торкніться, щоб виправити.",
  alarmLockScreenNotificationDisabledWarningAndroid:
    "Сповіщення про тривоги не з'являються на екрані блокування. Торкніться, щоб виправити.",
  contactPermissionNotGranted:
    'Galarm не має дозволу на доступ до ваших контактів. Нові контакти, додані до адресної книги телефону, не синхронізуються з Galarm. Торкніться, щоб виправити.',
  why: 'Чому',
  how: 'Як',
  registrationRequired: 'Потрібна реєстрація',
  phoneNumberRequired: 'Потрібен номер телефону',
  fewSeconds: 'Кілька секунд.',
  lessThanMinute: 'менше хвилини',
  updateUnsupportedVersion:
    'Для продовження використання Galarm потрібна оновлена версія програми.',
  update: 'Оновлення',
  back: 'Назад',
  unableToMarkAlarmDone:
    'Не вдалося позначити будильник як виконаний на даний момент. Будь ласка, спробуйте ще раз за кілька хвилин.',
  unableToMarkAlarmUndone:
    'Не вдасться позначити будильник як скасований. Будь ласка, спробуйте ще раз за кілька хвилин.',
  unableToMarkAlarmUnskipped:
    'Не вдасться позначити будильник як непропущений. Будь ласка, спробуйте ще раз за кілька хвилин.',
  unableToSkipAlarm:
    'Неможливо пропустити будильник у цей час. Будь ласка, спробуйте ще раз за кілька хвилин.',
  unableToSetGroupAlarmResponse:
    'Неможливо {{response}} тривогу групи в цей час. Будь ласка, спробуйте ще раз через кілька хвилин.',
  unableToDeleteAlarm:
    'Неможливо видалити будильник зараз. Будь ласка, спробуйте ще раз за кілька хвилин.',
  unableToSetAlarmResponse:
    'Наразі не вдасться встановити відповідь. Будь ласка, спробуйте ще раз через кілька хвилин.',
  unableToSnoozeAlarm: 'Неможливо перевести будильник у режим повтору.',
  unableToStopSnoozeForAlarm: 'Неможливо зупинити дрімоту за будильником.',
  unableToUpdateParticipantAlarmRingerSettings:
    'Неможливо оновити налаштування дзвінка. Будь ласка, спробуйте ще раз через кілька хвилин.',
  updateParticipantPreReminderDuration:
    'Наразі неможливо оновити тривалість попереднього нагадування. Будь ласка, спробуйте ще раз за кілька хвилин.',
  unableToUpdateAlarmRingerSettings:
    'Не вдалося оновити налаштування дзвінка. Будь ласка, спробуйте ще раз через кілька хвилин.',
  unableToUpdateAlarmPreReminderDuration:
    'Наразі неможливо оновити термін дії попереднього нагадування. Будь ласка, спробуйте ще раз через кілька хвилин.',
  retrievingAlarmsFromServer: 'Отримання тривог з сервера...',
  startApp: 'Пуск >',
  phoneNumberRequiredGroupListHeaderText:
    'Група - це колекція контактів Galarm, що дозволяє швидко створювати за ними тривоги.\n\nБудь ласка, зареєструйтесь, використовуючи свій номер телефону, щоб знайти контакти, які користуються Galarm. Ви можете додавати їх до груп.',
  phoneNumberRequiredBuddyAlarmHeaderText:
    'Buddy Alarm можна використовувати для встановлення будильників для друзів і близьких, щоб нагадувати їм про те, що їм потрібно зробити.\n\nЩоб скористатися цією та багатьма іншими цікавими функціями додатку, будь ласка, зареєструйтеся, вказавши свій номер телефону.',
  phoneNumberRequiredInstantAlarmHeaderText: `Миттєві сповіщення можна використовувати для негайного сповіщення контакту або групи в разі надзвичайних ситуацій або деяких термінових завдань.

Щоб використовувати цю та багато інших чудовових функцій додатку, будь ласка, зареєструйтесь за допомогою свого номера телефону.`,
  phoneNumberRequiredContactListHeaderText:
    'Контакти - це люди, яких можна додати як учасників тривог.\n\nБудь ласка, зареєструйтесь, використовуючи свій номер телефону, щоб переглянути контакти, які користуються Galarm. Ви можете додати їх як учасників ваших тривог.',
  phoneNumberRequiredGroupAlarmHeaderText:
    'Груповий будильник можна використовувати для встановлення нагадування для групи людей.\n\nЩоб скористатися цією та багатьма іншими крутими функціями додатку, будь ласка, зареєструйтеся, вказавши свій номер телефону.',
  phoneNumberRequiredParticipantsHeaderText:
    'Учасники діють як резервні копії цього будильника. Вони отримують нагадування, якщо ви пропустите тривогу.\n\nЩоб користуватися цією та багатьма іншими крутими функціями додатку, будь ласка, зареєструйтеся, вказавши свій номер телефону.',
  youHaveNotRegistered:
    'Наразі ваші тривоги не мають резервної копії.\n\nБудь ласка, зареєструйтеся, використовуючи свій номер телефону. Після реєстрації ваші будильники будуть збережені в хмарі. Це дозволить вам відновити будильники та інші налаштування в разі зміни телефону.\n',
  registerNow: 'Зареєструйтесь зараз',
  hoursAndMinutes: 'Години та хвилини',
  days: 'Дні',
  weeks: 'Тижні',
  months: 'Місяці',
  years: 'Роки',
  daysOfWeek: 'Щотижня (у вибрані дні)',
  monthly: 'Щомісяця',
  yearly: 'Щорічно',
  everyDay: 'Щодня',
  selectDaysOfWeek: 'Виберіть дні тижня',
  alarmRingMessageForSpecificDates:
    'Будильник спрацьовує лише в місяцях, які мають щонайменше {{dayOfMonth}} днів. Ви хочете продовжити?',
  alarmRingMessageForSpecificYear:
    'Цей будильник дзвонитиме лише у високосні роки. Хочете продовжити?',
  alarmRingMessageForSpecificDayOfWeekInMonth:
    'Цей будильник спрацьовує лише в місяці, які мають {{weekNumberOfDayInMonth}} {{dayName}} с. Хочете продовжити? ',
  alarmRepetitionAdjustedBasedOnNewDate:
    'Повторення будильника оновлено відповідно до нової дати.',
  inviteFriendsToInstallGalarm:
    'Контакти — це люди, яких можна додати як учасників до ваших будильників. Ви можете запросити контакти:\n\n1. З вашої адресної книги.\n\n2. Ввівши їхні імена та номери вручну.\n\nНатисніть «Оновити» у правому верхньому куті, щоб перезавантажити контакти Galarm після їх реєстрації.',
  whyCreateNewGroup:
    'Групи - це колекція контактів, які можна додавати як учасників ваших будильників.\n  \nВи не створили жодної групи.',
  noNotifications: 'У вас немає нових сповіщень.',
  createGroup: 'Створити групу',
  galarmRequiresAccessToContactsPermission:
    'Galarm запитує дозвіл на доступ до ваших контактів. Ця інформація надсилається на його сервери для ідентифікації ваших контактів за допомогою Galarm. Ці користувачі можуть бути додані як учасники ваших тривог.',
  galarmRequiresAccessToAudioFilesPermission:
    'Деякі будильники використовують музику телефону як мелодію дзвінка. Будь ласка, надайте дозвіл на доступ до аудіофайлів на вашому пристрої, щоб дзвонити на ці будильники вибраною мелодією.',
  galarmRequiresAccessToContactsSelectScreen:
    'Galarm не має дозволу на доступ до контактів. Будь ласка, дозвольте доступ до контактів, якщо ви хочете використовувати цю функцію.',
  allow: 'Дозвольте',
  deny: 'Відхилити',
  galarmRequiresAccessToContacts:
    'Контакти - це люди, яких можна додати як учасників ваших тривог. Ви можете додавати контакти за:\n\n1. Автоматично імпортуючи контакти з телефону. Натисніть "Дозволити доступ" і увімкніть "Контакти".\n\n2. Вручну додавання імені та номера контакту. Натисніть "Додати контакт", щоб почати.',
  galarmRequiresAccessToAlarmAndRemindersPermission:
    'Galarm потребує дозволу "Будильники та нагадування", щоб він міг дзвонити точно у визначений час. Будь ласка, увімкніть його на наступному екрані.',
  accessToContactsPermissionRequiredAndroid:
    'Galarm не має дозволу на доступ до ваших телефонних контактів.\n\nКоли ви дозволите доступ, люди у ваших телефонних контактах, які використовують Galarm, з\'являться як контакти Galarm. Цих людей можна буде додати як учасників тривоги. Натисніть "Дозволити доступ", виберіть "Дозвіл" і увімкніть "Контакти".\n\nВи все ще можете додавати контакти до Galarm вручну.',
  accessToContactsPermissionRequiredIos:
    'Galarm не має дозволу на доступ до ваших телефонних контактів.\n\nКоли ви дозволите доступ, люди у ваших телефонних контактах, які використовують Galarm, з\'являться як контакти Galarm. Цих людей можна буде додати як учасників тривоги. Натисніть "Дозволити доступ" і увімкніть "Контакти".\n\nВи все ще можете додавати контакти до Galarm вручну.',
  giveAccess: 'Дозволити доступ',
  enterValidMobileNumber:
    'Будь ласка, введіть дійсний номер телефону для реєстрації.',
  proceedAnyway: 'Все одно продовжуйте.',
  checkInvalidPhoneNumber:
    'Ми вважаємо, що ви ввели невірний номер {{mobileNumber}}.',
  checkInvalidCountryCode:
    'Невірний код країни, вказаний як {{countryCode}}. Якщо вказано більше одного коду країни, відредагуйте поле, щоб зберегти відповідний код країни.',
  editNumber: 'Номер редагування',
  editCountryCode: 'Редагувати код країни',
  sendingCodeOnCall: 'Дзвоню тобі з кодом.',
  sendCodeOnCall: 'Зателефонуй мені з кодом',
  sendCodeOnSms: 'Надіслати код за допомогою SMS',
  sendCodeOnWhatsApp: 'Надіслати код через WhatsApp',
  registrationLandingScreenRegisterText:
    "Натисніть Продовжити, щоб зареєструватися, використовуючи свій номер телефону.\n\nЗареєструвавшись:\n1) Ви зможете додавати учасників до своїх будильників і спілкуватися з ними в чаті.\n2) Ваші будильники будуть збережені в хмарі, тож коли ви зміните телефон, ваші будильники з'являться на новому телефоні.",
  continue: 'Продовжуйте',
  registerLater: 'Пропустити реєстрацію',
  cancelRegistration: 'Скасувати реєстрацію',
  welcome: 'Ласкаво просимо.',
  haventReceivedCodeYet: {
    one: 'Ще не отримали код? Ви можете запросити код повторно через 1 секунду.',
    other:
      'Ще не отримали код? Ви можете запросити код повторно через {{count}} секунд.'
  },
  storagePermissionDenied:
    'Неможливо отримати доступ до музичних файлів, оскільки заборонено доступ до сховища.',
  havingTroubleRegisteringMessage:
    'Galarm не може підтвердити код після декількох спроб.\n\nХочете пропустити реєстрацію і почати користуватися додатком?',
  autoDetectVerificationCode:
    'Щоб спростити реєстрацію, Galarm може автоматично визначити код підтвердження, якщо ви дозволите Galarm переглядати SMS-повідомлення.',
  notNow: 'Не зараз.',
  verifyNumberText:
    'Ми надішлемо SMS з кодом підтвердження на номер:\n\n{{formattedMobileNumber}}',
  verifyNumberWhatsApp:
    'Ми надішлемо повідомлення у WhatsApp з кодом підтвердження на адресу:\n\n{{formattedMobileNumber}}',
  verifyNumberCall:
    'Ви отримаєте телефонний дзвінок з кодом підтвердження за адресою:\n\n{{formattedMobileNumber}}',
  addToContacts: 'Додати в контакти',
  todayString: 'Сьогодні',
  tomorrowString: 'Завтра',
  backups: 'Резервні копії',
  acintyoTrademark:
    '© 2026 Acintyo, Inc. Всі права захищені.\nGalarm є зареєстрованою торговою маркою Acintyo, Inc.\nЗахищено патентами США 10382613, 10867286.\nІнші патенти знаходяться на розгляді.',
  acintyoTrademarkWeb:
    '© 2026 Acintyo, Inc. Всі права захищені. Galarm є зареєстрованою торговою маркою Acintyo, Inc.\nЗахищено патентами США № 10382613, 10867286. Інші патенти знаходяться на стадії розгляду.',
  acintyoTrademarkEnterprise: '© 2026 Acintyo, Inc.\nВсі права захищені.',
  markAlarmDone: 'Позначити тривогу як виконану',
  skipAlarm: 'Пропустити тривогу',
  confirmGroupAlarm: 'Підтвердити участь',
  declineGroupAlarm: 'Відмовитися від участі',
  snoozeAlarm: 'Будильник-сон',
  deleteAlarmQuickAction: 'Видалити тривогу',
  disableAlarm: 'Вимкнути будильник',
  confirmDisableAlarm: 'Вимкнути будильник?',
  saveToCalendar: 'Експорт до календаря',
  stillRingGroupAlarmAfterConfirmingInAdvance:
    'Ви заздалегідь підтверджуєте груповий сигнал тривоги.  Ви все ще хочете отримати нагадування під час тривоги?',
  updateNow: 'Оновити зараз',
  nParticipants: {
    one: '1 інший учасник',
    other: '{{count}} інші учасники'
  },
  details: 'Деталі',
  changeParanthesis: '(зміна)',
  loadMoreHistory: 'Переглянути більше',
  alarmSummaryForHistory:
    'Минулі відповіді для {{alarmName}}.\nПовтори {{alarmRepetitionString}}\n{{previousOccurrencesString}}',
  alarmSummaryForHistoryWeb: 'Попередні відповіді для {{alarmName}}',
  alarmSummaryForHistoryRepetitionWeb: 'Повтори {{alarmRepetitionString}}',
  dontSeeCompleteHistory: 'Не бачите повну історію?',
  dontSeeCompleteHistoryExplanation:
    'Історія тривог записується з моменту створення тривоги. Ми зберігаємо лише обмежену історію для кожної тривоги залежно від частоти повторення тривоги. Наприклад, якщо тривога повторюється щодня, ми зберігаємо історію за 30 днів.\n\nЗміна часу тривоги або її повторення обнуляє історію тривог.',
  noActionAvailableForAlarmOccurrence:
    'Для цього випадку не передбачено жодних дій.',
  enterEmailIdForFeedback:
    'Використовується для реагування та обміну оновленнями',
  noPreviousOccurrences: 'Історії тривог ще немає',
  nMissedOccurrencesOfAlarmInLastNDays: {
    zero: 'Історії тривог ще немає',
    one: '{{missedAlarmOccurrences}} пропущено з останнього {{count}}',
    other: '{{missedAlarmOccurrences}} пропущено з останнього {{count}}'
  },
  soundAndVibrationSummaryString: {
    zero: "{{volume}}% об'єму, {{ringtoneName}}",
    one: "{{volume}}% об'єму, {{ringtoneName}}, Анонсувати назву"
  },
  soundAndVibrationSummaryStringIos: {
    zero: '{{ringtoneName}}',
    one: "Критичний, {{volume}}% об'єму, {{ringtoneName}}"
  },
  previousOccurrences: 'Історія тривог',
  retrieving: 'Відновлення...',
  startTimeOfDay: 'Початок о',
  endTimeOfDay: 'Закінчується на',
  ringEveryHours: 'Дзвонить кожен',
  everyNHours: 'Щогодини',
  everyMHoursNMinutes: 'Години та хвилини',
  selectHourlyRepetition: 'Виберіть щогодинний повтор',
  everyNHoursRepetitionString: {
    one: 'Щогодини з {{startTimeString}} до {{endTimeString}} щогодини {{daysString}}',
    other:
      'Кожні {{count}} години з {{startTimeString}} по {{endTimeString}} кожні {{daysString}}'
  },
  everyNHoursAndMinutesRepetitionString:
    'Кожен {{hoursAndMinutes}} з {{startTimeString}} по {{endTimeString}} кожен {{daysString}}',
  everyMHoursAndNMinutesRepetitionString: 'Кожен {{repeatString}}',
  everyNHoursRepetitionStringForCalendar: {
    one: 'Щогодини з {{startTimeString}} до {{endTimeString}}',
    other: 'Кожні {{count}} години з {{startTimeString}} до {{endTimeString}}'
  },
  everyNHoursAndMinutesRepetitionStringForCalendar:
    'Кожен {{hoursAndMinutes}} від {{startTimeString}} до {{endTimeString}}',
  everyNHoursAndMinutesRepetitionStringForAlarmSummary:
    'Кожного {{hoursAndMinutes}} до {{endTimeString}}',
  everyNHoursRepetitionStringForAlarmSummary: {
    one: 'Щогодини до {{endTimeString}}',
    other: 'Кожні {{count}} години до {{endTimeString}}'
  },
  daysRepetitionOddString: {
    other: 'Всі непарні дати',
    one: 'Непарні дати ({{daysString}})'
  },
  daysRepetitionEvenString: {
    other: 'Всі парні дати',
    one: 'Парні дати ({{daysString}})'
  },
  oddNumberedRepetitionPreviewString: {
    one: 'Будильник дзвонитиме по непарних числах, які потрапляють на {{daysString}} у вказаний час.',
    other: 'Будильник дзвонитиме в усі непарні дні у вказаний час.'
  },
  evenNumberedRepetitionPreviewString: {
    one: 'Будильник дзвонитиме по парних числах, які припадають на {{daysString}} у вказаний час.',
    other: 'Будильник дзвонитиме по парних числах у вказаний час.'
  },
  hourlyRepetitionPreviewString: {
    one: 'Будильник дзвонитиме один раз на {{daysString}}:',
    other: 'Будильник дзвонитиме {{count}} разів кожну {{daysString}} годину:'
  },
  daysRepetitionPreviewString: {
    one: 'Цей будильник дзвонитиме щодня.',
    other: 'Будильник дзвонитиме кожні {{count}} днів.'
  },
  weeksRepetitionPreviewString: {
    one: 'Сигнал тривоги буде лунати щотижня в програмі «{{daysString}}».',
    other:
      'Сигнал тривоги буде лунати кожні {{count}} тижнів на {{daysString}}.'
  },
  weeksRepetitionPreviewStringEveryDay: {
    one: 'Будильник буде дзвонити щодня.',
    other: 'Сигнал тривоги буде звучати щодня кожні {{count}} тижнів.'
  },
  specifyNumberOfWeeksAndChooseDays:
    'Вкажіть кількість тижнів і виберіть дні для повторення.',
  everyNDays: {
    one: 'Щодня',
    other: 'Кожні {{count}} днів'
  },
  everyNWeeks: {
    one: 'Щотижня {{daysString}}',
    other: 'Кожні {{count}} тижнів {{daysString}}'
  },
  everyNMonths: {
    one: 'Щомісяця',
    other: 'Кожні {{count}} місяців'
  },
  everyNYears: {
    one: 'Щороку',
    other: 'Кожні {{count}} років'
  },
  cantSetEndTime: 'Неможливо встановити час завершення',
  endTimeShouldBeGreater: 'Час закінчення має бути більшим за час початку.',
  cantSetStartTime: 'Не вдається встановити час запуску',
  startTimeShouldBeLess: 'Час початку має бути меншим за час закінчення.',
  everyDaySmall: 'день',
  everyGivenDay: '{{day}}',
  everyGivenDays: '{{days}}',
  adjustingAlarmsAfterTimezoneChange:
    'Ми виявили, що ви переїхали до іншого часового поясу. Ми налаштовуємо ваші будильники.',
  ringOnDays: 'Дзвонить',
  yourAlarmsMayNotRing: 'Ваші будильники можуть не спрацьовувати',
  yourAlarmsMayNotRingTapToFix:
    'Ваші будильники можуть не спрацьовувати. Торкніться, щоб виправити.',
  unsyncedAlarmsWarning:
    'Деякі будильники не були синхронізовані з сервером. Підключіться до інтернету та натисніть, щоб зберегти їх зараз.',
  pendingActionFailed:
    'Зміна будильника ({{actionName}}) не вдалося зберегти після кількох спроб і вона була відхилена. Будь ласка, перевірте свої будильники або зверніться до служби підтримки, якщо дані здаються відсутніми.',
  pendingActionFailedWithRef:
    'Зміна будильника ({{actionName}}) не вдалося зберегти після кількох спроб і вона була відхилена. Ідентифікатор посилання: {{referenceId}}. Зверніться до служби підтримки з цим ідентифікатором, щоб допомогти відновити його.',
  xiaomiSetupInstructions:
    'Дотримуйтесь цих інструкцій, щоб ваші будильники завжди спрацьовували:\n\n - Натисніть "Увімкнути автозапуск" та увімкніть "Будильник", щоб ваші будильники завжди дзвонили. \n\nЩоб дізнатися більше, відвідайте www.galarmapp.com/setup-mi',
  oppoSetupInstructions:
    'Дотримуйтесь цих інструкцій, щоб ваші будильники завжди спрацьовували:\n\n - Торкніться "Увімкнути автозапуск" та увімкніть "Дозволити автозапуск".\n\n - Натисніть кнопку "Останні програми" на телефоні, проведіть пальцем по іконці програми Galarm вниз і натисніть "Заблокувати".  \n\nЩоб дізнатися більше, відвідайте www.galarmapp.com/setup-oppo',
  oppo8AndLowerSetupInstructions:
    'Дотримуйтесь цих інструкцій, щоб ваші будильники завжди спрацьовували:\n\n - Торкніться "Увімкнути автозапуск" та увімкніть "Дозволити автозапуск".\n\n - Натисніть кнопку "Останні програми" на телефоні, проведіть пальцем по іконці програми Galarm вниз і натисніть "Заблокувати".\n\nЩоб дізнатися більше, відвідайте www.galarmapp.com/setup-oppo-8-and-lower',
  vivo9And10SetupInstructions:
    'Дотримуйтесь цих інструкцій, щоб ваші будильники завжди спрацьовували:\n\n - Натисніть "Увімкнути автозапуск" та увімкніть "Будильник".\n\n - Торкніться "Використання батареї", виберіть "Високе фонове енергоспоживання" і дозвольте "Будильник".\n\nЩоб дізнатися більше, відвідайте www.galarmapp.com/setup-vivo',
  vivo11SetupInstructions:
    'Дотримуйтесь цих інструкцій, щоб ваші будильники завжди спрацьовували:\n\n- Натисніть "Увімкнути автозапуск" та увімкніть "Будильник".\n\n- Торкніться "Використання батареї", виберіть "Високе фонове енергоспоживання" і дозвольте "Будильник".\n\nЩоб дізнатися більше, відвідайте www.galarmapp.com/setup-vivo-11',
  vivoSetupInstructions:
    'Дотримуйтесь цих інструкцій, щоб будильник завжди спрацьовував:\n\n- Відкрийте "Налаштування телефону > Програми > Спеціальний доступ до програм > Автозапуск" та увімкніть автозапуск для Galarm.\n\n- Відкрийте "Налаштування телефону > Акумулятор > Керування фоновим енергоспоживанням > Galarm" і виберіть "Не обмежувати фонове енергоспоживання".\n\nЩоб дізнатися більше, відвідайте www.galarmapp.com/setup-vivo-12-and-above',
  vivo8AndLowerSetupInstructions:
    'Дотримуйтесь цих інструкцій, щоб будильник завжди спрацьовував:\n\n - Натисніть "Увімкнути автозапуск" та увімкніть "Будильник".\n\n - Торкніться "Використання батареї", виберіть "Високе фонове енергоспоживання" і дозвольте "Будильник".\n\nЩоб дізнатися більше, відвідайте www.galarmapp.com/setup-vivo-8-and-lower',
  huawei7AndLowerAdditionalSetupInstructions:
    'Дотримуйтесь цих інструкцій, щоб ваші будильники завжди спрацьовували:\n\n - Торкніться "Захищені програми" та увімкніть "Будильник".\n\nЩоб дізнатися більше, відвідайте www.galarmapp.com/setup-huawei-7-and-lower',
  huaweiAdditionalSetupInstructions:
    'Дотримуйтесь цих інструкцій, щоб ваші будильники завжди спрацьовували:\n\n - Торкніться "Керування запуском програм" і вимкніть "Будильник" на "Керувати вручну". У вікні, що з\'явиться, переконайтеся, що "Автозапуск" і "Працювати у фоновому режимі" увімкнено.\n\nЩоб дізнатися більше, відвідайте www.galarmapp.com/setup-huawei',
  meizuSetupInstructions:
    'Дотримуйтесь інструкцій за посиланням нижче, щоб ваші будильники завжди спрацьовували: https://dontkillmyapp.com/meizu',
  asusSetupInstructions:
    'Дотримуйтесь цих інструкцій, щоб ваші будильники завжди спрацьовували:\n\n - Торкніться "Увімкнути автозапуск" і натисніть "Менеджер автозапуску". Увімкніть "Будильник" в "Менеджері автозапуску".\n\nЩоб дізнатися більше, відвідайте www.galarmapp.com/setup-asus',
  nokia8AndLowerAdditionalSetupInstructions:
    'Дотримуйтесь цих інструкцій, щоб ваші будильники завжди спрацьовували:\n\n - Натисніть "Увімкнути автозапуск" та увімкніть "Будильник".\n\nЩоб дізнатися більше, відвідайте www.galarmapp.com/setup-nokia-8-and-lower',
  nokiaAdditionalSetupInstructions:
    'Дотримуйтесь цих інструкцій, щоб ваші будильники завжди спрацьовували:\n\n - Торкніться "Обмежені програми" і вимкніть "Будильник".\n\nЩоб дізнатися більше, відвідайте www.galarmapp.com/setup-nokia',
  lenovoSetupInstructions:
    'Дотримуйтесь цих інструкцій, щоб ваші будильники завжди спрацьовували:\n\n - Натисніть кнопку "Останні додатки" на телефоні, знайдіть додаток Galarm і натисніть на іконку "Блокування" у верхньому правому куті.\n  \nЩоб дізнатися більше, відвідайте https://dontkillmyapp.com/lenovo',
  samsungAdditionalSetupInstructions:
    'Дотримуйтесь цих інструкцій, щоб ваші будильники завжди спрацьовували:\n\n - Торкніться "Невідстежувані програми" і дозвольте "Галамарм".\n\nЩоб дізнатися більше, відвідайте www.galarmapp.com/setup-samsung',
  tecnoSetupInstructions:
    'Дотримуйтесь інструкцій за посиланням нижче, щоб ваші будильники завжди спрацьовували: https://www.galarmapp.com/setup-tecno',
  infinixSetupInstructions:
    'Дотримуйтесь інструкцій за посиланням нижче, щоб ваші будильники завжди спрацьовували: https://www.galarmapp.com/setup-infinix',
  samsungAdditionalSetupInstructionsAndroid11AndAbove:
    'За замовчуванням Samsung показує "Короткі" сповіщення, які швидко зникають. Дотримуйтесь цих інструкцій, щоб переглянути "Докладні" сповіщення про тривоги.\n\n - Відкрийте налаштування телефону і виберіть "Сповіщення"\n - Виберіть стиль сповіщень "Докладні"\n  \nЩоб дізнатися більше, відвідайте www.galarmapp.com/setup-samsung-android11-and-above',
  iosSetupInstructions:
    'За замовчуванням стиль банера для сповіщень в iOS встановлено на "Тимчасовий", що призводить до швидкого зникнення сповіщень. Дотримуйтесь цих інструкцій, щоб встановити стиль банера "Постійний".\n\n- Відкрийте налаштування телефону і перейдіть до Galarm\n- Виберіть Сповіщення та встановіть стиль банера на "Постійний\n\nЩоб дізнатися більше, відвідайте www.galarmapp.com/setup-ios',
  iosSetupInstructions15AndBelow:
    'За замовчуванням стиль банера для сповіщень в iOS встановлено на "Тимчасовий", що призводить до швидкого зникнення сповіщень. Дотримуйтесь цих інструкцій, щоб встановити стиль банера "Постійний".\n\n- Відкрийте налаштування телефону і перейдіть до Galarm\n- Виберіть Сповіщення та встановіть стиль банера на "Постійний\n\nЩоб дізнатися більше, відвідайте www.galarmapp.com/setup-ios-15-below',
  setNotificationsStyle: 'Налаштування стилю сповіщень',
  setNotificationsStyleToDetailed: 'Встановіть стиль сповіщень "Детальний"',
  setBannerStyle: 'Встановити стиль банера',
  setBannerStyleToPersistent: 'Встановіть стиль банера "Постійний"',
  selectAtleastOneDay: 'Виберіть дні, в які має дзвонити будильник.',
  selectAtLeastOneHourOrMinute:
    'Години або хвилини повинні бути ненульовим значенням',
  hourlyAlarmDefaultStartTimeSetAlert:
    'Час запуску будильника встановлено на 8 ранку.',
  batteryUsage: 'Використання батареї',
  dontShowAgain: "Більше не з'являтися",
  alarmWillRingEveryHourTillSeen:
    'Будильник буде спрацьовувати щогодини, доки ви не зробите якусь дію.',
  unknown: 'Невідомо',
  alarmMarkedDone: '{{name}} позначив тривогу "Виконано".',
  alarmMarkedSkipped: '{{name}} пропустив тривогу.',
  alarmIsMarkedDone: '{{alarmName}} позначено як "виконано".',
  alarmIsSkipped: '{{alarmName}} пропускається.',
  alarmIsConfirmed: '{{alarmName}} підтверджено.',
  alarmIsDeclined: '{{alarmName}} відхилено.',
  alarmIsSnoozed: '{{alarmName}} дрімає.',
  alarmIsAccepted: '{{alarmName}} прийнято.',
  alarmIsRejected: '{{alarmName}} відкидається.',
  dismissingCalendarEvent: 'Відмова від події календаря для {{title}}',
  newContactInfo:
    'Будь ласка, вкажіть ім\'я та номер телефону контактної особи.\n\nТільки зареєстровані користувачі можуть бути додані в якості контактів. Якщо користувач не є зареєстрованим користувачем Galarm, ви можете запросити його за допомогою "Налаштування > Поділитися цим додатком". Ви можете додати його як контакт після того, як він зареєструється, використовуючи його номер телефону. ',
  cantEditContactMobileNumber:
    'Ви не можете редагувати номер телефону. Видаліть контакт і додайте його знову, якщо хочете змінити номер.',
  phoneContactsNotSyncedPermissionDenied:
    'Galarm не має дозволу на доступ до телефонних контактів. Телефонні контакти не будуть синхронізовані.',
  inviteContactMessage:
    'Привіт {{contactName}}, я хочу додати тебе до моїх будильників та нагадувань за допомогою Galarm. Завантажте додаток з {{downloadLink}}. Будь ласка, зареєструйтеся за цим номером і почніть ділитися тривогами.',
  noRepeat: 'Не повторюється',
  deepLinkNoLongerValidTitle: 'Упс!',
  deepLinkNoLongerValidMessage:
    'Тривогу не було створено. Це може бути старе або недійсне посилання.',
  inviteContact: 'Запросити контакт',
  fromPhoneBook: 'З адресної книги',
  addFromPhoneBook: 'Запросити з адресної книги',
  manually: 'Вручну.',
  addManualContact: 'Запросити вручну',
  noOtherContactsFound:
    'Всі контакти у вашій адресній книзі використовують Galarm.',
  cantAddPhoneContactPermissionDenied:
    'Galarm не має дозволу на доступ до телефонних контактів. Надайте дозвіл на доступ до контактів.',
  alarmWillRingWithRandomRingtone:
    'Для будильника буде обрано випадкову мелодію.',
  alarmWillRingWithRandomRingtoneGlobal:
    'Для будильника буде обрано випадкову мелодію.',
  createdAlarmFromDeepLinkTitle: 'Все готово!',
  createdAlarmFromDeepLinkMessage:
    'Ви отримаєте нагадування про "{{alarmName}}" на сайті {{alarmTime}} за наступними адресами {{alarmDate}}',
  createdRepeatingAlarmFromDeepLinkMessage: {
    zero: 'Вам буде надіслано нагадування про "{{alarmName}}" {{repetitionString}}',
    one: 'Ви будете отримувати нагадування про "{{alarmName}}" {{repetitionString}} на {{alarmTime}} починаючи з {{alarmDate}}'
  },
  deleteCategoryAlertTitle: 'Видалити категорію?',
  deleteCategoryAlertMessage: {
    zero: '',
    one: '1 тривога належить до цієї категорії. Видалення цієї категорії призведе до скидання категорії для цієї тривоги.',
    other:
      '{{count}} тривоги належать до цієї категорії. Видалення цієї категорії призведе до скидання категорії для цих тривог.'
  },
  updateReadyToInstallAlertTitle: 'Встановити оновлення?',
  updateReadyToInstallAlertMessage:
    'Оновлення готові до встановлення. Бажаєте встановити оновлення зараз? ',
  hideCategoryAlertTitle: 'Приховати категорію?',
  hideCategoryAlertMessage: {
    zero: 'Ви не зможете використовувати цю категорію в майбутньому.',
    one: '1 тривога належить до цієї категорії. Приховування цієї категорії призведе до скидання категорії для цієї тривоги.\n  \nВи не зможете використовувати цю категорію в майбутньому.',
    other:
      '{{count}} тривоги належать до цієї категорії. Приховування цієї категорії призведе до скидання категорії для цих тривог.\n  \nВи не зможете використовувати цю категорію в майбутньому.'
  },
  alarmCategoryDeleteAllAlarmsPrompt: {
    one: '1 тривога належить до цієї категорії. Ви хочете її видалити?\n\nЗверніть увагу, що тривоги учасників не видаляються.',
    other:
      '{{count}} тривоги належать до цієї категорії. Ви хочете їх видалити?\n\nЗверніть увагу, що тривоги учасників не видаляються.'
  },
  enterNameForGroup: 'Введіть назву групи',
  enterMobileNumber: 'Введіть свій номер телефону',
  enterNotesForAlarm: 'Введіть нотатки для тривоги',
  enterUserName: "Введіть своє ім'я",
  enterEmailId: "Необов'язково",
  enterFeedback: 'Як ми можемо покращити?',
  describeProblem: 'Опишіть вашу проблему',
  invited: 'Запрошені',
  resend: 'Повторно відправити',
  addContact: 'Додати контакт',
  inviteAgain: 'Запросити ще раз',
  contactNotRegistered:
    '{{contactName}} ще не встановили Galarm. Ви зможете додати їх до тривог, як тільки вони встановлять і зареєструються, використовуючи свій номер телефону.',
  registration: 'Реєстрація',
  verify: 'Верифікація',
  profile: 'Профіль',
  profileImage: 'Зображення профілю',
  addProfileImage: 'Додати зображення профілю',
  groupDetails: 'Інформація про групу',
  newGroup: 'Нова група',
  uploadImage: 'Змінити зображення',
  removeImage: 'Видалити зображення',
  selectParticipants: 'Відбір учасників',
  selectMembers: 'Вибрати учасників',
  selectTimezone: 'Виберіть часовий пояс',
  searchForATimezone: 'Пошук часового поясу',
  timezone: 'Часовий пояс',
  deviceTimezone: 'Часовий пояс пристрою',
  useDeviceTimezone: 'Використовувати часовий пояс пристрою',
  specifyTimezoneForAlarm: 'Вказати часовий пояс для тривог',
  defaultTimezoneForAlarm: 'Часовий пояс за замовчуванням для будильників',
  changeDefaultTimezoneForAllExistingAlarms: {
    zero: 'Ви хочете скинути часовий пояс для всіх наявних будильників?',
    one: 'Ви хочете змінити часовий пояс для всіх існуючих будильників на цей часовий пояс? Будильники дзвонитимуть у налаштований час у новому часовому поясі.'
  },
  changeDefaultRingerSettingsForAllExistingAlarms:
    'Хочете змінити налаштування звуку та вібрації для наявних будильників?\n\nЯкщо ви виберете "Так", наявні будильники будуть дзвонити з новими налаштуваннями. Якщо ви виберете "Ні", наявні будильники продовжать дзвонити зі старими налаштуваннями.',
  defaultTimezoneChangedForAllAlarms:
    'Для всіх будильників змінено часовий пояс.',
  ringerSettingsChangedForAllAlarms:
    'Змінено налаштування звуку та вібрації для існуючих будильників.',
  editName: 'Редагувати назву',
  groupImage: 'Зображення групи',
  addGroupImage: 'Додати зображення групи',
  selectAlarmType: 'Створити тривогу для',
  contactDetails: 'Контактні дані',
  commonAlarms: 'Сигнали тривоги',
  commonGroups: 'Групи',
  groupAlarmsTitle: 'Сигнали тривоги',
  selectRingtone: 'Виберіть мелодію дзвінка',
  selectMusic: 'Виберіть Музика',
  select: 'Виберіть',
  personalAlarm: 'Персональна сигналізація',
  groupAlarm: 'Групова тривога',
  newPersonalAlarm: 'Новий персональний будильник',
  newGroupAlarm: 'Нова групова тривога',
  editPersonalAlarm: 'Редагувати персональний будильник',
  editTaskAlarm: 'Редагувати будильник',
  editGroupAlarm: 'Редагування групової тривоги',
  rearrangeParticipants: 'Перестановка учасників',
  alarmConversation: 'Тривожний чат',
  timezoneMismatchDetected:
    "Щось підказує нам, що ви перебуваєте в іншому часовому поясі, ніж коли востаннє користувалися Galarm.\n\nСтарий часовий пояс: {{oldTimezone}}\nНовий часовий пояс: {{newTimezone}}\n\nЦе може бути пов'язано зі зміною вашого місцезнаходження або зміною часового поясу на вашому пристрої.\n\nБудь ласка, перезапустіть Galarm, щоб ми могли адаптуватися до нового часового поясу.",
  deviceRestartRequired: 'Потрібен перезапуск програми',
  disabledAlarm: 'Вимкнено будильник {{name}}',
  newContact: 'Новий контакт',
  contactName: "Ім'я контактної особи",
  contactMobileNumber: 'Контактний номер телефону',
  enterNameForContact: "Введіть ім'я контакту",
  pickCountryForContact: 'Країна контакту',
  enterMobileNumberForContact: 'Введіть номер телефону контакту',
  specifyNameForContact: "Ім'я контакту обов'язкове",
  specifyValidPhoneNumberForContact: 'Потрібен дійсний номер телефону',
  addingContact: 'Додавання контакту',
  deletingContact: 'Видалення контакту',
  editingContact: 'Контакт для редагування',
  pending: 'На розгляді',
  deleteContact: 'Видалити контакт',
  galarmContact: 'Додано вручну',
  phoneContact: 'Додано з телефонних контактів',
  confirmDeleteContactTitle: 'Видалити {{name}}?',
  confirmDeleteContact: 'Ви не зможете додати їх до своїх будильників.',
  contactAdded:
    'Чудово! Тепер ви можете додати {{name}} як учасника до своїх будильників.',
  contactInvited:
    'На адресу {{name}} було надіслано текстове повідомлення із запрошенням скористатися послугами Galarm.',
  changeSnoozeDuration: 'Тривалість зміни',
  durationOfEvent: 'Тривалість заходу',
  upgradeToPremium: 'Перехід на Преміум',
  premium: 'Преміум',
  alarmLimitReached: 'Досягнуто ліміт тривоги',
  unableToConnectToGooglePlay:
    'Не вдається підключитися до Google Play. Переконайтеся, що ви увійшли до свого облікового запису Google.',
  cantLoadVideo: 'Не вдається завантажити відео',
  cantUpgradeToPremium: 'Неможливо перейти на преміум-версію',
  unableToConnectToIapAndroid:
    'Не вдається підключитися до Play Store. Будь ласка, відкрийте додаток Play Store і переконайтеся, що ви ввійшли в систему.',
  unableToConnectToIapIos:
    'Не вдається підключитися до App Store. Будь ласка, відкрийте додаток App Store і переконайтеся, що ви ввійшли в систему.',
  premiumFeaturesIos:
    'Як преміум-користувач, ви отримуєте збільшений ліміт {{maxLimit}} одночасних тривог.\n\nВаша покупка також допомагає нам розробляти більше функцій.',
  premiumFeaturesAndroid:
    'Створюйте необмежену кількість тривог, перейшовши на преміум-підписку.\n\nВаша покупка також допомагає нам розробляти більше функцій.',
  upgrade: 'Оновлення',
  rvInternalError:
    'Ми не змогли завантажити відео через внутрішню помилку. Однак ми збільшили ліміт тривоги на 1.',
  rvNetworkError:
    "Будь ласка, переконайтеся, що у вас гарне з'єднання з Інтернетом, і спробуйте ще раз.",
  rvNotFoundError:
    'Наразі ми не змогли знайти відповідне відео. Однак ми збільшили ліміт тривоги на 1.',
  dontRemindMe: 'Не нагадуй мені.',
  sameTimeAsBuddy: 'У той самий час, що й buddy',
  noAlertForBuddyAlarm:
    'Ви вирішили не отримувати сповіщення про цей тривожний сигнал.',
  noAlertRecipientIntervalDescription: 'Ви не отримаєте сповіщення.',
  chooseHours: 'Виберіть години',
  chooseMins: 'Виберіть хвилини',
  changeHours: 'Години зміни',
  moreOptions: 'Більше варіантів...',
  specificDates: 'Конкретні дати',
  specificDatesRepetition: {
    one: 'Конкретні дати (1 випадок)',
    other: 'Конкретні дати ({{count}} події)'
  },
  specificDatesRepetitionSummary:
    'Конкретні дати ({{remaining}}/{{total}} залишилися)',
  nOccurrences: {
    one: '1 Виникнення',
    other: '{{count}} Випадки'
  },
  addOrRemoveAlarmOccurrences:
    'Ви можете додавати події в будь-якому порядку. Ви можете натиснути на будь-яку дату або час, щоб змінити її.',
  chooseTime: 'Оберіть час...',
  set: 'Набір',
  chooseNumberOfDays: 'Введіть кількість днів',
  chooseNumberOfWeeks: 'Введіть кількість тижнів',
  numberOfDaysShouldBeAtLeastOne: 'Кількість днів має бути не менше 1',
  numberOfWeeksShouldBeAtLeastOne: 'Кількість тижнів має бути щонайменше 1',
  numberOfMonthsShouldBeAtLeastOne: 'Кількість місяців має бути не менше 1',
  numberOfYearsShouldBeAtLeastOne: 'Кількість років має бути не менше 1',
  frequency: 'Частота',
  configuration: 'Конфігурація',
  endDate: 'Дата закінчення тривоги',
  noEndDate: 'Без кінцевої дати',
  alarmEndDateSetOnAlarm:
    'Дата закінчення тривоги встановлена на {{endDateString}}.',
  noAlarmDateSetForAlarm:
    'Для цього тривожного сигналу не встановлено дату завершення.',
  noOccurrenceForThisAlarmAsPerEndDate:
    'Кінцева дата не допускає жодних подій для тривоги.',
  alarmDateShouldBeBiggerThanAlarmStartDate:
    'Дата закінчення тривоги повинна бути після дати початку тривоги.',
  aWeek: 'Тиждень',
  aMonth: 'Місяць',
  allInactiveAlarms: 'Усі неактивні тривоги',
  chooseAlarmEndDate: 'Виберіть дату закінчення тривоги',
  next: 'Далі',
  next7Days: '7 днів від сьогодні',
  next30Days: '30 днів від сьогодні',
  next12Months: '12 місяців від сьогодні',
  next10Years: '10 років від сьогодні',
  chooseDate: 'Оберіть дату...',
  learnMore: 'Дізнайтеся більше',
  repeatEvery: 'Повторює кожну',
  repeatEveryDays: 'день(и)',
  repeatEveryWeeks: 'тиждень(и)',
  repeatEveryMonths: 'місяць(и)',
  repeatEveryYears: 'рік(и)',
  repeatOnce: 'Повторити один раз',
  repeatEveryDay: 'Повторювати щодня',
  repeatEveryWeek: 'Повторювати щотижня',
  repeatEveryMonth: 'Повторювати щомісяця',
  repeatEveryYear: 'Повторювати щорічно',
  selectRepeatOption: 'Виберіть опцію повторення',
  autoSnooze: 'Автоматичний відкладення будильника',
  autoSnoozePerAlarm: 'Автоматичний будильник з відкладенням',
  unableToUploadGroupAvatar:
    'Неможливо завантажити зображення групи. Будь ласка, спробуйте пізніше',
  addNewMembersToExistingAlarms:
    'У цій групі ви маєте такі тривоги:\n\n{{alarmNames}}\n    \nВи хочете додати нових учасників до цих тривог?',
  removeGroupMemberAlert:
    'Видалення учасника вплине на наступні тривоги:\n\n{{alarmNames}}\n\nВи все ще хочете видалити користувача?',
  leaveGroupAlert:
    'Вихід з групи вплине на наступні тривоги:\n\n{{alarmNames}}\n\nВи все ще хочете вийти з групи?',
  updateAppAfterFeedback:
    'Ми помітили, що ви використовуєте стару версію програми. Будь ласка, оновіть її для кращого досвіду.',
  changesAreLost:
    'У вас є незбережені зміни.\n\nХочете зберегти перед виходом?',
  recipientAlarmIntervalGreaterThanRepetitionInterval:
    'Інтервал "нагадування" має бути меншим за інтервал повторення.',
  cascadingAlarmIntervalGreaterThanRepetitionInterval:
    'Інтервал "Час між оповіщеннями учасників" має бути меншим за інтервал повторення.',
  subscriptionCanceled:
    'Вашу преміум-підписку скасовано. Преміум-функції будуть недоступні, доки ви не поновите підписку.',
  unableToRenewSubscription:
    'Виникла проблема з поновленням вашої преміум-підписки. Будь ласка, переконайтеся, що ваша платіжна інформація актуальна.',
  notice: 'Повідомлення',
  ringerSettingsWillApplyToNewAlarms:
    'Зміни, які ви вносите до налаштувань звуку та вібрації, застосовуються лише до нових будильників.\n\nДля існуючих будильників ви можете відредагувати будильник, щоб змінити його налаштування звуку та вібрації.',
  renew: 'Поновити',
  galarmPremium: 'Galarm Premium',
  payMonthly: 'Сплачуйте щомісяця на {{price}} за місяць',
  payYearly: 'Сплачуйте щорічно на {{price}} за рік',
  free: 'Безкоштовно',
  unlimited: 'Необмежена',
  personalAlarms: 'Персональна сигналізація',
  groupAlarms: 'Групові тривоги',
  buddyAlarms: 'Будильники друга',
  alarmRepetitions: 'Повторення',
  ringtones: 'Рингтони',
  alarmHistory: 'Історія тривог',
  base: 'Базовий',
  advanced: 'Розширений',
  complete: 'Повний',
  alarmHistoryFree: 'Обмежений',
  phoneMusicAsRingtone: 'Музика для телефону як мелодія дзвінка',
  startFreeTrial: 'Почніть 14-денну безкоштовну пробну версію',
  chargedAtEndOfFreeTrial:
    'Після закінчення 14-денної безкоштовної пробної версії з вас буде стягнуто плату, якщо ви не скасуєте підписку.',
  chargedAtPurchase:
    'Вартість стягується під час покупки. У вартість входить вступна знижка 20%.',
  lookingForLifetimePlan: 'Натисніть тут, щоб отримати план на все життя>>.',
  monthlySubscription: 'Щомісяця',
  yearlySubscription: 'Щорічно',
  premiumRingtoneRequiresUpgrade:
    'Для використання цієї мелодії потрібна підписка Premium.',
  defaultPremiumFeaturesDescription:
    'Оновіть тарифний план до Преміум, щоб увімкнути ці круті функції.',
  groupAlarmsPremiumFeaturesDescription:
    'Щоб створити більше 1 групової тривоги, потрібна преміум-підписка.',
  instantAlarmsPremiumFeaturesDescription:
    'Щоб створити більше 5 миттєвих тривог, потрібна преміум-підписка.',
  buddyAlarmsPremiumFeaturesDescription:
    'Вам потрібна преміум-підписка, щоб створити більше 1 тривоги для когось іншого ("приятеля").',
  shareableAlarmLinksPremiumFeaturesDescription:
    'Вам потрібна преміум-підписка, щоб створювати більше спільних посилань на тривоги.',
  viewPremiumFeaturesDescription:
    'Дякуємо, що ви є преміум-користувачем. Ваш преміум-план пропонує ці функції.',
  accessToPremiumFeatures: 'Преміум-плани пропонують наступні можливості:',
  alarmCategoryPremiumFeaturesDescription:
    'Щоб створювати нові категорії, вам потрібна преміум-підписка.',
  galarmWebMovedToToolsTab:
    'Galarm Web переміщено на вкладку Інструменти. У майбутньому випуску його буде видалено з Налаштувань.',
  linkedAccountsMovedToToolsTab:
    "Пов'язані календарі переміщено на вкладку Інструменти. У майбутньому випуску їх буде видалено з Налаштувань.",
  galarmWebPremiumFeaturesDescription:
    'Вам потрібна преміум-підписка, щоб використовувати Galarm у веб-браузері.',
  personalAlarmsFeatureDescription:
    'Використовуйте персональний будильник, щоб прокинутися, прийняти ліки або виконати будь-яке інше завдання. За бажанням ви можете додати учасників, які отримуватимуть сповіщення, якщо ви пропустите будильник, щоб вони могли нагадати вам про це. Учасники також отримують сповіщення, коли ви позначаєте будильник як виконаний.',
  groupAlarmsFeatureDescription:
    'Використовуйте груповий будильник для групових заходів, таких як прогулянки, вечірки або будь-які інші події. Сигнал спрацьовує одночасно для всіх учасників, і вони можуть підтвердити свою участь.',
  instantAlarmsFeatureDescription:
    'Використовуйте цей будильник, щоб попередити контакт або групу контактів про навчальну тривогу, початок гри, термінове завдання/зустріч та інші події, що потребують негайної уваги.',
  buddyAlarmsFeatureDescription:
    'Створюйте будильники для когось іншого ("приятеля"), щоб нагадувати йому про справи, які потрібно зробити. Ви отримаєте сповіщення, щоб нагадати приятелю, якщо він пропустить будильник. Ви також отримаєте сповіщення, коли приятель позначить будильник як виконаний.',
  unlimitedAlarmsFeatureDescription:
    'Створюйте більше групових та дружніх тривог.',
  instantAlarmsPremiumFeature: 'Надсилати екстрені сповіщення',
  alarmRepetitionsFeatureDescription:
    'Створюйте будильники з розширеними можливостями повторення, наприклад, кожні 30 хвилин, кожні 2 години 45 хвилин, через день, раз на два тижні та багато іншого.',
  ringtonesFeatureDescription:
    'Вибирайте з широкого спектру преміум-рингтонів для своїх будильників. Ми постійно додаємо нові мелодії до преміум-пропозиції.',
  phoneMusicAsRingtoneFeatureDescription:
    'Виберіть будь-яку пісню/музику на телефоні як мелодію будильника.',
  shareableAlarmLinksFeatureDescription:
    'Ви можете поділитися тривогами з іншими за допомогою посилання.\n\nНаприклад, вчитель може поділитися посиланням на тривожний сигнал з учнями, використовуючи електронну пошту, WhatsApp або будь-який додаток для обміну повідомленнями. Коли учні натиснуть на посилання, копія нагадування буде створена на їхніх телефонах. Усі учні отримають сповіщення у вказаний час, щоб приєднатися до класу.',
  instantAlarmFeatureDescription:
    'Миттєве сповіщення групи людей одним натисканням кнопки.\n\nВикористовуйте цю тривогу, щоб сповістити про екстрені навчання, початок гри, термінове завдання/зустріч та інші події, які потребують негайної уваги.',
  alarmHistoryFeatureDescription:
    'Переглядайте всі минулі відповіді для кожного повторюваного тривожного сигналу. Це дозволить вам легко дізнатися, коли ви пропустили заняття в спортзалі, коли ваша мама пропустила прийом ліків тощо.',
  announceAlarmTitleFeatureDescription:
    'Оголошуйте назву будильника, коли він лунає.',
  exportToCalendarPremiumFeaturesDescription:
    'Щоб експортувати більше будильників до календаря, вам потрібна преміум-підписка.',
  exportToCalendarFeatureDescription:
    'Ви можете експортувати будильники до календаря. Це дозволить вам легко переглядати будильники в календарі вашого пристрою і краще відображати вашу доступність.',
  galarmWebFeatureDescription:
    'Використовуйте Galarm у веб-браузері для створення, редагування та видалення тривог.',
  preReminderFeatureDescription:
    'Встановіть попередні нагадування, щоб отримувати сповіщення про майбутні тривоги. Ви можете налаштувати відносну тривалість нагадування до фактичного часу спрацьовування будильника, наприклад, за 30 хвилин, за 1 день і т.д.',
  autoSnoozeCountUpgradeTitle:
    'Встановлення кількості відкладань більше ніж 2 вимагає преміум-підписки',
  higherAutoSnoozeCountPerAlarm:
    'Ви можете встановити більшу кількість відкладань для кожного будильника окремо. Редагуйте налаштування "Звук і вібрація" під час створення або редагування будильника.',
  calendarViewFeatureDescription:
    'Переглядайте будильники в календарі, щоб легко переглядати будильники на будь-який день.',
  updatePhoneNumberFeatureDescription:
    'Ви можете змінити номер телефону, який використовується для цього акаунта. Всі ваші будильники, контакти, групи та інші налаштування будуть перенесені на новий номер телефону.',
  alarmPhotoFeatureDescription:
    "Додайте фотографію до будильника для швидких візуальних підказок, наприклад, фото ліків, інструкції до завдання, предмета тощо. Фотографія з'явиться на екрані, коли спрацює будильник.",
  taskListFeatureDescription:
    "Створюйте списки завдань, щоб тримати пов'язані завдання разом.",
  taskAlarmPremiumFeature: 'Нагадування для завдань',
  taskAlarmFeatureDescription:
    'Встановлюйте будильники для окремих завдань або цілих списків завдань, щоб отримувати нагадування у потрібний час.',
  duplicateAlarmPremiumFeature: 'Дублююча тривога',
  duplicateAlarmFeatureDescription:
    'Швидко створюйте копії тривоги з тими самими налаштуваннями та вносьте зміни перед збереженням.',
  calendarViewPremiumFeature: 'Перегляд календаря',
  showingAlarmsForDate: 'Відображення тривог для {{date}}',
  updatePhoneNumberPremiumFeature: 'Змінити номер телефону',
  alarmNotFound: 'Сигнал тривоги не знайдено',
  alarmNotFoundMessage:
    'Можливо, цей тривожний сигнал було нещодавно видалено. Натисніть "Видалити", щоб вимкнути подальші сповіщення для цього тривожного сигналу.',
  alarmExistsWithDeepLinkTitle: 'Дублююча тривога',
  alarmExistsWithDeepLinkMessage:
    'Будильник, створений за цим посиланням, вже існує у вашому телефоні.',
  errorCreatingSharedAlarmLink:
    'Не вдалося створити посилання на спільний будильник. Будь ласка, спробуйте ще раз.',
  alarmDoesntHaveNextDate: 'Тривога не має дійсної наступної дати.',
  sharePersonalAlarmDeepLinkDescription:
    'Перейдіть за цим посиланням, щоб створити тривогу для цієї події на {{dateString}}.',
  joinGroupAlarmDeepLinkDescription:
    'Перейдіть за цим посиланням, щоб приєднатися до цього групового заходу за адресою {{dateString}}',
  subscribedAlarmEdited:
    '{{alarmCreatorName}} оновив {{alarmName}}. Хочете оновити свій будильник?',
  subscribedAlarmDeleted:
    '{{alarmCreatorName}} видалив {{alarmName}}. Ви хочете видалити свій будильник?',
  responseReceivedForTicket:
    'Ми відповіли на ваш тикет №{{ticketId}} за адресою: {{email}}. Якщо листа немає у вашій папці "Вхідні", перевірте, будь ласка, папку "Спам" на наявність листа від support@galarm.zendesk.com.',
  newTicketReceived:
    'Дякуємо, що написали нам. Ми створили тікет №{{ticketId}} для відстеження вашого запиту.\n\nМи відповімо на вказану вами електронну адресу: {{email}}. Якщо вона невірна, будь ласка, надішліть свій відгук ще раз, вказавши правильну електронну адресу.\n\nБудь ласка, також додайте support@galarm.zendesk.com до своєї адресної книги, щоб забезпечити належну доставку наших відповідей. Ми також надішлемо повідомлення сюди, коли відповімо на ваш запит.',
  sentAccountBackup:
    'Ми надіслали дані вашої тривоги на адресу {{email}}. Якщо їх немає у вашій папці "Вхідні", перевірте, чи не надійшов лист від noreply@acintyo.com.',
  alarmDoesntExist: 'Сигналізації не існує.',
  shareAlarm: 'Поділіться посиланням на тривогу',
  shareAlarmDescription:
    'Ви можете поділитися цим будильником з будь-ким за допомогою посилання, не додаючи його до контактів. Коли хтось натискає на посилання на своєму телефоні, створюється копія будильника.',
  shareLink: 'Поділіться посиланням',
  joinedGroupAlarmFromDeepLinkMessage:
    'Ви отримаєте нагадування про "{{alarmName}}" на сайті {{alarmTime}} за наступними адресами {{alarmDate}}',
  joinedRepeatingGroupAlarmFromDeepLinkMessage: {
    zero: 'Вам буде надіслано нагадування про "{{alarmName}}" {{repetitionString}}',
    one: 'Ви будете отримувати нагадування про "{{alarmName}}" {{repetitionString}} на {{alarmTime}} починаючи з {{alarmDate}}'
  },
  youHaveSubscribedToThisAlarm:
    'Ви стежите за цим тривожним повідомленням з сайту {{creatorName}}.',
  alreadySharedAlarmDescription: {
    zero: 'У вас немає підписників на цей сигнал тривоги.\n\nВи можете продовжувати ділитися цим будильником з іншими людьми за допомогою посилання. Коли вони натиснуть на посилання, копія цього будильника буде створена на їхньому телефоні.',
    one: '{{count}} людина слідує за цим сигналом тривоги.\n\nВи можете продовжувати ділитися цим будильником з іншими людьми за допомогою посилання. Коли вони натиснуть на посилання, копія цього будильника буде створена на їхньому телефоні.',
    other:
      '{{count}} люди йдуть за цим сигналом.\n\nВи можете продовжувати ділитися цим будильником з іншими людьми за допомогою посилання. Коли вони натиснуть на посилання, копія цього будильника буде створена на їхньому телефоні.'
  },
  shareParentAlarmDescription:
    'Ви стежите за цим тривожним повідомленням з сайту {{creatorName}}.\n\nВи також можете поділитися цим будильником з іншими за допомогою посилання. Коли вони натискають на посилання, копія цього будильника створюється на їхньому телефоні, і вони також можуть почати стежити за цим будильником.',
  shareableAlarmLinks: 'Посилання, якими можна поділитися',
  nPeopleFollowingAlarm: {
    zero: 'У вас немає підписників на цей сигнал тривоги.',
    one: '{{count}} людина слідує за цим сигналом.',
    other: '{{count}} люди йдуть за цим сигналом.'
  },
  likeUsOnFacebook: 'Facebook',
  followUsOnTwitter: 'X (раніше Twitter)',
  followUsOnInstagram: 'Instagram',
  youtube: 'YouTube',
  mediumBlog: 'Блоги на Medium',
  howtoVideos: 'Відео з інструкціями',
  followGalarmOnSocialMedia: 'Слідкуйте за Galarm у соціальних мережах',
  galarmOnSocialMedia: 'Galarm у соціальних мережах',
  followGalarmOnSocialMediaDescription:
    'Переглядайте цікаві новини про оновлення програми, використання функцій, майбутні функції, а також ключові огляди додатків. Ви також можете поспілкуватися з командою Galarm.',
  sharedAlarm: 'Редагування спільного тривожного сигналу',
  editingPublishedAlarm: {
    one: 'Ви редагуєте тривогу, яку ви поширили раніше за посиланням. {{count}} людина наразі стежить за цим тривожним сигналом.\n\nКоли ви внесете будь-які зміни до цього тривожного сигналу, вона отримає сповіщення про зміни.',
    other:
      'Ви редагуєте тривогу, яку ви поширили раніше за посиланням. {{count}} людей, які наразі слідкують за цією тривогою.\n\nКоли ви внесете будь-які зміни до цього тривожного сигналу, вони отримають сповіщення про зміни.'
  },
  editingSubscribedAlarm:
    'Ви стежите за цим тривожним сигналом з сайту {{creatorName}}. Після редагування тривоги ви не отримуватимете жодних оновлень для цього тривожного сигналу.',
  viewAlarm: 'Переглянути тривогу',
  view: 'Вигляд',
  editAlarm: 'Редагувати тривогу',
  editTimeForNextOccurrence: 'Редагувати час для наступного випадку',
  editedNextOccurrenceConfirmation:
    'Цей будильник було оновлено, щоб дзвонити після відредагованого випадку, і окремий будильник було створено для відредагованого випадку.',
  thanksForTryingPremiumTitle: 'Все готово!',
  thanksForTryingPremiumMessage:
    'Сподіваємося, вам сподобаються преміум-функції.\n\nЯкщо у вас виникнуть запитання, зверніться до служби підтримки через "Налаштування > Зворотній зв\'язок" або напишіть нам на galarm@acintyo.com.',
  subscribedAlarmEditedInAlarmDetails:
    '{{creatorName}} змінив будильник.\nОновити будильник?',
  subscribedAlarmDeletedInAlarmDetails:
    '{{creatorName}} видалив свій будильник.\nВидалити будильник?',
  updateSubscribedAlarm: 'Так, оновити',
  deleteSubscribedAlarm: 'Так, видалити',
  ignoreSubscribedAlarm: 'Ні, ігноруйте.',
  customRepetitionPremiumScreenDescription:
    'Користувацькі повтори - це преміум-функція.\n\nВи можете використовувати цю функцію для створення будильників з розширеними повтореннями. Приклади включають\n',
  specificDatesRepetitionPremiumScreenDescription:
    'За допомогою цього повтору ви можете налаштувати будильник на певні дати.',
  repeatAlternateDate: '✅ Повторювати по черзі в різні дні',
  repeatEveryNDay: '✅ Повторювати кожні 3 дні',
  repeatEveryNHoursAndMMinutes: '✅ Повторювати кожні 2 години 30 хвилин',
  repeatEveryNMinutes: '✅ Повторювати кожні 45 хвилин',
  repeatBiweekly: '✅ Повторювати кожні 2 тижні',
  repeatEveryNWeeks: '✅ Повторювати кожні 6 тижнів',
  repeatEveryNMonths: '✅ Повторювати кожні 3 місяці (щоквартально)',
  repeatEveryLastDayOfMonth: '✅ Повторюється в останній день кожного місяця',
  repeatDayOfWeekOfMonth: '✅ Повторюється у 2-гу суботу кожного місяця',
  repeatLastDayOfWeekOfMonth:
    "✅ Повторюється в останню п'ятницю кожного місяця",
  customRepetition: 'Користувацьке повторення',
  lastDayOfMonth: 'Останній день кожного місяця',
  dayOfWeekInMonth: '{{weekNumberOfDayInMonth}} {{dayName}} кожного місяця',
  lastDayOfWeekInMonth: 'Останній {{dayName}} кожного місяця',
  dayOfWeekInMonthInYearSummary:
    '{{weekNumberOfDayInMonth}} {{dayName}} з {{monthName}}',
  lastDayOfWeekInMonthInYearSummary: 'Останній {{dayName}} з {{monthName}}',
  lastDayOfMonthInYearSummary: 'Останній день {{monthName}}',
  dayOfWeekInMonthInYear:
    '{{weekNumberOfDayInMonth}} {{dayName}} {{monthName}} щороку',
  lastDayOfWeekInMonthInYear: 'Останні {{dayName}} з {{monthName}} щороку',
  lastDayOfMonthInYear: 'Останній день {{monthName}} щороку',
  chooseAMonthsConfiguration: 'Будь ласка, оберіть конфігурацію.',
  chooseADaysConfiguration: 'Будь ласка, оберіть конфігурацію',
  chooseAYearsConfiguration: 'Будь ласка, оберіть конфігурацію.',
  chooseAtLeastOneOccurrence: 'Будь ласка, оберіть хоча б один випадок.',
  sendCodeAgain: 'Надішліть код ще раз',
  didntGetCodeNewUser:
    'Не отримали код?\n\nВи можете запросити код повторно або пропустити реєстрацію. Ви можете зареєструватися пізніше.',
  didntGetCodeExistingUser:
    'Не отримали код?\n\nВи можете запросити код повторно або скасувати реєстрацію. Ви можете зареєструватися пізніше.',
  didntGetCodeUpdatePhoneNumber:
    'Не отримали код?\n\nВи можете запросити код ще раз або спробувати пізніше.',
  alreadySentCodeAgain:
    'Ми надіслали вам код. Якщо у вас виникли труднощі з отриманням коду, будь ласка, пропустіть реєстрацію та зареєструйтесь пізніше.',
  appearance: 'Зовнішній вигляд',
  accentColor: 'Акцентний колір',
  theme: 'Тема',
  announceAlarmName: 'Оголосити назву тривоги',
  ttsHelperText:
    'Заголовок будильника буде оголошено, коли він задзвонить. Ви можете натиснути на кнопку відтворення перед заголовком будильника, щоб прослухати попередній перегляд.',
  initializingTts: 'Ініціалізація тексту в мовлення',
  errorSpeakingAlarmName:
    'Не вдається вимовити назву будильника. Зверніться до служби підтримки через "Налаштування > Зворотній зв\'язок".',
  entityAlarm: 'тривога',
  entityGroup: 'група',
  entityContact: 'контакт',
  admin: 'Адміністратор',
  specifyAlarmTitleToSpeak: 'Вкажіть назву тривоги для озвучення',
  wakeup: 'Прокидайся.',
  ttsPremiumScreenDescription:
    'Оголошувати назву будильника - преміум-функція.\n\nЯкщо увімкнено, назву будильника буде оголошено, коли він задзвонить.\n\nЩоб переглянути, вкажіть заголовок будильника і торкніться відтворення.',
  unknownAlarmCategory: 'Невідома категорія тривоги',
  cantAnnounceAlarmTitle: 'Назва тривоги не буде оголошена',
  ringtoneDurationIsSmall:
    'Тривалість мелодії повинна бути не менше 5 секунд для оголошення назви будильника.\n\nБажаєте продовжити з цими налаштуваннями?',
  noActionItems: 'Ніяких дій.',
  personNotInContacts: 'Цього користувача немає у ваших контактах Galarm.',
  light: 'Світло',
  dark: 'Темнота.',
  systemDefault: 'Використовувати налаштування пристрою',
  chooseTheme: 'Виберіть тему',
  dontSeeAllYourContacts: 'Не бачите всі свої контакти?',
  lastContactsSyncedAt: 'Останній раз синхронізовано в {{dateString}}',
  refresh: 'Оновити',
  forever: 'Назавжди.',
  autoSnoozeConfiguration: 'Налаштування повтору',
  autoSnoozeConfigurationSummary:
    '{{autoSnoozeDurationLabel}}, {{autoSnoozeCountLabel}}',
  uncategorizedCategoryName: 'Не класифіковано',
  uncategorizedCategoryScreenTitle: 'Без категорії',
  setAlarmCategory: 'Встановити категорію тривоги',
  changeAlarmCategory: 'Змінити категорію тривоги',
  viewAlarmHistory: 'Перегляд історії тривог',
  computingAlarmHistory: 'Обчислення підсумків для історії тривог.',
  alarmByCategories: '{{name}} Сигнали тривоги',
  alarmCategories: 'Категорії',
  editAlarmCategory: 'Редагувати категорію',
  deleteAlarmCategory: 'Видалити категорію',
  newAlarmCategoryTitle: 'Нова категорія',
  newAlarmCategoryNamePlaceholder: "Вкажіть ім'я",
  editAlarmCategoryTitle: 'Редагувати категорію',
  alarmCategorySummary: {
    zero: '{{alarmsSummary}}',
    one: '{{alarmsSummary}}, {{count}} пропущено',
    other: '{{alarmsSummary}}, {{count}} пропущено'
  },
  numAlarms: {
    zero: 'Ніяких тривог',
    one: '{{count}} тривога',
    other: '{{count}} тривоги'
  },
  numIncidents: {
    zero: 'Без інцидентів',
    one: '{{count}} інцидент',
    other: '{{count}} інциденти'
  },
  openedIncidents: 'Відкриті інциденти',
  closedIncidents: 'Закриті інциденти',
  incidentChart: 'Графік інцидентів (за останні 30 днів)',
  incidentCalendar: 'Календар інцидентів',
  incidentDistribution: 'Розподіл інцидентів (за останні 30 днів)',
  noIncidentsOpenedClosedInLast30Days:
    'За останні 30 днів не було відкритих або закритих інцидентів',
  noIncidentsOpenedInLast30Days:
    'За останні 30 днів не було відкрито жодного інциденту',
  color: 'Колір',
  createNewAlarmCategory:
    'Створіть нову категорію, натиснувши кнопку + внизу праворуч',
  setValidName: "Вкажіть правильне ім'я",
  specifyTimezoneForAlarmMessage:
    'Під час створення будильників ви можете вказати часовий пояс. Будильники дзвонитимуть відповідно до вказаного часового поясу. \n\nЯкщо ви виберете "Часовий пояс пристрою", будильники дзвонитимуть у часовому поясі вашого пристрою.',
  selectDefaultTimezoneForAlarmDefaultTooltipMessage:
    'Виберіть часовий пояс за замовчуванням для будильників. Ви можете змінити часовий пояс для будильників під час їх створення.',
  alarmCategoryFeatureDescription:
    'Створюйте власні категорії для будильників. Категорії дозволяють легко впорядкувати ваші тривоги.',
  markAlarmDoneInAdvance: 'Відмітити будильник "Готово" раніше?',
  skipAlarmInAdvance: '"Пропустити" будильник раніше?',
  markAlarmDoneInAdvanceMessageRepeatingAlarm:
    'Будильник не спрацює на {{dateTimeString}}, якщо ви зараз позначите його як "Виконано".',
  skipAlarmInAdvanceMessageRepeatingAlarm:
    'Якщо ви пропустите його зараз, будильник не задзвонить на {{dateTimeString}}.',
  markAlarmDoneInAdvanceMessageOneTimeAlarm:
    'Будильник не спрацює на {{dateTimeString}}, якщо ви зараз позначите його як "Виконано".',
  skipAlarmInAdvanceMessageOneTimeAlarm:
    'Якщо ви пропустите його зараз, будильник не задзвонить на {{dateTimeString}}.',
  alarmsByCategories: 'Тривоги за категоріями',
  workAlarmCategory: 'Робота',
  homeAlarmCategory: 'Головна',
  birthdaysAlarmCategory: 'Дні народження',
  more: 'Більше',
  alarmCategory: 'Категорія тривоги',
  editAlarmCategoryColor: 'Редагувати колір',
  editAlarmCategoryColorTitle: 'Редагувати колір для {{name}}',
  allUserCategoriesDeleted:
    'Усі створені вами категорії тривог було видалено, оскільки преміум-підписку було скасовано. Тривоги з цих категорій з\'являться у розділі "Не категоризовані".',
  calendar: 'Календар',
  eventExportedFromGalarm:
    '"Експортовано з Galarm на {{dateString}} на {{timeString}}."',
  unableToExportEventToCalendar:
    'Неможливо експортувати подію до календаря. Переконайтеся, що ви надали дозвіл на доступ до календаря на вашому пристрої. Перезапустіть додаток і спробуйте ще раз, якщо ви надали дозвіл. Якщо проблема не зникне, надішліть нам відгук через "Налаштування > Зворотній зв\'язок".',
  scanQrCode:
    'Щоб отримати доступ до Galarm у браузері, перейдіть на web.galarm.app та відскануйте QR-код.',
  logOut: 'Вийти з системи',
  useHere: 'Використовуйте тут',
  appRunningElsewhere: 'Ви вийшли з цього сеансу. Бажаєте відновити цей сеанс?',
  dateTime: 'Дата та час',
  selectAtLeastOneDayForRepetition:
    'Виберіть принаймні один день, коли будильник буде повторюватися.',
  chooseNumberOfDaysForAlarmRepetition:
    'Введіть кількість днів, через яку будильник має повторитися.',
  chooseNumberOfWeeksForAlarmRepetition:
    'Введіть кількість тижнів, через які будильник має повторитися.',
  chooseNumberOfMonthsForAlarmRepetition:
    'Введіть кількість місяців, через які будильник має повторитися.',
  chooseNumberOfYearsForAlarmRepetition:
    'Введіть кількість років, через які тривога повинна повторитися.',
  previouslySelectedContactsAreUnselected:
    'Попередньо вибрані контакти буде знято.',
  previouslySelectedGroupIsUnselected:
    'Попередньо вибрана група стає невибраною.',
  galarmWebInstructions:
    '1. Відкрийте додаток Galarm на своєму телефоні\n2. Перейдіть у вкладку "Налаштування" і натисніть на "Galarm Web"\n3. Переконайтеся, що у вас встановлена найновіша версія програми, якщо ви не бачите цю опцію\n4. Відскануйте QR-код праворуч',
  likeToCreateAlarm: 'Створити тривогу для...',
  payUtilityBills: 'Сплачуйте рахунки',
  wakeupAlarmName: 'Прокидайся.',
  exerciseAlarmName: 'Вправа',
  drinkWaterAlarmName: 'Питна вода',
  everyNHoursRepetitionStringShortSummary: {
    one: '{{startTimeString}} на {{endTimeString}} Щогодини',
    other: '{{startTimeString}} на {{endTimeString}} Кожні {{count}} години'
  },
  firstTimeManagementQuote:
    '"Погана новина - час летить. Хороша новина - ти пілот".',
  firstTimeManagementQuoteAuthor: 'Майкл Альтшулер',
  secondTimeManagementQuote:
    '"Будь-який тайм-менеджмент починається з планування".',
  secondTimeManagementQuoteAuthor: 'Том Грінінг',
  thirdTimeManagementQuote:
    '"Ніколи не відкладай на завтра те, що можеш зробити сьогодні".',
  thirdTimeManagementQuoteAuthor: 'Бенджамін Франклін',
  fourthTimeManagementQuote:
    '"Час - це те, чого ми хочемо найбільше, але що ми використовуємо найгірше".',
  fourthTimeManagementQuoteAuthor: 'Вільям Пенн',
  fifthTimeManagementQuote:
    '"Через рік ви, можливо, пошкодуєте, що не почали сьогодні".',
  fifthTimeManagementQuoteAuthor: 'Карен Ламб',
  sixthTimeManagementQuote: '"Ви можете зволікати, але час не буде".',
  sixthTimeManagementQuoteAuthor: 'Бенджамін Франклін',
  tapToGetStarted: 'Натисніть "+", щоб почати.',
  allCategories: 'Всі категорії',
  createAlarmWithContact: 'Створіть тривогу за допомогою {{name}}',
  createAlarmWithGroup: 'Створіть тривогу за допомогою {{name}}',
  editGroup: 'Група редагування',
  discardChanges: 'Поточні зміни будуть відкинуті. Продовжувати?',
  alarmWillRingEveryNDays: {
    zero: 'Будильник дзвонитиме щодня.',
    one: 'Будильник дзвонитиме по черзі в різні дні.',
    other: 'Будильник дзвонитиме кожного {{dayWithOrdinal}} дня.'
  },
  hoursString: {
    zero: '',
    one: '1 година',
    other: '{{count}} годин'
  },
  minutesString: {
    zero: '',
    one: '1 хвилина',
    other: '{{count}} хвилини'
  },
  alarmWillRingEveryMHoursAndNMinutes:
    'Будильник буде дзвонити після кожного {{repeatString}}, починаючи з {{dayString}}. Після цього {{otherDaysString}} і так далі.',
  alarmWillRingEveryNWeeks: {
    zero: 'Будильник дзвонитиме щотижня.',
    one: 'Будильник дзвонитиме раз на два тижні.',
    other: 'Будильник дзвонитиме щотижня {{weekWithOrdinal}} тиждень.'
  },
  alarmWillRingEveryNMonths: {
    zero: 'Будильник дзвонитиме щомісяця.',
    one: 'Будильник дзвонитиме раз на два місяці.',
    other: 'Будильник дзвонитиме щомісяця {{monthWithOrdinal}}.'
  },
  alarmWillRingEveryNYears: {
    zero: 'Будильник дзвонитиме щороку.',
    one: 'Будильник дзвонитиме раз на рік.',
    other: 'Будильник дзвонитиме щороку {{yearWithOrdinal}}.'
  },
  ringParticipantAlarmsByDefaultTooltipMessage:
    'Якщо цей параметр увімкнено, будильники від інших користувачів дзвонитимуть без прийняття. Ви все одно повинні прийняти тривогу, щоб повідомити її творця про те, що ви маєте намір взяти участь у тривозі.\n\nЯкщо цю опцію вимкнено, будильники, додані для вас іншими, не дзвонитимуть на ваш телефон, якщо ви явно не приймете їх.',
  specifyTimezoneForAlarmDefaultTooltipMessage:
    'Якщо цей параметр увімкнено, ви можете вказати часовий пояс під час створення будильників. Будильники дзвонитимуть відповідно до вказаного часового поясу.\n\nЯкщо цю опцію вимкнено, будильники дзвонитимуть у часовому поясі вашого пристрою.',
  ringOnEarphoneOnlyTooltipTitle:
    'Поведінка будильника, коли підключено навушники',
  ringOnEarphoneOnlyTooltipMessage:
    'Якщо підключені навушники, ви можете налаштувати будильник так, щоб він дзвонив лише на навушники або на динамік телефону та навушники.\n\nЯкщо навушники не підключено, будильники дзвонитимуть на динамік телефону.',
  gestureOptionsTooltipTitle: 'Жест для скидання будильника',
  gestureOptionsTooltipMessage:
    'Коли на екрані блокування спрацьовує будильник, ви можете відключити його, натиснувши або пересунувши кнопку.\n\nЦей параметр дозволяє вам вибрати спосіб ігнорування будильника.',
  notificationSettingsTooltipTitle: 'Налаштування сповіщень',
  notificationSettingsTooltipMessage:
    'Увімкніть сповіщення, які ви бажаєте отримувати, і вимкніть ті, про які ви не хочете отримувати сповіщення.',
  messagesForAlarm: 'Повідомлення для {{name}}',
  systemNotificationsTooltipMessage:
    'Сповіщення, що генеруються додатком для таких подій, як\n  - коли будильники спрацьовують через зміну часового поясу контакту\n  - коли запрошений контакт реєструється на Galarm\n  - коли тривоги порушуються через видалення контактом свого акаунта',
  galarmWebNotificationsTooltipMessage:
    'Сповіщення, надіслані вам від Galarm Web.',
  alarmsfromOthersNotificationsTooltipMessage:
    'Сповіщення, які надсилаються, коли вас додано до тривоги як учасника.',
  alarmChatNotifictionsTooltipMessage:
    'Сповіщення, надіслані для повідомлень чату в тривозі.',
  groupNotificationsTooltipMessage:
    'Сповіщення, які надсилаються, коли вас додано до групи, видалено з групи або когось додано/видалено з групи.',
  alarmAcknowledgementNotificationsTooltipMessage:
    'Сповіщення, які надсилаються, коли учасник підтверджує тривогу, в якій ви також є учасником.',
  sharedAlarmNotificationsTooltipMessage:
    'Сповіщення, які надсилаються:\n  - коли хтось підписується на тривогу, яку ви поширили за посиланням\n  - коли будильник, на який ви підписані, змінено',
  pinMode: 'Режим виводу',
  pinModeTooltipMessage:
    'Увімкніть цей параметр, коли ви закріпили програму у верхній частині екрана за допомогою функції закріплення додатків в Android.',
  sleepTimer: 'Музика для сну',
  sleepTimerTitle: 'Відтворити музику для',
  ongoingSleepTimer: 'Музика для сну триває',
  stopSleepTimer: 'Ви хочете зупинити поточну музику?',
  restartSleepTimer: 'Ви хочете зупинити поточну музику і почати нову?',
  play: 'Грай.',
  youAreOffline:
    'Наразі ви перебуваєте в режимі офлайн. Перейдіть в онлайн для виконання будь-яких операцій.',
  alarmLinkRelativeToTimezone: '{{timeString}} у своєму часовому поясі.',
  alarmLinkNotRelativeToTimezone: 'Будильник кожного пролунає о {{timeString}}',
  alarmShouldRingAt: 'Будильник пролунає у кожного:',
  sleepMusicTooltip:
    'Вмикайте природні звуки, щоб розслабити тіло і розум. Музика припиняє відтворення після заданої тривалості.',
  alarmLinkCopiedToClipboard:
    'Посилання на тривогу скопійовано в буфер обміну.',
  confirmLogOut: 'Ви хочете вийти з системи?',
  appNotRunningMessage:
    'Ми виявили, що Galarm не запущено на вашому телефоні. Торкніться, щоб запустити Galarm, щоб не пропустити жодного важливого сигналу.',
  tapToEnterNotesForAlarm: 'Натисніть, щоб ввести нотатки',
  accountAlreadyExists: 'Знайдено існуючий обліковий запис',
  accountsMerged:
    "Ми знайшли існуючий обліковий запис, пов'язаний з цим номером мобільного телефону. Ми об'єднали два акаунти.",
  upgradeToPremiumToAssignUserDefinedCategory:
    'Перейдіть на Преміум, щоб вибрати категорію, визначену користувачем.',
  userDefinedCategoryNotSetForAlarm:
    'Оновіть тарифний план до Преміум, щоб автоматично призначити категорію, визначену користувачем. Для будильника не встановлено категорію.',
  alarmDetails: 'Деталі тривоги',
  profileDetails: 'Профіль',
  activeWebSession:
    'Ви вже маєте активну веб-сесію. Ви можете вийти з нього або розпочати новий сеанс.\n\nПочаток нового сеансу автоматично призведе до виходу з поточного активного сеансу.',
  startNewSession: 'Почніть новий сеанс',
  confirmWebSessionLogout:
    'Ви вийдете з поточного веб-сеансу. Ви можете розпочати новий сеанс, відсканувавши код ще раз.',
  defaultInstantAlarmTitleForGroup:
    '{{groupName}} Сповіщення від {{creatorName}}',
  defaultInstantAlarmTitleForContact: 'Сповіщення від {{creatorName}}',
  atleastOneMemberShouldBeActive:
    'Принаймні один учасник повинен бути активним.',
  activeParticipants: 'Активні учасники',
  acceptAlarm: 'Прийняти тривогу',
  rejectAlarm: 'Відхилити тривогу',
  nConfirmed: '{{count}} підтверджено',
  nDeclined: '{{count}} відхилено',
  nPending: '{{count}} на розгляді',
  everyoneConfirmed: 'Всі підтвердили',
  everyoneDeclined: 'Всі відмовилися',
  appTagline: 'Ніколи нічого не пропускай',
  usePreviousBackup: 'Я вже зареєстрований користувач >>.',
  viewAlarmsByCategories: 'Перегляд тривог за категоріями',
  viewAllAlarms: 'Переглянути всі тривоги',
  switchToSummaryView: 'Перейдіть до зведеного перегляду',
  switchToListView: 'Перехід до перегляду списку',
  hideHourlyAlarms: 'Приховати погодинні будильники',
  showHourlyAlarms: 'Показувати щогодинні будильники',
  calendarView: 'Календар Galarm',
  viewRecentlyDeletedAlarms: 'Перегляд нещодавно видалених тривог',
  deletedOnDate: 'Видалено на {{alarmDate}}',
  recentlyDeletedAlarmFooterText:
    'Цей тривожний сигнал було видалено на {{alarmDate}}',
  noRecentlyDeletedAlarms: 'Нещодавно видалених тривог немає',
  restoreAlarmsFromMobileApp:
    'Ці будильники будуть автоматично видалені через 30 днів після їх видалення. Якщо ви хочете відновити будь-який з них, перейдіть на екран "Нещодавно видалені будильники" у вашому мобільному додатку і натисніть на іконку відновлення.',
  deleteExpiredAlarms: 'Видалити пропущені будильники',
  deleteInactiveAlarms: 'Видалення неактивних тривог',
  deleteAlarms: 'Видалити будильники',
  enableAlarms: 'Увімкнути будильники',
  disableAlarms: 'Вимкнути будильники',
  noItemsToDisplay: 'Немає елементів для відображення',
  sent: 'Відправлено',
  received: 'Отримано',
  defaultConfigurationUpdated: 'Оновлена конфігурація за замовчуванням.',
  notAlerted: '(виключено)',
  alarmKeepsRingingHelp: 'Допоможіть! Мій будильник продовжує дзвонити',
  alarmKeepsRingingHelpMessage:
    'Ми оновили ваші тривоги та надіслали звіт про проблему.',
  alarmKeepsRingingHelpAlert:
    'Ми оновимо ваші тривоги, і ви більше не повинні спостерігати цю проблему. Ми також надішлемо звіт про проблему до нашої служби підтримки для подальшого розслідування.\n\n  Якщо проблема не зникне, зв\'яжіться з нами через "Налаштування > Зворотній зв\'язок".',
  sendingFeedback: 'Надсилання відгуку',
  sendingProblemReport: 'Надсилання повідомлення про проблему',
  fixingAlarms: 'Оновлення будильників',
  existingAccountFound: 'Відновлено резервну копію',
  existingAccountDataRestored: {
    zero: 'Вітаємо, всі дані відновлено з резервної копії.',
    one: 'Вітаємо, всі дані відновлено з резервної копії.',
    other: 'Вітаємо, всі дані відновлено з резервної копії.'
  },
  noExistingAccountFound: 'Резервну копію не знайдено',
  createdNewAccount:
    'Цей номер телефону не був зареєстрований в системі Galarm. Ми створили новий обліковий запис, використовуючи цей номер телефону.',
  iosCloseToAllowedNumNotificationsScheduled:
    'Ви наближаєтеся до межі системи iOS для запланованих сповіщень.\n\nЩоб будильники спрацьовували вчасно, увімкніть «Розширену доставку будильників» у «Налаштуваннях (вкладка) → Розширені налаштування».\n\nЦя преміум-функція використовує сервери Galarm для надійної доставки сповіщень про будильники, коли межа системи iOS вичерпана. Для цього потрібно активне підключення до Інтернету.',
  acknowledgeAlarmToScheduleNextOccurrence:
    'Це останнє сповіщення для цього тривожного сигналу. Тривале натискання на це сповіщення дає змогу запланувати наступне виникнення цього тривожного сигналу.',
  lastNotificationForOneTimeAlarm: 'Це останнє сповіщення для цієї тривоги.',
  criticalAlertsMessageTitle: 'Дзвінок будильника, коли телефон вимкнений',
  criticalAlertsMessageDescription:
    '\nВи можете налаштувати Galarm так, щоб він використовував Критичні сповіщення iOS для дзвінків будильника, коли ваш телефон вимкнений. Хочете увімкнути цю функцію для всіх будильників?\n\nВи також можете вибірково ввімкнути її для деяких будильників, відредагувавши їхні налаштування "Звук і вібрація > Критичні сповіщення".',
  allowCriticalAlerts: 'Дозволити критичні сповіщення',
  criticalAlertsPermissionDenied:
    'Для показу критичних сповіщень Galarm вимагає дозволу від вашого телефону. Будь ласка, увімкніть цей дозвіл у налаштуваннях вашого телефону.',
  enableCriticalAlertsForAllAlarms: 'Так, увімкнути для всіх тривог',
  selectivelyEnableCriticalAlerts: 'Ні, я вибірково ввімкну',
  firstName: "Ім'я та прізвище",
  lastName: 'Прізвище',
  email: 'Електронна пошта',
  password: 'Пароль',
  confirmPassword: 'Підтвердити пароль',
  signup: 'Зареєструватися',
  login: 'Логін',
  alreadySignedUp: 'Вже зареєструвалися?',
  notAUser: 'Не користувач?',
  subscribe: 'Підписатися',
  configurePlan: 'Налаштувати план',
  choosePlan: 'Виберіть план',
  billingCycle: 'Білінговий цикл',
  needHelpToGetStarted: 'Потрібна допомога, щоб почати?',
  browser: 'Браузер: {{name}}',
  deviceOs: 'Пристрій: {{name}}',
  lastActive: 'Остання активність: {{timestamp}}',
  signUp: 'Зареєструватися',
  useGalarmOnWeb: 'Використовуйте Galarm в Інтернеті',
  welcomeUser: 'Ласкаво просимо. {{name}}',
  changePassword: 'Змінити пароль',
  saveAlarm: 'Зберегти тривогу',
  galarmUserTip: 'Ти знав?',
  sendAlarm: 'Надіслати тривогу',
  saveGroup: 'Зберегти групу',
  webAppBestViewedOnDesktop:
    "URL-адреса (web.galarm.app) призначена для запуску інтерфейсу Galarm у веб-браузері на вашому ноутбуці або комп'ютері.\n\nДля використання Galarm на мобільному пристрої, будь ласка, встановіть додаток для Android з Google Play або додаток для iOS з App Store, скориставшись одним із посилань нижче:",
  scanQrCodeMessage: 'Відскануйте QR-код',
  reloadQrCode: 'Натисніть, щоб перезавантажити QR-код',
  invalidQrCodeScanned: 'Відскановано невірний QR-код.',
  unableToScanCode: 'Не вдається відсканувати код',
  unableToScanCodeMessage:
    'Виникла проблема при скануванні коду. Будь ласка, спробуйте ще раз. Якщо проблеми не зникнуть, будь ласка, надішліть нам відгук з мобільного додатку через "Налаштування > Зворотній зв\'язок".',
  problemWithEnterpriseAccountSetup:
    'Виникла проблема з налаштуванням вашого облікового запису Galarm Pro. Будь ласка, зверніться до служби технічної підтримки.',
  problemWithCreatingCheckoutSession:
    'Виникла проблема зі створенням сесії оформлення замовлення. Будь ласка, зверніться до служби технічної підтримки.',
  unableToLoadPremiumPlans:
    'Не вдалося завантажити преміум-плани. Будь ласка, спробуйте пізніше.',
  noPlanSelected: 'Будь ласка, виберіть план перед продовженням.',
  problemWithCreatingCustomerPortalSession:
    'Виникла проблема зі створенням сесії клієнтського порталу. Будь ласка, зверніться до служби технічної підтримки.',
  problemWithCreatingApiKey:
    'Виникла проблема зі створенням ключа API. Будь ласка, зверніться до технічної підтримки.',
  creatingAnAccount: 'Створення облікового запису',
  currentPlan: 'Поточний план: {{name}} ({{quantity}} місць)',
  myAccount: 'Інформація про обліковий запис',
  new: 'Новий',
  deleteAllAlarmHistoryAlertTitle: 'Видалення історії тривог',
  deleteAllAlarmHistoryAlertMessage:
    'Натисніть "Продовжити", щоб видалити історію для цього тривожного сигналу. Цю дію не можна скасувати.',
  ageOutInactiveAlarmsMessage:
    'Ви маєте {{count}} тривог, які були неактивні понад 60 днів. Наявність великої кількості неактивних тривог може вплинути на продуктивність програми.\n\nВи хочете видалити ці тривоги?',
  duplicateAlarm: 'Дублююча тривога',
  graduallyIncreaseVolume: 'Поступово збільшуйте гучність',
  graduallyIncreaseVolumeTooltipMessage:
    'Якщо цей параметр увімкнено, гучність будильника поступово збільшується до налаштованої гучності мелодії дзвінка. Це дає змогу зупинити будильник до того, як він стане надто гучним.\n\nЯкщо цей параметр вимкнено, будильники дзвонитимуть з налаштованою гучністю протягом усього часу звучання мелодії.',
  shakeToStopAlarm: 'Потрясіть, щоб зупинити будильник',
  shakeToStopAlarmTooltipMessage:
    'Якщо цей параметр увімкнено, ви можете потрясти телефон, щоб зупинити будильник, що дзвонить. Якщо налаштовано автоматичне відкладання, потрясіння відкладе будильник.',
  shakeToStopAlarmNotAvailable:
    'Потрясіть, щоб зупинити будильник - недоступно на цьому пристрої.',
  shakeSensitivity: 'Чутливість до струшування',
  shakeSensitivityVeryHigh: 'Дуже висока',
  shakeSensitivityHigh: 'Висока',
  shakeSensitivityMedium: 'Середня',
  shakeSensitivityLow: 'Низька',
  shakeSensitivityVeryLow: 'Дуже низька',
  shakeTestInstructions:
    'Потрясіть телефон, щоб перевірити. Смуга заповнюється, коли виявляє рух; зелений означає, що будильник зупиниться. Ви також відчуєте вібрацію, коли будильник зупиниться.',
  teams: 'Команди',
  alerts: 'Сповіщення',
  listeners: 'Слухачі',
  noMembersConfiguredInEnterpriseAccount: `Ви ще не додали жодного учасника.

Учасники — це користувачі, яких можна сповістити, коли у вашій організації відбуваються інциденти. Ці люди вже повинні бути зареєстровані в Galarm.`,
  noMembersConfiguredInBusinessAccount: `Ви ще не додали жодного учасника.

Учасники — це користувачі, яким ви хочете надати преміум-функції Galarm. Ці люди вже повинні бути зареєстровані в Galarm.`,
  noTeamsConfiguredInEnterpriseAccount: `Ви ще не створили жодної команди.

Команди — це групи учасників, яких можна сповістити разом, коли у вашій організації відбуваються інциденти.`,
  noAlertsConfiguredInEnterpriseAccount: `Ви ще не створили жодного слухача.

Слухачі відстежують інциденти у вашій організації. Ви можете визначити, які учасники або команди отримують сповіщення, коли виявлено інцидент, і встановити правила ескалації, якщо його не підтверджено вчасно.

Кожен слухач надає вебхук, який ви можете інтегрувати з вашими інструментами моніторингу, щоб автоматично запускати інциденти, коли умови виконуються. Ви також можете створювати інциденти вручну з додатку, коли щось потребує уваги.`,
  noShiftsConfiguredInEnterpriseAccount:
    'Ви ще не створили жодної конфігурації зміни.',
  noRotationsConfiguredInEnterpriseAccount: 'Ви ще не створили жодної ротації.',
  rotations: 'Ротації',
  addRotation: 'Додати обертання',
  editRotation: 'Редагувати обертання',
  enterRotationName: 'Введіть назву ротації',
  rotationType: 'Тип обертання',
  numberOfHoursInRotation: 'Кількість годин у ротації',
  numberOfDaysInRotation: 'Кількість днів у ротації',
  numberOfWeeksInRotation: 'Кількість тижнів у ротації',
  specify: 'Вкажіть...',
  noIntegrationsConfiguredInEnterpriseAccount:
    'Ви ще не налаштували жодних конфігурацій інтеграції.',
  loadingUser: 'Завантаження інформації про користувача',
  addMember: 'Додати учасника',
  add: 'Додати',
  noUserFoundWithMobileNumber:
    'За цим номером телефону не знайдено жодного зареєстрованого користувача Galarm. Будь ласка, переконайтеся, що ви вводите номер телефону з кодом країни без будь-яких спеціальних символів, таких як дужки, тире, пробіли тощо.',
  memberWithPhoneNumberAlreadyAdded:
    'Користувача з таким номером телефону вже додано.',
  memberWithEmailAlreadyAdded: 'Користувача з такою адресою вже додано.',
  assignKeyToMember: 'Призначити ліцензійний ключ',
  revokeKeyFromMember: 'Відкликання ліцензійного ключа',
  cantAssignKeyToMember: 'Неможливо призначити ключ користувачеві',
  noEnterpriseLicenseKeyAvailable:
    'Ліцензійні ключі недоступні. Будь ласка, оновіть свій тарифний план.',
  addTeam: 'Додати команду',
  enterTeamName: 'Введіть назву команди',
  addAlert: 'Додати слухача',
  critical: 'Критично',
  low: 'Низький',
  medium: 'Середній',
  high: 'Високий',
  severity: 'Тяжкість',
  enterAlertName: "Введіть ім'я слухача",
  organization: 'Організація',
  startTime: 'Час початку',
  endTime: 'Кінцевий час',
  shiftName: 'Зміна. {{index}}',
  addShift: 'Додати зміну',
  assignees: 'Правонаступники',
  shiftStartEndTime: '{{startTime}} - {{endTime}}',
  assignee: 'Правонаступник',
  specifyAssigneeForShift: 'Вказуємо призначеного на зміну',
  selectAtLeastOneMember: 'Виберіть принаймні одного учасника',
  editMember: 'Редагувати учасника',
  editTeam: 'Команда редакторів',
  cantRemoveMemberAssignedToTeamsOrAlerts:
    'Учасник є частиною команди або призначений слухачеві. Будь ласка, видаліть учасника з цих команд/слухачів перед видаленням.\nКоманди: {{teams}}\nСлухачі: {{alerts}}',
  cantRevokeKeyFromMemberAssignedToTeamsOrAlerts:
    'Учасник є частиною команди або призначений слухачеві. Будь ласка, видаліть учасника з цих команд/слухачів перед тим, як відкликати ключ.\nКоманди: {{teams}}\nСлухачі: {{alerts}}',
  cantDeleteTeamAssignedToAlerts:
    'Команда входить до складу слухача. Будь ласка, видаліть команду зі списку перед видаленням.\nСлухачі: {{alerts}}',
  cantDeleteRotationAssignedToAlerts:
    'Ротація є частиною слухача. Будь ласка, видаліть команду зі списку перед видаленням.\nСлухачі: {{alerts}}',
  editAlert: 'Редагувати слухача',
  timezoneDisplayString: '(GMT{{offset}}) {{timezone}}',
  apiKey: 'Ключ API',
  viewApiKey: 'Перегляд ключа API',
  apiKeyWarningMessage:
    'Завжди зберігайте свій API-ключ у безпеці. Не передавайте його нікому. Якщо ви вважаєте, що ваш ключ API був скомпрометований, натисніть кнопку "Змінити" вище, щоб змінити його. Після зміни ключа вам потрібно буде вказати новий ключ у всіх місцях, де ви ініціюєте інциденти за допомогою REST API',
  integrationConfigs: 'Налаштування інтеграції',
  addIntegrationConfig: 'Додати конфігурацію інтеграції',
  editIntegrationConfig: 'Редагування конфігурації інтеграції',
  integrationSource: 'Джерело інтеграції',
  apiToken: 'Токен API',
  integrations: 'Інтеграції',
  selectPlaceholder: 'Виберіть...',
  chooseRoleForMember: 'Оберіть роль для учасника',
  zendeskSubdomain: 'Субдомен Zendesk',
  creatorTimeForBuddyAlarm: '{{timeString}} ({{remindMeAfter}})',
  nextFiveAlarms: 'Наступні 5 тривог',
  categories: 'Категорії',
  viewingAlarmsDueToday: 'Перегляд тривог, які мають надійти сьогодні',
  viewingAlarmsDueTomorrow: 'Перегляд тривог на завтра',
  expiredAlarms: 'Пропущені будильники',
  viewingExpiredAlarms: 'Перегляд пропущених будильників',
  noAlarmsDueToday: 'Сьогодні немає тривог',
  noAlarmsDueTomorrow: 'Ніяких тривог на завтра',
  noExpiredAlarms: 'Немає пропущених будильників',
  viewingAllAlarms: 'Перегляд усіх тривог',
  viewingRecentlyDeletedAlarms: 'Перегляд нещодавно видалених тривог',
  alarmsWillBeAutomaticallyDeleted:
    'Тривоги будуть остаточно видалені через 30 днів після видалення.',
  summaryView: 'Спробувати "Зведений перегляд"?',
  summaryViewDescription:
    'Перегляньте тривоги, впорядковані за датами та категоріями.\n\nВи можете повернутися до перегляду списку за допомогою кнопки ⋮ вгорі праворуч.',
  disableBatteryOptimizationMessageOnStartup:
    'Для надійного спрацьовування будильника Galarm має працювати у фоновому режимі. Будь ласка, надайте дозвіл на наступному екрані.',
  disableBatteryOptimizationMessage:
    'Galarm має працювати у фоновому режимі, щоб будильники надійно спрацьовували.',
  allowNotificationsToDisplayAlarms:
    'Galarm потребує дозволу, щоб показувати сповіщення, коли спрацьовує будильник.',
  scheduleExactAlarmsMessage:
    'Galarm потрібен дозвіл на планування точних будильників.',
  alarmCategoryWithSameNameExists:
    'Категорія з такою назвою вже існує. Будь ласка, вкажіть іншу назву.',
  unlimitedAlarmsPremiumFeature:
    'Необмежена кількість групових та дружніх тривог',
  alarmRepetitionsPremiumFeature: 'Розширені параметри повторення',
  ringtonesPremiumFeature: 'Більше мелодій',
  galarmWebPremiumFeature: 'Використовуйте Galarm в Інтернеті',
  taskListPremiumFeature: 'Створюйте кілька списків завдань',
  preReminderPremiumFeature: 'Попереднє нагадування для будильників',
  alarmCategoriesPremiumFeature: 'Користувацькі категорії тривог',
  shareableAlarmLinksPremiumFeature: 'Спільні посилання на тривоги',
  announceAlarmNamePremiumFeature: 'Оголосити назву тривоги',
  manageSubscription: 'Керування підпискою',
  modifySubscription: 'Змінити підписку',
  purchaseRestored: 'Покупку відновлено.',
  unableToRetrieveSubscriptionPlansAndroid:
    'Ми не можемо підключитися до Google Play, щоб виконати оновлення. Будь ласка, переконайтеся, що ви підключені до Інтернету, а потім спробуйте ще раз. \n\nЯкщо проблема не зникне, будь ласка, повідомте про неї нашій службі підтримки.',
  unableToRetrieveSubscriptionPlansIos:
    'Ми не можемо підключитися до App Store, щоб виконати оновлення. Переконайтеся, що ви підключені до Інтернету, а потім спробуйте ще раз. \n\nЯкщо проблема не зникне, будь ласка, повідомте про неї нашій службі підтримки.',
  drawOverOtherApps: 'Відображення поверх інших програм',
  drawOverOtherAppsHelperText:
    'Дозволити Galarm показувати тривожні сповіщення зверху',
  nTimes: {
    one: '1 раз',
    other: '{{count}} разів'
  },
  learnHowToUseFocus: 'Вивчайте фокус',
  enhancedNotificationsDeprecated: 'Розширені сповіщення застаріли',
  enhancedNotificationsDeprecatedMessage:
    'Ми виявили, що Розширені сповіщення не є надійними та призводять до надмірного розряду акумулятора. Будь ласка, використовуйте iOS Focus, щоб дозволити Galarm дзвонити на будильник, коли ваш телефон перебуває у режимі "Не турбувати".',
  usingIosFocus: 'Використання iOS Focus',
  iosFocusModePara1:
    'Galarm не дзвонитиме, якщо перемикач дзвінка телефону вимкнено або якщо гучність дзвінка дзвоника дорівнює 0.\n\nApple рекомендує використовувати "Фокус", якщо ви хочете, щоб ваш телефон був беззвучним, але при цьому дозволяв деяким додаткам сповіщати вас. Скористайтеся наведеними нижче інструкціями, щоб налаштувати функцію "Фокус" на телефоні.',
  iosFocusModePara2:
    'Більш детальну інструкцію зі скріншотами можна переглянути за посиланням https://galarm.zendesk.com/hc/en-us/articles/10906890793236-Allow-alarms-to-ring-on-silent-on-iOS',
  settingFocus: 'Налаштування фокусу:',
  settingFocusFootNotes:
    'Зверніть увагу, що Focus доступний на iOS 15 і вище.\n\nЯкщо у вас виникли запитання або ви хочете залишити відгук, будь ласка, зв\'яжіться з нами через "Налаштування > Зворотній зв\'язок".',
  enablingFocus: 'Увімкнути фокус:',
  settingFocusInstruction1: 'Перейдіть до "Налаштування телефону > Фокус".',
  settingFocusInstruction2: 'Натисніть на профіль фокусування "Не турбувати".',
  settingFocusInstruction3: 'Натисніть на "Додатки" і додайте Galarm.',
  settingFocusInstruction4:
    'Зробіть те саме для інших налаштованих профілів фокусування.',
  enablingFocusInstruction1:
    'Проведіть вниз від верхнього правого краю, щоб переглянути Центр керування.',
  enablingFocusInstruction2: 'Натисніть на "Фокус".',
  enablingFocusInstruction3:
    'Натисніть "Не турбувати" або будь-який інший профіль фокусування, який ви хочете увімкнути.',
  enablingFocusInstruction4:
    "З'явиться позначка увімкненого на даний момент фокусу. Щоб вимкнути його, торкніться його ще раз.",
  startDateForRotation: 'Дата початку ротації',
  startTimeForRotation: 'Час початку ротації',
  member: 'Учасник',
  multipleShiftsInADay: 'Кілька змін протягом дня',
  escalationPolicy: 'Політика ескалації',
  atTimeOfEvent: 'На момент проведення заходу',
  afterNMinutes: 'Через {{count}} хвилин',
  afterNHours: {
    one: 'Через 1 годину',
    other: 'Після {{count}} години'
  },
  afterDuration: 'Після того, як {{durationString}}',
  addTrigger: 'Додати тригер',
  viewCode: 'Переглянути код',
  apiCodes: 'Коди API',
  viewIncidents: 'Переглянути інциденти',
  viewInstantAlarms: 'Переглянути миттєві сигнали',
  viewTasks: 'Переглянути завдання',
  incidentsForAlert: 'Інциденти для слухача {{alertName}}',
  timestamp: 'Відмітка часу',
  notAcknowledged: 'Відкрито',
  acknowledged: 'Прийнято',
  closed: 'Закрито.',
  recovered: 'Автоматичне відновлення',
  noIncidentsForAlert: 'Для цього слухача ще немає інцидентів',
  errorClosingIncident: 'Помилка закриття інциденту',
  errorClosingIncidents: 'Помилки закриття інцидентів',
  apiCodeCopiedToClipboard: 'Код API скопійовано до буфера обміну.',
  triggerName: 'Спусковий гачок. {{index}}',
  delay: 'Затримка.',
  chooseAssigneePlaceholder: 'Виберіть правонаступника...',
  delayForTrigger: 'Затримка для тригера',
  assigneeWillBeAlertedAfterDelay:
    'Правонаступник буде повідомлений після {{durationString}}.',
  escalationForIncidentsForAlert:
    'Ескалація інциденту на {{incidentDate}} для слухача {{alertName}}',
  alertIncidentAcknowledged:
    'Підтверджено {{memberName}} за адресою {{dateString}}',
  alertIncidentClosed: 'Закрито {{memberName}} за адресою {{dateString}}',
  alertIncidentAutoClosed: 'Автоматично закривається при {{dateString}}',
  alertIncidentRecovered: 'Відновлено автоматично за адресою {{dateString}}',
  alertedAssignees: 'Тривога! {{assigneesString}}',
  acknowledgedBy: 'Підтверджено {{memberName}}',
  closedBy: 'Закрито {{memberName}}',
  alertIncidents: 'Інциденти',
  viewingAlertIncidents: 'Перегляд інцидентів',
  createOrganization: 'Створити організацію',
  youAreNotPartOfAnyOrganization:
    'Ви не є частиною жодної організації. Створіть організацію, щоб почати.',
  tellUsAboutYourOrganization: 'Розкажіть нам про вашу організацію',
  noActiveSubscription: 'У вас немає активної підписки.',
  chooseOrganization: 'Оберіть організацію для продовження.',
  noTriggersForIncident: 'Тригерів для цього інциденту не знайдено.',
  role: 'Роль',
  viewer: 'Глядач',
  viewerNoLogin: 'Переглядач (Без входу)',
  incidentCoordinator: 'Координатор інциденту',
  assignedListeners: 'Призначені слухачі',
  assignedLabels: 'Призначені мітки',
  noListenersAssignedToCoordinator:
    'Будь ласка, призначте принаймні одного слухача або мітку координатору інциденту.',
  recipientRole: 'Роль одержувача',
  editor: 'Редактор',
  recipientRoleTooltipMessage: `Ви можете дозволити одержувачу змінювати дату та час будильника.

Одержувач повинен бути підписником Galarm Premium, щоб змінити дату та час будильника.`,
  recipientChangeDateTimePremiumDescription:
    'Зміна дати та часу будильника для одержувача є преміум-функцією. Оновіть до Galarm Premium, щоб змінити дату та час цього будильника.',
  recipientUpdatedAlarmDateAndTime:
    'Час будильника змінено на {{dateTimeString}}. Створювача повідомлено.',
  recipientChangedAlarmTimeChatMessage:
    '{{username}} змінив час будильника з {{originalTime}} на {{newTime}}',
  allowRecipientToChangeTime: 'Дозволити одержувачу змінювати час сигналу',
  enterpriseViewerRoleDescription:
    'Користувачі з роллю Переглядача можуть бути додані до слухачів для отримання сигналів про інциденти. Вони також можуть увійти в веб-додаток, щоб переглядати інциденти та слухачів, але не можуть вносити зміни.',
  enterpriseViewerNoLoginRoleDescription:
    'Користувачі з роллю Переглядач (Без входу) можуть бути додані до слухачів для отримання сигналів тривоги про інциденти. Вони не можуть увійти в веб-додаток, щоб переглядати інциденти та слухачів.',
  enterpriseAdminRoleDescription:
    'Користувачі з роллю Адміністратора можуть бути додані до слухачів для отримання сигналів про інциденти. Вони також можуть увійти в веб-додаток, щоб переглядати інциденти та слухачів і вносити зміни.',
  enterpriseIncidentCoordinatorRoleDescription:
    'Користувач з роллю координатора інцидентів може увійти в додаток, щоб переглянути інциденти для слухачів, призначених їм. Вони також можуть закривати інциденти для цих слухачів з панелі управління.',
  findAppleOrder: 'Знайти замовлення Apple',
  incidentCoordinatorListenerLimitWarning:
    "Вам призначено більше 30 слухачів. Тут показані лише інциденти з перших 30. Будь ласка, зв'яжіться з вашим адміністратором.",
  newOrganization: 'Нова організація',
  switchOrganization: 'Змінити організацію',
  usageAnalytics: 'Аналітика використання',
  incidentsOpened: 'Всього відкрито інцидентів',
  incidentsOpen: 'Відкрито',
  incidentsAcknowledged: 'Підтверджено',
  incidentsClosed: 'Закрито',
  incidentsAutoClosed: 'Автоматично закрито',
  alarmsSent: 'Надіслано будильників',
  avgTimeToAcknowledge: 'Середній час підтвердження',
  avgTimeToResolve: 'Середній час вирішення',
  noAnalyticsData:
    'Дані аналітики ще недоступні. Дані записуються, коли відбуваються інциденти та інші події.',
  dailyTrend: 'Щоденна тенденція (останні 30 днів)',
  daily: 'Щоденно',
  weekly: 'Щотижнево',
  numbersView: 'Числа',
  chartView: 'Графік',
  last7Days: 'Останні 7 днів',
  last30Days: 'Останні 30 днів',
  last90Days: 'Останні 90 днів',
  last6Months: 'Останні 6 місяців',
  lastYear: 'Останній рік',
  noOrganizations: 'Ви не є частиною жодної організації.',
  maxOrganizationsReached:
    'Користувач може бути членом максимум 10 організацій.',
  yourOrganizations: 'Організації',
  urlNotFound: 'URL не відповідає жодному з підтримуваних маршрутів.',
  triggerAlert: 'Тригерний інцидент',
  recaptchaFailed: 'перевірка reCAPTCHA не вдалася. {{error}}',
  loadingAccountInformation: 'Завантаження інформації про обліковий запис',
  loadingAuthInfo: 'Завантаження інформації для автентифікації',
  allAlerts: 'Всім слухачам',
  recentlyTriggeredAlerts: 'Нещодавно активовані слухачі',
  recentlyClosedIncidents: 'Нещодавно закриті інциденти',
  noRecentlyTriggeredAlerts:
    'Останнім часом не було жодного слухача, який би спрацював.',
  noRecentlyClosedIncidents:
    'За останній час не було закрито жодного інциденту.',
  closedAt: 'Закрито о {{dateTimeString}}',
  dashboard: 'Приладова панель',
  loggedIntoOrganizationAccount: 'Орг.: {{organizationName}}\nРоль: {{role}}',
  viewIncidentEscalation: 'Переглянути ескалацію інциденту',
  closeIncident: 'Близький інцидент',
  closingIncident: 'Заключний інцидент',
  unableToRefreshEnterpriseAccount: 'Не вдалося оновити ваш обліковий запис.',
  viewAuthToken: 'Перегляд токену авторизації',
  problemWithCreatingAuthToken:
    'Виникла проблема зі створенням токена авторизації. Будь ласка, зверніться до служби технічної підтримки.',
  authToken: 'Токен авторизації',
  authTokenWarningMessage:
    'Завжди зберігайте цей токен у безпеці. Не передавайте його нікому. Якщо ви вважаєте, що ваш ключ API скомпрометований, натисніть кнопку "Змінити" вище, щоб змінити його. Після зміни токену вам потрібно буде вказати новий токен у всіх місцях, де ви ініціюєте інциденти за допомогою REST API',
  authTokenCopiedToClipboard: 'Токен авторизації скопійовано до буфера обміну.',
  resendVerificationEmail:
    'Повторно надіслати електронний лист з підтвердженням',
  loggedInUsingEmail: 'Увійшов за допомогою електронної пошти {{email}}.',
  checkingIfMemberIsAppUser: 'Перевірка, чи є учасник користувачем додатку.',
  settingMemberDetails: 'Налаштування даних учасника.',
  addingTeam: 'Додавання команди.',
  editingTeam: 'Редакційна група.',
  addingRotation: 'Додаю обертання.',
  editingRotation: 'Редакторська ротація.',
  assigningKeyToMember: 'Присвоєння ключа учаснику.',
  revokingKeyFromMember: 'Відкликання ключа у користувача.',
  deletingTeam: 'Команда видалення.',
  deletingRotation: 'Видалення обертання.',
  addingAlert: 'Додавання слухача.',
  editingAlert: 'Редагуючий слухач.',
  deletingAlert: 'Видалення слухача.',
  triggeringAlert: 'Запуск інциденту.',
  creatingOrganizationAccount: 'Створення облікового запису організації.',
  creatingCheckoutSession: 'Запуск сеансу оформлення замовлення.',
  creatingAnAccountForMember: 'Створення облікового запису для учасника.',
  passwordResetEmailSent:
    'Ми надіслали вам електронного листа для зміни пароля. Змініть пароль та увійдіть знову.',
  changeOwner: 'Змінити власника',
  changeOrganizationOwner: 'Змінити власника організації',
  newOwnerEmail: 'Електронна пошта нового власника',
  saveOnYearlySubscription: 'Зберегти {{percent}}%.',
  annual: 'Щорічний',
  resetAlarms: 'Оновити тривоги',
  resetAlarmsAlert:
    'Всі тривоги було оновлено. Якщо ви продовжуєте спостерігати проблеми з тривогами, будь ласка, надішліть тікет за допомогою опції "Повідомити про проблему".',
  resetAlarmsTooltipMessage:
    'Якщо у вас виникли проблеми з будильниками, наприклад, видалені будильники дзвонять на телефон, будь ласка, поновіть будильники за допомогою цієї опції. Якщо проблема не зникне, будь ласка, надішліть тікет за допомогою опції "Повідомити про проблему".',
  resetTempPassword: 'Скинути тимчасовий пароль',
  currPassword: 'Поточний пароль',
  tempPassword: 'Тимчасовий пароль',
  newPassword: 'Новий пароль',
  reset: 'Перезавантаження',
  loggingIn: 'Вхід в систему',
  resettingTempPassword: 'Скидання тимчасового пароля',
  changingPassword: 'Зміна пароля',
  numSeats: 'Кількість місць',
  helpMeDecide: 'Допоможіть мені вирішити.',
  numEnterpriseSeatsHelper:
    'Кількість місць має відповідати кількості людей у вашій організації, які будуть користуватися додатком для отримання інцидентів. Під час налаштування слухача ви можете вказати його політику ескалації. Політика ескалації може мати декілька рівнів. Наприклад, ви можете вказати, що перший рівень ескалації - до команди з 3 осіб. Якщо перший рівень ескалації не відповідає протягом 5 хвилин, другий рівень ескалації - для команди з 5 осіб. У цьому випадку ви можете вказати кількість місць 8.',
  numBusinessSeatsHelper:
    'Виберіть кількість місць відповідно до кількості людей, які будуть використовувати Galarm для отримання тривог і нагадувань.',
  perSeatPrice: '{{price}} за {{interval}} за місце',
  doneForToday: 'Прийнято',
  getStarted: 'Початок роботи',
  firstAlertInstructions: 'Інструкції для першого слухача',
  learnMoreAboutGalarmEnterprise: 'Дізнайтеся більше про Galarm Pro',
  home: 'Головна',
  team: 'Команда',
  alert: 'Тривога!',
  listener: 'Слухач',
  forgotPassword: 'Забули пароль?',
  forgotPasswordTitle: 'Забули пароль',
  sendPasswordResetEmail: 'Надіслати електронну пошту для скидання пароля',
  sendingPasswordResetEmail:
    'Надсилання електронного листа зі скиданням пароля',
  field: 'Поле',
  description: 'Опис',
  requestIntegration: 'Подати запит на іншу інтеграцію',
  integrationDetails: 'Деталі інтеграції',
  enterIntegrationDetails: 'Надайте деталі інтеграції',
  galarmEnterpriseFreeTrial:
    'Підпишіться на 14-денну безкоштовну пробну версію',
  galarmEnterpriseFreeTrialDescription: 'Автоматизуйте управління інцидентами',
  bySigningUpYouAgreeToOur: 'Реєструючись, ви погоджуєтеся з нашими',
  and: 'і',
  alarmSubscribers: 'Прихильники тривоги',
  otherSubscribersCount: {
    one: 'Ще 1 підписник відсутній у ваших контактах',
    other: '{{count}} більше підписників, яких немає у ваших контактах'
  },
  getAccountData: 'Експорт даних тривог',
  getAccountDataPrompt:
    'Вкажіть адресу електронної пошти, на яку ми надішлемо текстовий файл з усіма вашими тривогами.',
  getAccountDataConfirmation:
    'Зверніть увагу, що ми надішлемо вам текстовий файл з усіма вашими тривогами на електронну адресу {{email}}.',
  sendingAccountData: 'Експорт даних про тривоги...',
  sentAccountData: 'Дані про тривоги надсилаються на адресу {{email}}.',
  errorSendingAccountData: 'Помилка експорту даних тривог: {{error}}',
  sendingEmailVerificationLink:
    'Надсилання посилання для підтвердження електронної пошти',
  viewLogs: 'Перегляд журналів',
  message: 'Повідомлення',
  billing: 'Виставлення рахунків',
  newIncidentForAlert: 'Новий випадок для слухача {{alertName}}',
  triggerFailureForAlert:
    'Не вдалося активувати слухача {{alertName}}: {{error}}',
  clickNextAfterAddingMembers: 'Натисніть "Далі" після додавання учасників',
  clickDoneAfterAddingAlerts:
    'Натисніть "Готово", щоб завершити налаштування і перейти до Панелі керування.',
  alertCreatedSuccessfully:
    'Прослуховувач успішно створено. Ви можете активувати цей приймач за допомогою піктограми меню з трьома крапками навпроти назви приймача.',
  fixSubscription: 'Виправити підписку',
  fixSubscriptionDescription:
    'Ми виявили проблему з вашою підпискою. Ваша підписка містить {{numSeats}} місць, але ви призначили ключі {{numSeatsAssigned}} учасникам. Ви можете призначити не більше {{numSeats}} ключів.',
  fixSubscriptionChooseOption:
    'Будь ласка, виправте вашу підписку одним з наведених нижче способів.',
  fixSubscriptionContactAdmin:
    "Будь ласка, зв'яжіться з адміністратором вашої організації.",
  unassignKeysFromMembers:
    'Зніміть призначення принаймні {{extraKeysAssigned}} ключа(ів) з учасників',
  addMoreSeatsToSubscription:
    'Додайте принаймні {{extraKeysAssigned}} місць до своєї підписки',
  revokeMembersKey: 'Відкликати ключ учасника',
  revokeMembersKeyDescription:
    'Виберіть учасників, чиї ключі ви хочете відкликати.',
  revoke: 'Відкликати',
  unableToRevokeMembersKey:
    'Виникла помилка при відкликанні ключа учасника. Будь ласка, зверніться до служби підтримки.',
  problemWithLoadingProducts: 'Проблема із завантаженням товарів. {{error}}',
  verificationCompleted: 'Перевірку завершено',
  deviceAlreadyRegistered:
    'Цей номер телефону вже було перевірено на цьому пристрої.',
  phoneNumberAutoFilled:
    'Galarm буде використовувати обраний номер телефону з вашого облікового запису Google.',
  unableToRegisterPreVerifiedUser:
    'Не вдалося зареєструвати попередньо перевіреного користувача.',
  allowNotifications: 'Дозволити сповіщення',
  allowNotificationsDescription:
    'Відображення будильників, коли вони дзвонять.',
  scheduleExactAlarms: 'Тривоги за розкладом',
  scheduleExactAlarmsHelperText:
    'Дозвольте Galarm дзвонити по будильнику в точний час.',
  scheduleExactAlarmsDescription: 'Дзвонити на будильник в точний час.',
  disableBatteryOptimization: 'Керування оптимізацією акумулятора',
  disableBatteryOptimizationDescription:
    'Дозволити Galarm працювати у фоновому режимі.',
  requestRequiredPermissions:
    'Для активації тривог Galarm потрібні такі дозволи',
  allowDisallowedPermissions: 'Натисніть, щоб дозволити',
  notificationsAreEnabled: 'Дозвіл на показ сповіщень вже дозволено.',
  connectingToStore: 'Підключення до сховища...',
  restartApp: 'Перезапустити програму',
  updateAvailable: 'Доступне оновлення',
  english: 'Англійська мова',
  russian: 'Російська мова',
  german: 'Німецька',
  french: 'Французька',
  spanish: 'Іспанська',
  italian: 'Італійська',
  portuguese: 'Португальська',
  japanese: 'Японський',
  korean: 'Корейська',
  indonesian: 'Індонезійська',
  changeAppLanguage: 'Змінити мову програми',
  appLanguage: 'Мова програми',
  iosChangeAppLanguagePara1:
    'Galarm обирає мову програми з налаштувань вашого телефону. Будь ласка, виконайте ці кроки, щоб змінити мову додатку Galarm:',
  iosChangeAppLanguageInstruction1:
    'Відкрийте "Налаштування телефону > Загальні > Мова та регіон". Переконайтеся, що мова, яку ви хочете використовувати для Galarm, присутня у списку бажаних мов.',
  iosChangeAppLanguageInstruction2:
    'Поверніться до "Налаштувань телефону" і натисніть на "Galarm" у списку додатків внизу.',
  iosChangeAppLanguageInstruction3:
    'Натисніть на "Мова" і виберіть мову, яку ви хочете встановити для Galarm. Поверніться в додаток після вибору мови',
  androidChangeAppLanguagePara1:
    'Galarm обирає мову програми з налаштувань вашого телефону. Будь ласка, виконайте ці кроки, щоб змінити мову додатку Galarm:',
  androidChangeAppLanguageInstruction1:
    'Натисніть кнопку "Відкрити налаштування програми" нижче.',
  androidChangeAppLanguageInstruction2:
    'Натисніть на "Мова" і виберіть мову, яку ви хочете використовувати для Galarm.',
  androidChangeAppLanguageInstruction3:
    'Після вибору мови поверніться сюди і натисніть кнопку "Перезапустити програму" нижче.',
  problemRetrievingSubscriptionData:
    'Виникла проблема з отриманням інформації про вашу підписку. Ми перенаправляємо вас на сторінку облікового запису. Будь ласка, перевірте статус підписки та зверніться до служби технічної підтримки, якщо проблеми не зникнуть.',
  deletingOrganization: 'Видалення організації...',
  deleteOrganization: 'Видалити організацію',
  deleteOrganizationDescription:
    'Ви впевнені, що хочете видалити свою організацію?\n  \n  Це незворотна операція. Всі дані вашої організації будуть видалені.\n  \n  Будь ласка, переконайтеся, що ви скасували свою підписку перед видаленням організації.',
  galarmEnterpriseTrialDescription:
    'Існує 14-денна безкоштовна пробна версія, протягом якої ви можете скасувати підписку безкоштовно.',
  galarmEnterpriseTrialAlreadyAvailed:
    'Ви вже скористалися 14-денною безкоштовною пробною версією. Зверніться до служби підтримки, якщо вам потрібно більше часу, щоб оцінити продукт.',
  signinWithGoogle: 'Увійдіть за допомогою Google',
  signinWithGithub: 'Увійдіть за допомогою GitHub',
  verifyAccount: 'Підтвердити обліковий запис',
  verifyAccountMessage:
    'Ви повинні були отримати лист із кодом підтвердження. Введіть код нижче, щоб підтвердити свій обліковий запис. Якщо ви не отримали код, ви можете запросити новий код, натиснувши кнопку "Повторно надіслати код".',
  verificationCode: 'Код верифікації',
  optionalString: '{{string}}',
  quickReminderTitle: "Назва (необов'язково)",
  accountVerified: 'Обліковий запис підтверджено',
  accountVerifiedMessage:
    'Будь ласка, увійдіть, використовуючи свої облікові дані.',
  multipleUsersWithSameEmail:
    'Існує кілька користувачів з однаковою адресою електронної пошти. Зверніться до служби підтримки.',
  multipleUsersWithSameMobileNumber:
    'Існує декілька користувачів з одним номером мобільного телефону. Зверніться до служби підтримки.',
  startTrial: 'Почніть випробування',
  nextSteps: 'Наступні кроки',
  firstTimeSetupComplete:
    'Ви завершили початкове налаштування Galarm Enterprise і створили свого першого слухача. Нижче наведено кілька наступних кроків, які ви можете зробити з цього моменту.',
  testTheAlertInstruction:
    'Ознайомтеся з інструкціями на {{link}}, щоб дізнатися, як протестувати щойно створеного слухача.',
  integrateTheAlertInstruction:
    'Ознайомтеся з інструкціями на сайті {{link}}, щоб інтегрувати слухач з різними інструментами моніторингу.',
  createMoreAlertsInstruction:
    'Ви можете додати більше слухачів, перейшовши на вкладку "Слухачі" зліва.',
  addMoreMembersInstruction:
    'Ви можете додати більше учасників, перейшовши на вкладку "Учасники" зліва.',
  createTeamsInstruction:
    'Ви можете об\'єднати учасників у "Команди" і сповіщати цілі команди, коли відбувається інцидент. Створюйте команди, перейшовши на вкладку "Команди" зліва, і використовуйте їх у конфігурації слухача.',
  testTheAlert: 'Перевірте слухача',
  integrateTheAlert: 'Інтегруйте слухача',
  createMoreAlerts: 'Створіть більше слухачів',
  addMoreMembers: 'Додати більше членів',
  createTeams: 'Створення команд',
  docs: 'Документація',
  docsSmall: 'Док.',
  contactSupport: 'Зверніться до служби підтримки',
  pastDue: 'Прострочена заборгованість',
  canceled: 'Скасовано',
  unpaid: 'Неоплачений',
  incomplete: 'Неповний',
  incomplete_expired: 'Неповний Прострочений Термін дії закінчився',
  trialing: 'Безкоштовна пробна версія',
  paused: 'Призупинився.',
  plan: 'План',
  status: 'Статус',
  renewsOn: 'Поновлюється',
  yourRoles: 'Ваші ролі',
  enterprisePlan:
    '{{quantity}} поновлює кожне місце, поновлює кожне {{interval}}',
  currentOrganization: 'Поточна організація',
  useThisOrganization: 'Використовуйте цю організацію',
  fixPayment: 'Фіксований платіж',
  fixingPayment: 'Фіксація платежу',
  addPaymentInformation: 'Додати платіжну інформацію',
  noPaymentInformationAvailable:
    'Відсутня платіжна інформація. Будь ласка, оновіть сторінку, якщо ви нещодавно додали платіжну інформацію.',
  openBillingPortal: 'Відкритий білінговий портал',
  openingBillingPortal: 'Відкриття білінгового порталу',
  startupWizardDescription:
    'Цей майстер допоможе вам розпочати роботу і створити свого першого слухача.',
  userNotFound: 'Користувача не знайдено',
  wrongPassword: 'Неправильний пароль',
  emailAlreadyInUse: 'Вже використовувана адреса електронної пошти',
  restoreDeletedAlarms: 'Відновлення видалених тривог',
  deleteAlarmAlert:
    'Видалені тривоги можна відновити з розділу "Нещодавно видалені тривоги". Ви можете переглянути їх, натиснувши меню з трьома крапками (⋮) у верхньому правому куті вкладки "Тривоги".\n\nВидалені тривоги залишаються там протягом 30 днів, після чого їх буде видалено назавжди.',
  slackVerificationCode: 'Ваш код верифікації Slack: {{verificationCode}}.',
  dndAccess: 'Не заважати доступу',
  dndHelperText:
    'Дозвольте Galarm дзвонити на будильник, коли ваш телефон у режимі "Не турбувати".',
  cantRestoreInstantAlarmMessage:
    'Миттєві тривоги не підлягають відновленню. Ви можете переглянути чат та іншу інформацію за цим тривожним повідомленням, якщо це необхідно. Тривога буде видалена назавжди через 30 днів з моменту видалення.',
  upgradeToUnlockAllFeatures: 'Оновлення для розблокування всіх функцій',
  otherSignupOptions: 'Інші варіанти реєстрації:',
  renewSubscription: 'Поновити підписку',
  subscriptionOnHold:
    'На утриманні (Ваш тарифний план дозволяє {{subscriptionQty}} місць\nале ви призначили {{numSubscriptionKeys}} місць.',
  checklists: 'Завдання',
  checklist: 'Список завдань',
  typeToAddTask: 'Введіть, щоб додати завдання',
  specifyTaskName: 'Вкажіть назву завдання',
  otherChecklists: 'Списки завдань',
  defaultChecklistName: 'без назви',
  addTasksToChecklist: 'Додайте завдання за допомогою поля введення внизу',
  addTasksToDefaultChecklist:
    'Додайте завдання за допомогою поля введення внизу... або створіть новий список завдань, натиснувши кнопку + вгорі праворуч',
  createNewChecklist:
    "Ви можете створювати нові списки завдань, щоб відстежувати пов'язані завдання в одному місці.",
  addNewChecklist: 'Новий список завдань',
  alarmPhoto: 'Фото тривоги',
  alarmPhotoFeatureTitle: 'Фото тривоги',
  alarmPhotoFeatureDescriptionPremiumUser:
    "За допомогою цієї функції ви можете додати фотографію до будильника для швидких візуальних підказок, наприклад, фото ліків, інструкцій до завдання, предмета тощо. Фотографія з'явиться на екрані, коли спрацює будильник.",
  alarmPhotoFeatureDescriptionFreeUser:
    "За допомогою цієї функції ви можете додати фотографію до будильника для швидких візуальних підказок, наприклад, фото ліків, інструкцій до завдання, предмета тощо. Фотографія з'явиться на екрані, коли спрацює будильник.\n  \nЦе преміум-функція. Вам буде запропоновано перейти на преміум-аккаунт, щоб користуватися цією функцією.",
  alarmPhotoPremiumFeature: 'Додавання фото до нотаток про тривоги',
  installPendingAppUpdate:
    'Останнє оновлення програми завантажено і готове до встановлення.',
  numTasks: {
    zero: 'Немає завдань',
    one: '1 завдання',
    other: '{{count}} завдання'
  },
  numTasksWithCompleted: {
    one: '1 завдання, {{completed}} виконано',
    other: '{{count}} завдань, {{completed}} виконано'
  },
  muteAlarms: 'Вимкнути будильники',
  unmuteAlarms: 'Вимкнути будильники',
  alarmsAreMuted:
    'Наразі всі ваші будильники вимкнено. Торкніться, щоб увімкнути.',
  alarmsHaveBeenMuted:
    'Ваші будильники були вимкнені. Вони не задзвонять, поки ви їх не вимкнете.',
  alarmsHaveBeenUnmuted:
    'Ваші будильники були вимкнені. Вони повинні дзвонити, як було налаштовано.',
  deleteChecklist: 'Видалити список завдань',
  confirmDeleteChecklist: 'Видалити список завдань?',
  confirmDeleteCompletedTasks: 'Видалити завершені завдання?',
  confirmResetCompletedTasks: 'Скинути виконані завдання?',
  confirmDeleteTask: 'Видалити {{taskName}}?',
  showCompletedTasks: 'Показати виконані завдання',
  hideCompletedTasks: 'Приховати виконані завдання',
  deleteCompletedTasks: 'Видалення завершених завдань',
  resetCompletedTasks: 'Скинути виконані завдання',
  yourGroups: 'Ваші групи',
  newAlarmWith: 'Новий будильник з {{name}}',
  newGroupWith: 'Нова група з {{name}}',
  alertContact: 'Тривога! {{name}}',
  alertGroup: 'Тривога! {{name}}',
  instantAlarmMovedToFabNotice:
    'Функція миттєвого сигналу тепер доступна з кнопки “+” внизу праворуч на цьому екрані. Іконка “гучномовець” буде видалена з верхнього правого кута в майбутньому випуску.',
  tasksIntroTitle: 'Завдання та списки завдань',
  tasksIntroDescription:
    'Завдання - це ваші справи, які не мають дедлайну. Тут ви можете швидко додавати їх і керувати ними, відмічаючи їх, коли виконуєте кожне завдання.\n\nВи також можете створювати списки завдань, щоб групувати схожі завдання. Наприклад, ви можете створити список завдань для покупок продуктів, інший для робочих завдань і так далі.',
  groupsMovedToContactsScreen:
    '"Групи" були об\'єднані в цю вкладку. Ваші групи відображаються вгорі під заголовком "Ваші групи". Ви можете створювати нові групи, натиснувши на кнопку "+" внизу праворуч.',
  loadingTasks: 'Завантаження завдань...',
  tryPremium: 'Спробуйте Преміум',
  buyPremiumToUnlockFeature:
    'Це преміум-функція. Розблокуйте цю та багато інших крутих функцій за допомогою нашого преміум-плану з 14-денною безкоштовною пробною версією.',
  newTask: 'Нове завдання',
  newTaskList: 'Новий список завдань',
  enterTaskName: 'Введіть назву завдання',
  enterTaskListName: 'Введіть назву списку завдань',
  taskName: 'Назва завдання',
  taskListName: 'Назва списку завдань',
  checklistTasks: '{{name}}',
  editTaskListName: 'Редагування назви списку завдань',
  editTask: 'Завдання редагування',
  releaseNotes: 'Останні оновлення',
  currentRelease: '(наразі встановлено)',
  loadingReleaseNotes:
    'Завантажуємо останні оновлення. Будь ласка, переконайтеся, що ви підключені до Інтернету.',
  id: 'ІДЕНТИФІКАТОР',
  subscriptionData: 'Дані про підписку',
  organizations: 'Організації',
  showRotationCalendar: 'Показати календар ротацій',
  rotationCalendar: 'Календар ротацій',
  editShift: 'Редагувати Shift',
  startDateForShift: 'Дата початку зміни',
  startTimeForShift: 'Час початку зміни',
  endDateForShift: 'Дата закінчення зміни',
  endTimeForShift: 'Час закінчення зміни',
  editingShift: 'Зміна редагування',
  addingShift: 'Додавання зміни',
  products: 'Продукти',
  prices: 'Плани',
  planType: 'Тип плану',
  business: 'Бізнес',
  enterprise: 'Підприємство',
  compare: 'Порівняйте',
  apiSupport: 'Підтримка API для моніторингу послуг',
  accessToConsoleToViewAndCloseIncidents:
    'Інформаційна панель для управління інцидентами',
  triggerInstantAlertsFromTheConsole:
    'Запускайте інциденти з Enterprise Console',
  coreFeatures: 'Основні функції:',
  everythingInBusiness: 'Все, що є в бізнес-плані та:',
  updatePlanInstructions:
    'Ви можете оновити свій план, натиснувши на кнопку "Відкрити білінговий портал" праворуч і вибравши кнопку "Оновити план" на білінговому порталі.',
  membersDescription:
    'Ви придбали {{subscriptionKeysCount}} місць - {{assignedSubscriptionKeysCount}} призначених і {{unassignedSubscriptionKeysCount}} вільних. Галочка навпроти імені учасника вказує на призначене місце.',
  wizardMembersDescription:
    'Почніть з додавання людей, яких слід повідомити, коли спрацьовує тривога. Учасник — це будь-хто у вашій організації, хто повинен отримувати сповіщення про інциденти на свій телефон через додаток Galarm.',
  wizardAlertsDescription:
    'Тепер додайте слухача, який дозволяє налаштувати, кого сповіщати, коли у вашій організації відбуваються інциденти. Ви також можете налаштувати, як ескалувати інциденти, якщо вони не підтверджені вчасно. Після створення слухача ви можете отримати доступ до його URL-адреси вебхука, щоб запускати інциденти з ваших інструментів моніторингу з меню слухача. Ви також можете вручну запустити інцидент з меню слухача.',
  centralBilling: 'Централізований білінг',
  saveTwoMonths: 'Заощаджуйте 2 місяці',
  owner: 'Власник',
  enterpriseAccountSummary:
    'Ви є частиною організації {{organizationName}}, яка підписана на план Galarm Pro {{planType}}.',
  perYearPerUser: 'на одного користувача/рік',
  perMonthPerUser: 'за користувача/місяць',
  creationDate: 'Дата створення',
  updatePhoneNumber: 'Змінити номер телефону',
  confirmCountryCodeAndEnterUpdatedPhoneNumber:
    "Будь ласка, підтвердіть код країни та введіть свій новий номер телефону. Ваш акаунт буде прив'язаний до цього номера телефону після завершення верифікації.",
  unableToUpdatePhoneNumber:
    'Не вдається змінити номер телефону: {{error}}. Будь ласка, зверніться до служби підтримки.',
  phoneNumberUpdated: 'Номер телефону успішно змінено.',
  phoneNumberUpdatedMessage:
    'Ви можете почати користуватися додатком у звичайному режимі. Будь ласка, попросіть своїх контактів оновити ваш номер телефону в адресній книзі.',
  memberChangedPhoneNumber:
    '{{memberName}} змінив свій номер телефону. Будь ласка, оновіть свою адресну книгу, щоб продовжити додавати їх до будильників.',
  preferredSourceForIncidents: 'Бажане джерело інформації про інциденти',
  apiCodesDescription:
    'Для інтеграції слухача з джерелом скористайтеся наступними інструкціями',
  rotation: 'Ротація',
  noAlarmsForThisDay: 'Ніяких будильників на цей день',
  markAlarmsAsComplete: 'Позначити будильники як завершені',
  markAlarmsAsCompleteExplanation:
    'Одноразові тривоги будуть позначені як завершені і з\'являться в розділі "Неактивні".\n\nПовторювані тривоги будуть позначені як виконані і будуть перенесені до наступної події.',
  enterIncidentPrefix: 'Максимум 5 символів',
  incidentPrefix: 'Префікс інциденту',
  incidentPrefixAlreadyExists: 'Префікс інциденту вже існує',
  removeTask: 'Видалити завдання?',
  incidentPrefixLengthExceeded: 'Префікс інциденту довший за 5 символів',
  criticalAlerts: 'Критичні сповіщення',
  criticalAlertsConfiguration:
    'Будильник дзвонитиме на {{criticalAlertsVolume}}% гучності, навіть якщо ваш телефон вимкнено або увімкнено фокус.',
  criticalAlertsDisabledShort: 'Будильник не спрацює, якщо телефон вимкнено.',
  criticalAlertsConfigurationGlobal:
    'Будильники дзвонитимуть на {{criticalAlertsVolume}}% гучності, навіть якщо ваш телефон вимкнено або увімкнено фокус.',
  criticalAlertsDisabledShortGlobal:
    'Будильники не дзвонитимуть, якщо телефон вимкнено.',
  criticalAlertsEnabled:
    'Критичні сповіщення увімкнено. Будильники дзвонитимуть, навіть якщо ваш телефон вимкнено або увімкнено фокус.',
  criticalAlertsDisabled:
    'Критичні сповіщення вимкнено. Будильники не дзвонитимуть, якщо телефон вимкнено.',
  enableCriticalAlerts: 'Увімкнути критичні сповіщення',
  showFullScreenIntents: 'Показати тривогу на весь екран',
  showFullScreenIntentsDescription:
    'Коли телефон заблоковано, будильник відображатиметься на весь екран.',
  percentVolume: "{{volume}}% об'єму",
  selectADate: 'Будь ласка, оберіть дату для перегляду тривог.',
  affiliates: 'Партнери',
  referralCount: 'Кількість рефералів',
  addAffiliate: 'Додати партнера',
  creatingAffiliate: 'Створення афіліату',
  affiliateLink: 'Партнерське посилання',
  upgradeRequiredForWeb: 'Потрібне оновлення',
  upgradeToPremiumForWeb:
    'Ця функція вимагає преміум-підписки. Будь ласка, придбайте преміум-підписку в мобільному додатку, щоб скористатися цією функцією.',
  accountType: 'Тип рахунку',
  profileAndSettings: 'Профіль та налаштування',
  confirmIncidents: 'Підтвердити інциденти',
  removeIncidents: 'Видалити кілька інцидентів',
  incidents: 'Інциденти',
  closeSelectedIncidents: 'Закрити вибрані інциденти',
  viewIncidentNotes: 'Переглянути нотатки про інцидент',
  incidentNotes: 'Примітки до інциденту',
  incidentSummary: 'Короткий опис інциденту',
  addNote: 'Додати примітку',
  noAdditionalNotesForIncident:
    'Жодних додаткових коментарів щодо цього інциденту.',
  fromIncident: 'Від інциденту:',
  fromUsers: 'Від користувачів:',
  chooseFirstDayOfWeek: 'Виберіть перший день тижня',
  firstDayOfWeek: 'Перший день тижня',
  changePlan: 'План змін',
  currentPremiumSubscriptionStatus: 'Ви зараз підписані на план {{planName}}.',
  purchasedLifetimePlan: 'Ви придбали план "Довічний преміум".',
  currentProSubscriptionStatus: 'Ви є членом організації {{orgName}}.',
  currentStripePremiumSubscriptionStatus:
    'Ви зараз підписані на план {{planName}}.',
  changeToAnnualPlan: 'Перехід на річний план',
  unableToChangePlan:
    'Неможливо перейти на річний план. Будь ласка, зверніться до технічної підтримки через "Налаштування > Зворотній зв\'язок".',
  confirmChangeToAnnualPlan: 'Бажаєте перейти на річний план?',
  changeToAnnualPlanDescription:
    'З вас буде стягнуто {{price}} за річний тарифний план. Будь-які дні, що залишилися у вашому поточному плані, будуть скориговані відповідно до річного плану.',
  alarmTimezoneChanged:
    'Деякі будильники було оновлено для використання часового поясу пристрою, оскільки часовий пояс, який використовувався для цих будильників, не підтримується цим пристроєм.',
  defaultTimezoneChanged:
    'Стандартний часовий пояс для будильників змінено на часовий пояс пристрою, оскільки часовий пояс {{defaultTimezoneForAlarm}} не підтримується цим пристроєм. За необхідності оновіть усі існуючі будильники, які використовують цей часовий пояс.',
  invalidEmail: 'Неправильна адреса електронної пошти.',
  unableToValidateEmail: 'Неможливо підтвердити електронну пошту. {{error}}',
  havingProblems: 'Маєте проблеми?',
  alertData: 'Дані попередження',
  notificationActionBehavior: 'Поведінка сповіщення Дія Поведінка',
  foreground: 'Передній план',
  background: 'Передумови',
  notificationActionBehaviorTooltipMessage:
    'Якщо вибрано "На передньому плані", натискання на дію сповіщення відкриє програму на передньому плані. Якщо вибрано "На задньому плані", натискання на дію сповіщення залишатиме програму на задньому плані.',
  getCodeOnWhatsApp: 'Отримайте код на WhatsApp',
  getCode: 'Отримати код',
  dontHaveWhatsApp: 'Не маєте WhatsApp?',
  unableToSendCodeViaWhatsAppTitle: 'Не вдається надіслати код через WhatsApp',
  unableToSendCodeViaWhatsAppMessage:
    '{{error}}\n\nБудь ласка, запросіть код ще раз на іншому каналі.',
  dataSecurity: 'Безпека даних',
  customSnooze: 'Інше',
  customSnoozeDuration: 'Інше ({{durationString}})',
  snoozeDuration: 'Тривалість засинання',
  action: 'Дія',
  adsMessage:
    '\nДякуємо за довіру до Galarm. Щоб підтримати його розвиток, час від часу ви можете бачити рекламу.\n\nОновіть наш бюджетний преміум-план, щоб користуватися без реклами та отримати доступ до ще більшої кількості функцій.',
  headsUp: 'Обережно!',
  unableToAuthenticateUser: 'Не вдалося автентифікувати користувача. {{error}}',
  addOccurrence: 'Додати подію',
  closeIncidents: 'Закриті інциденти',
  closingIncidents: 'Закриття інцидентів',
  olderThanHours: 'Старіше, ніж (годин)',
  errorLoadingRecaptcha:
    'Виникла помилка під час завантаження reCAPTCHA виклику. Будь ласка, спробуйте ще раз через деякий час і зверніться до служби технічної підтримки, якщо проблема не зникне.',
  completeRecaptcha: 'Виконайте наступне завдання, щоб продовжити реєстрацію.',
  incidentNotesPlaceholder:
    "Додайте примітки для цього інциденту (необов'язково)",
  incidentSummaryPlaceholder:
    "Додайте короткий опис цього інциденту (необов'язково)",
  rotationMustHaveMembers:
    'Ротація повинна складатися щонайменше з одного учасника.',
  listenerMustHaveTriggers: 'Слухач повинен мати принаймні один тригер.',
  rotationExpiresOn: 'Термін дії закінчується {{dateString}}',
  rotationExpiredOn: 'Закінчився {{dateString}}',
  editAndSaveRotationToSetExpirationDate:
    'Відредагуйте та збережіть ротацію, щоб встановити термін придатності.',
  cantEnableAlarmNoValidNextDate:
    'Не вдається увімкнути будильник. Немає дійсної наступної дати для будильника.',
  noValidNextDateForAlarm: 'Немає дійсної наступної дати для тривоги.',
  lifetimePremium: 'Довічна премія',
  buyNow: 'Купити зараз',
  checkout: 'Оформити замовлення',
  cancelProduct: 'Скасувати товар',
  endTimeForCreatorCrossesMidnightForRecipientAlarm:
    'Час завершення будильника творця перетинає північ. Будь ласка, встановіть правильний час завершення.',
  dataRetention: 'Зберігання даних',
  retainIncidentsForDuration: 'Тривалість зберігання інциденту',
  retainIncidentsForDurationDescription:
    'Дозволяє вказати тривалість, протягом якої інцидент залишається в системі після його закриття. Навіть якщо встановлено значення "Без збереження", інциденти можуть залишатися в системі до чотирьох годин, перш ніж їх буде видалено під час періодичного циклу очищення.',
  noRetention: 'Без утримання',
  fetchingData: 'Отримання даних...',
  errorFetchingData: 'Помилка отримання даних: {{message}}',
  incidentsCleanupLevel: 'Рівень очищення інцидентів',
  incidentsCleanupLevelDescription:
    'Вказує стан інциденту, до якого інциденти очищуються під час періодичного циклу очищення. Якщо встановлено стан "Закрито", витираються всі закриті інциденти. Якщо встановлено стан "Підтверджено", витираються всі підтверджені або закриті інциденти.',
  connectedAccounts: "Пов'язані облікові записи Google",
  incidentNameTemplate: 'Шаблон назви інциденту',
  invalidIncidentNameTemplate:
    'Неправильний шаблон назви інциденту. Зверніть увагу, що ви можете використовувати лише "identifier", "name" та "summary" як імена змінних. Будь ласка, перевірте шаблон і спробуйте ще раз. Зверніться до служби підтримки, якщо проблеми продовжуються.',
  preferredSourceForIncidentsDescription:
    'Якщо ви хочете використовувати слухач як веб-хук або отримувати інциденти від інструменту моніторингу, будь ласка, виберіть джерело зі списку нижче. Коли ви виберете джерело, ми покажемо інструкції, як інтегрувати слухавку з джерелом.\n\nЦе необов\'язково, і ви можете переглянути інструкції для будь-якого джерела пізніше, скориставшись пунктом меню "Переглянути код" для слухача.',
  noCalendarsFoundForConnectedAccount:
    'Календарі для підключеного облікового запису не знайдено. Будь ласка, видаліть обліковий запис і додайте його знову, переконавшись, що Galarm має доступ до ваших календарів. Якщо проблема не зникає, зверніться до технічної підтримки через "Налаштування > Зворотній зв\'язок".',
  attachScreenshotsToFeedback:
    'Ви отримаєте електронного листа з підтвердженням того, що ми отримали ваш відгук. Якщо ви хочете поділитися знімками екрана, щоб допомогти нам краще зрозуміти проблему, будь ласка, надішліть нам лист зі знімками екрана.',
  checkFeedbackReceipt:
    'Будь ласка, перевірте свою поштову скриньку на наявність електронного листа з підтвердженням відправки. Якщо ви не бачите його у папці "Вхідні", перевірте папку "Спам" і додайте support@galarm.zendesk.com до своєї адресної книги.\n\nЯкщо ви хочете поділитися знімками екрану, щоб допомогти нам краще зрозуміти проблему, будь ласка, надішліть їх на електронну пошту.',
  watchRewardedAdToUnlockMessage: `Зараз ви побачите рекламу на весь екран. Ви зможете закрити її через кілька секунд. Ви побачите лише одну таку рекламу на день. Це допомагає нам зберігати додаток безкоштовним.

Щоб видалити рекламу та розблокувати додаткові функції, розгляньте можливість оновлення до нашого преміум-плану.`,
  watchRewardedAdToUnlockMessageAndroid: `Зараз ви побачите повноекранну рекламу тривалістю до 30 секунд. Після її завершення з'явиться повідомлення «Винагороду надано» та кнопка X зверху. Натисніть X, щоб закрити рекламу та продовжити.

Будь ласка, не натискайте кнопку назад, поки не з'явиться повідомлення «Винагороду надано». Ви побачите лише одну таку рекламу на день.

Щоб видалити рекламу та розблокувати додаткові функції, будь ласка, розгляньте можливість оновлення до нашого преміум-плану.`,
  watchRewardedAdToUnlockMessageIos: `Зараз ви побачите повноекранну рекламу тривалістю до 30 секунд. Після її завершення з'явиться повідомлення «Винагороду надано» та кнопка X зверху. Натисніть X, щоб закрити рекламу та продовжити.

Ви побачите лише одну таку рекламу на день. Щоб видалити рекламу та розблокувати додаткові функції, будь ласка, розгляньте можливість оновлення до нашого преміум-плану.`,
  dontShowMessageAgain: 'Не показувати це повідомлення знову',
  alphabeticalAsc: 'За алфавітним зростанням',
  alphabeticalDesc: 'За спаданням за алфавітом',
  newestFirst: 'Найновіші Перші',
  oldestFirst: 'Найстарший Перший',
  sortChecklistBy: 'Сортувати завдання за',
  addedTaskToDeleteAlert:
    'Додано завдання для видалення слухача. Цей слухач більше не буде приймати нові інциденти і буде видалений найближчим часом. Ви можете закрити це діалогове вікно і продовжити використання програми.',
  alertsData: 'Дані слухача',
  appNotConnectedToServer:
    "Додаток не підключений до сервера. Будь-які зміни зберігаються локально і будуть синхронізовані, коли програма підключиться до сервера. Натисніть, щоб відновити з'єднання.",
  unableToConnectToServer: 'Не вдалося підключитися до сервера.',
  pleaseCheckYourInternetConnection:
    "Будь ласка, перевірте своє інтернет-з'єднання.",
  autoCloseIncidents: 'Автоматичне закриття інцидентів',
  autoCloseIncidentsDescription:
    'Автоматичне закриття інцидентів через певний проміжок часу.',
  autoClosed: 'Автоматично закрито',
  never: 'Ніколи.',
  dndAccessNotGranted:
    'Доступ до функції "Не турбувати" не надано. Будильники можуть не спрацьовувати, якщо увімкнено функцію "Не турбувати".',
  deviceTokenExpired:
    'Ваш пристрій не отримує пуш-сповіщення від Galarm, оскільки термін дії токену пристрою закінчився. Будь ласка, перезапустіть додаток, щоб оновити токен.',
  unableToSendRemoteNotification:
    'Ваш пристрій не отримує пуш-сповіщення від Galarm. Код помилки: {{errorCode}}. Будь ласка, зверніться до технічної підтримки через "Налаштування > Зворотній зв\'язок".',
  cameraNotAvailable: 'Камера недоступна',
  removePhoneContacts: 'Видалення телефонних контактів',
  removePhoneContactsConfirmation:
    'Це призведе до видалення всіх синхронізованих контактів Galarm з контактів вашого телефону. Ви не зможете додати їх до будильників або груп. Ви можете синхронізувати контакти телефону знову, надавши дозвіл на доступ до контактів у налаштуваннях програми.',
  allowContactsPermission: 'Дозволити контакти Дозвіл',
  allowContactsPermissionDescription:
    'На наступному екрані натисніть Дозволи і дозвольте доступ до контактів.',
  revokeContactsPermission: 'Відкликати дозвіл на контакти',
  revokeContactsPermissionDescription:
    'Перш ніж видаляти контакти телефону, вам потрібно відкликати дозвіл на доступ до контактів. На наступному екрані торкніться Контактів і відмініть доступ до контактів.',
  phoneContactsRemoved:
    'Додано завдання для видалення телефонних контактів. Будь ласка, зверніться до служби підтримки, якщо контакти не будуть видалені через кілька хвилин.',
  specifyDate: 'Вкажіть дату',
  specifyTime: 'Вкажіть час',
  summer_soft: 'Summer Soft',
  beeps: 'Гудки.',
  bollywood_nights: 'Вечори Боллівуду',
  gentle_reminder: 'Лагідне нагадування',
  himalayan_piper: 'Гімалайська сопілка',
  holiday_joy: 'Святкова радість',
  hollywood_adventure: 'Голлівудська пригода',
  melody: 'Мелоді.',
  morning_rooster: 'Ранковий півень',
  morning_sunshine: 'Ранкове сонце',
  sweet_sea: 'Солодке море',
  old_school_ring: 'Трінг Трінг',
  horizon: 'Горизонт',
  symphony: 'Симфонія',
  chords: 'Акорди',
  discovery: 'Відкриття',
  rainforest: 'Тропічні ліси',
  wishes: 'Побажання',
  natural_marimba: 'Натуральна маримба',
  MyAlarmNotification: '{{alarmName}} - Пора.',
  ParticipantCascadingAlarmNotification:
    '{{alarmName}} - Саме час нагадати {{alarmCreatorName}}.',
  ParticipantSimultaneousAlarmNotification:
    '{{alarmName}}. Саме час підтвердити свою участь.',
  InstantAlarmNotification: '{{alarmName}}. Просимо вашої негайної уваги.',
  MyAlarmNotificationShort: 'Пора.',
  ParticipantCascadingAlarmNotificationShort:
    'Саме час нагадати {{alarmCreatorName}}.',
  ParticipantSimultaneousAlarmNotificationShort:
    'Саме час підтвердити свою участь.',
  InstantAlarmNotificationShort: 'Просимо вашої негайної уваги.',
  MyRecipientAlarmNotification:
    '{{alarmName}} - Саме час нагадати {{alarmRecipientName}}.',
  MyRecipientAlarmNotificationShort:
    'Саме час нагадати {{alarmRecipientName}}.',
  RecipientAlarmNotification:
    '{{alarmName}} (за матеріалами {{alarmCreatorName}}) - Час настав.',
  RecipientAlarmNotificationShort: 'Настав час - автор: {{alarmCreatorName}}.',
  adFreeExperiencePremiumFeature: 'Без реклами',
  adFreeExperienceFeatureDescription:
    'Насолоджуйтесь безперервним переглядом без реклами.',
  accountLabel: 'Мітка облікового запису',
  editAccountLabel: 'Редагувати мітку облікового запису',
  enterAccountLabel: 'Введіть назву для цього облікового запису',
  failedToUpdateLabel:
    'Не вдалося оновити мітку облікового запису. Спробуйте ще раз.',
  considerEvents: 'Встановити будильники для',
  importAllDayEvents: 'Імпортувати події на весь день',
  considerEventsStartingWith:
    'Встановити будильники для подій, що починаються з',
  eventsStartingWith: 'Події, що починаються з',
  allEvents: 'Всі події',
  noEvents: 'Немає подій',
  ringAlarmsForCalendarEvents: 'Нагадування про подію',
  durationBefore: '{{duration}} до',
  durationBeforeEventTime: '{{duration}} до початку заходу',
  beforeEventTime: 'до початку заходу',
  promptForUpdates: 'Запит на встановлення оновлень застосунку',
  calendarNotifications: 'Календарні сповіщення',
  enableEnhancedNotifications: 'Увімкнути',
  calendarWithSnoozeAt: 'Подія відбудеться наступного разу на {{timeString}}',
  calendarEventFeedbackHeader:
    'Ви будете надсилати частину інформації про цю подію календаря для цілей налагодження. Будь-які особисті дані, такі як назва події, опис або учасники, не будуть передаватися.',
  screenWillCloseAutomatically:
    'Цей екран автоматично закриється через {{seconds}} секунд.',
  viewingCalendarEvent: 'Перегляд події календаря для «{{title}}»',
  snoozingCalendarEvent: 'Відкладене календарне подія для «{{title}}»',
  calendarGrantExpired:
    'Доступ до календаря {{connectedAccountName}}, {{userName}} закінчився. Перейдіть до розділу «Налаштування» -> «Підключені календарі», видаліть обліковий запис і спробуйте ще раз.',
  linkedAccountsPremiumFeaturesDescription:
    "Ви можете пов'язати свої облікові записи Google та імпортувати події з основного календаря в Galarm.",
  instantAlarmPremiumFeaturesDescription:
    'Вам потрібна преміум-підписка, щоб створити більше миттєвих сигналів.',
  linkedAccountsPremiumFeatureDescription:
    'Підключіть свої облікові записи Google, щоб імпортувати події з основного календаря в Galarm.',
  linkedAccountsPremiumFeature: "Пов'язати календарі Google",
  calendarNotificationsTooltipMessage:
    "Повідомлення про пов'язані події календаря.",
  hideRecentlyDeletedAlarms: 'Приховати нещодавно видалені будильники',
  loadingCalendarEvent: 'Завантаження події календаря...',
  noOpenIncidents: 'Відкритих інцидентів немає',
  incidentsForMember: 'Інциденти для «{{name}}»',
  noIncidentsForMember: 'Поки що для цього учасника немає інцидентів',
  noIncidents: 'Ніяких інцидентів',
  labels: 'Етикетки',
  manageLabels: 'Керувати мітками',
  addLabel: 'Додати мітку',
  editLabel: 'Редагувати мітку',
  labelName: 'Назва лейбла',
  enterLabelName: 'Введіть назву мітки',
  existingLabels: 'Існуючі етикетки',
  noLabelsYet: 'Поки що не створено жодних міток',
  labelNameRequired: 'Потрібно вказати назву етикетки',
  labelAlreadyExists: 'Етикетка з такою назвою вже існує.',
  selectLabels: 'Вибрати етикетки',
  filterByMember: 'Фільтрувати за членом',
  filterByTeam: 'Фільтрувати за командою',
  filterByLabel: 'Фільтрувати за міткою',
  deletingLabel: 'Видалення мітки...',
  dutch: 'голландський',
  turkish: 'турецький',
  ukrainian: 'український',
  appSupportedLanguages:
    'Наразі Galarm підтримує англійську, російську, німецьку, французьку, іспанську, італійську, португальську, японську, корейську, індонезійську, голландську, турецьку та українську мови.',
  enhancedNotifications: 'Покращена доставка сповіщень',
  enhancedNotificationsPremiumFeatureDescription:
    'Якщо ця функція увімкнена, ви можете створювати додаткові будильники, навіть якщо операційна система вашого телефону не дозволяє запланувати більше будильників. Galarm вирішує цю проблему, плануючи будильники в хмарі та надсилаючи push-повідомлення на ваш телефон, коли настає час будильника.',
  enhancedNotificationsFeatureDescription:
    'Створюйте будильники навіть тоді, коли операційна система вашого телефону не дозволяє запланувати більше будильників.\n\nGalarm вирішує цю проблему, плануючи будильники в хмарі та надсилаючи push-повідомлення на ваш телефон, коли настає час будильника.',
  appTerminatedNotification: 'Повідомлення про припинення роботи програми',
  appTerminatedNotificationTooltipMessage:
    "Повідомлення, що з'являється при закритті програми. Рекомендується залишити програму працювати у фоновому режимі, щоб будильник спрацював вчасно.",
  cantChangeSetting: 'Не можна змінити {{settingName}}',
  fetchingAlarm: 'Отримання сигналу тривоги...',
  viewIncidentAlarms: 'Переглянути інциденти',
  showingIncidents: {
    zero: 'Ніяких інцидентів',
    one: 'Показано {{startIndex}} - {{endIndex}} з {{count}} інцидент',
    other: 'Показано {{startIndex}} - {{endIndex}} з {{count}} інцидентів'
  },
  noIncidentsFound: 'Інцидентів не виявлено',
  noIncidentsInSystem: 'У системі ще не зареєстровано жодного інциденту.',
  sendTestIncident: 'Тестовий інцидент',
  sendTestIncidentConfirmMessage:
    'Це викличе тестовий інцидент для слухача "{{alertName}}". Продовжити?',
  noListenersToSendTestIncident:
    'Вам потрібно налаштувати слухача, перш ніж ви зможете надіслати тестовий інцидент. Перейдіть до розділу Слухачі, щоб створити його.',
  pageSize: 'Розмір сторінки',
  incidentsPerPage: 'Інциденти на сторінку',
  identifier: 'Ідентифікатор',
  reportedAt: 'Повідомлено в',
  closedAtLabel: 'Закрито',
  priority: 'Пріоритет',
  allListeners: 'Всі слухачі',
  allDates: 'Всі дати',
  allPriorities: 'Всі пріоритети',
  allStatuses: 'Всі статуси',
  connectedAccountsDescription:
    'Ви можете підключити свій обліковий запис Google до Galarm, щоб отримувати сповіщення про події календаря в Galarm. Дізнайтеся більше на https://features.galarmapp.com/calendar-integration',
  removeGoogleAccount: 'Видалити обліковий запис Google',
  removeGoogleAccountDescription:
    'Ви впевнені, що хочете видалити цей обліковий запис Google?',
  unableToRemoveGoogleAccount: 'Неможливо видалити обліковий запис Google',
  googleAccountRemoved: 'Обліковий запис видалено',
  googleAccountRemovedDescription: 'Цей обліковий запис Google було видалено.',
  calendarEvent: 'Подія в календарі',
  connectedAccount: 'Підключений обліковий запис',
  linkedCalendars: "Пов'язані календарі",
  syncedCalendars: 'Синхронізовані календарі',
  availableCalendars: 'Доступні календарі',
  noSyncedCalendars:
    'Синхронізованих календарів не знайдено. Додайте календарі з розділу "Доступні календарі" нижче.',
  noAvailableCalendars: 'Немає доступних календарів для синхронізації.',
  removeCalendar: 'Видалити календар',
  calendarDetails: 'Деталі календаря',
  addingCalendar: 'Додавання календаря...',
  calendarAdded: 'Календар успішно додано',
  errorAddingCalendar: 'Помилка додавання календаря: {{error}}',
  duplicateCalendarDetectedTitle: 'Виявлено дубльований календар',
  removingCalendar: 'Видалення календаря...',
  calendarRemoved:
    "Ми додали завдання для видалення календаря. Ви можете закрити цей діалог і продовжити користуватися додатком. Будь ласка, зв'яжіться з підтримкою, якщо календар не буде видалено через кілька хвилин.",
  errorRemovingCalendar: 'Помилка видалення календаря: {{error}}',
  removeCalendarDescription:
    'Ви впевнені, що хочете видалити календар "{{calendarName}}"?',
  default: 'За замовчуванням',
  join_meeting_action: 'Приєднатися до зустрічі',
  view_calendar_event: 'Перегляд',
  snooze_calendar_event: 'Відкласти',
  dismiss_calendar_event: 'Відхилити',
  numEvents: {
    one: '1 подія',
    other: '{{count}} події'
  },
  calendarEvents: 'Події календаря',
  viewingCalendarEvents: 'Перегляд подій календаря',
  calendarEventAlarmName: 'Подія в календарі',
  calendarName: 'Назва календаря',
  meetingLink: 'Посилання на зустріч',
  attendees: 'Учасники',
  organizer: 'Організатор',
  addAccount: 'Додати обліковий запис',
  accountAlreadyConnected: 'Акаунт вже підключений',
  unableToSignInWithGoogle: 'Неможливо увійти за допомогою Google',
  unableToSignInWithGoogleDescription:
    'Виникла проблема під час входу за допомогою Google. Зверніться до служби технічної підтримки, скориставшись меню «Налаштування > Відгуки».',
  requiredScopesNotGranted:
    'Galarm не має доступу до ваших календарів, тому ми не можемо імпортувати події з вашого календаря. Будь ласка, видаліть обліковий запис і додайте його знову, переконавшись, що Galarm має доступ до ваших календарів. Якщо проблема не зникне, зверніться до технічної підтримки за допомогою «Налаштування > Відгуки».',
  refreshTokenNotFound:
    'Не вдається отримати доступ до облікового запису. Видаліть обліковий запис і додайте його знову. Якщо проблема не зникне, видаліть обліковий запис ще раз. Перейдіть на myaccount.google.com, натисніть «Дані та конфіденційність» ліворуч, прокрутіть униз до «Сторонні програми та служби», виберіть Galarm і натисніть «Видалити всі підключення до Galarm». Додайте обліковий запис знову. Зверніться до служби технічної підтримки, якщо ви знову побачите це повідомлення після виконання всіх кроків.',
  noCalendarsSyncedForConnectedAccount: 'Календарі не синхронізовані.',
  calendarsNotSynced:
    'Основний календар не синхронізовано. Натисніть кнопку оновлення, щоб синхронізувати календар.',
  calendarsSynced: 'Календарі успішно синхронізовані.',
  refreshGoogleAccount: 'Оновити обліковий запис Google',
  refreshingGoogleAccount: 'Оновлення облікового запису Google...',
  googleAccountRefreshed: 'Обліковий запис Google успішно оновлено',
  errorRefreshingGoogleAccount:
    'Помилка оновлення облікового запису Google: {{error}}',
  refreshGoogleAccountDescription:
    'Повторно імпортуйте події з календаря Google та налаштуйте автоматичні оновлення.',
  ignoreEvents: 'Ігнорувати події',
  ignoreEvent: 'Ігнорувати подію',
  unignoreEvent: 'Розклад подій',
  yourIgnoredEvents: 'Ваші проігноровані події',
  ignoredCalendarEvents: 'Проігноровані події календаря',
  noEventsSelected: 'Не вибрано жодних подій',
  selectEventsToIgnore: 'Виберіть події, які потрібно ігнорувати',
  showInCalendar: 'Показати в календарі',
  viewingIgnoredCalendarEvents: 'Перегляд проігнорованих подій календаря',
  viewIgnoredEvents: 'Переглянути проігноровані події',
  general: 'Загальне',
  addMembersAsContacts: 'Додати членів як контакти Galarm',
  addMembersAsContactsDescription:
    'Синхронізованих учасників можна додавати до сповіщень та груп у додатку Galarm. Після зміни цього параметра скористайтеся піктограмою оновлення, щоб виконати повторну синхронізацію.',
  resyncMembersPrompt:
    'Чи хочете ви повторно синхронізувати членів з новими налаштуваннями?',
  toAdmins: 'Адміністраторам',
  toEveryone: 'Всім',
  accountManagers: 'Менеджери по роботі з клієнтами',
  accountManager: 'Менеджер по роботі з клієнтами',
  viewAccountManagers: 'Переглянути менеджерів облікових записів',
  addAccountManager: 'Додати менеджера облікового запису',
  userAlreadyManager: 'Користувач вже є менеджером облікового запису.',
  noAccountManagersConfigured:
    'Не налаштовано жодного менеджера облікових записів.',
  addingAccountManager: 'Додавання менеджера облікового запису...',
  filterByCalendar: 'Фільтрувати за назвою календаря',
  calendarEventNotFound: 'Подія в календарі не знайдена',
  calendarEventNotFoundMessage:
    'Подія календаря з ідентифікатором {{eventId}} не знайдена. Можливо, вона була видалена або календар більше не доступний.',
  proMemberContact: 'Член організації в Galarm Pro',
  viewCalendarEvents: 'Переглянути події в календарі',
  noScheduledCalendarEvents: 'Немає запланованих подій у календарі',
  notSpecified: 'Не вказано',
  addedTaskToRemoveGoogleAccount:
    'Додано завдання для видалення облікового запису Google. Ви можете закрити це діалогове вікно і продовжувати користуватися додатком. Якщо обліковий запис не буде видалено через кілька хвилин, зверніться до служби підтримки.',
  success: 'Успіх',
  addingTaskToRemoveGoogleAccount:
    'Додавання завдання для видалення облікового запису Google...',
  addingGoogleCalendar:
    'Додавання завдання для синхронізації з Google Calendar...',
  googleCalendarAdded:
    'Ми підключили ваш обліковий запис Google і імпортуємо події з основного календаря. Натисніть на підключений обліковий запис, щоб налаштувати його звукові та вібраційні параметри.\n\nЯкщо події не імпортуються протягом декількох хвилин, зверніться до служби підтримки.',
  googleAccountLinkedSelectCalendars:
    "Ми пов'язали ваш обліковий запис Google і імпортуємо події з вибраних календарів.",
  multipleCalendarsUpgradeMessage:
    'Ми додали підтримку імпорту кількох календарів з одного облікового запису. Якщо ви бажаєте імпортувати кілька календарів з цього облікового запису, видаліть обліковий запис і додайте його знову.',
  errorAddingGoogleCalendar:
    'Помилка під час додавання Google Calendar: {{error}}',
  acceptedEvents: 'Події, які ви прийняли',
  declinedEvents: 'Події, які ви відхилили',
  tentativeEvents: 'Події, які ви позначили як «Можливо»',
  needsActionEvents: 'Події, що чекають на вашу відповідь',
  show: 'Показати',
  hide: 'Сховати',
  showAndRing: 'Показ і ринг',
  chooseBehavior: 'Виберіть поведінку',
  calendarEventBehavior: 'Обробка подій, на які ви запрошені',
  lastSyncedAt: 'Останнє синхронізування: {{dateTimeString}}',
  apiConfiguration: 'Конфігурація API',
  apiVersion: 'Версія API',
  apiVersionDescription:
    'Версія API використовується для забезпечення сумісності між додатком і сервером. Якщо ви використовуєте V2, то мобільний додаток повинен бути версії 9.9.0 або вище. Якщо у вас виникли проблеми з API, зверніться до служби технічної підтримки.',
  reschedulingEventsAsNeeded: 'Перенесення заходів за необхідності...',
  failedToUpdateSetting: 'Не вдалося оновити налаштування: {{error}}',
  selectEventsToSchedule:
    'Виберіть події, для яких потрібно запланувати сповіщення',
  scheduleEvents: 'Розклад подій',
  unableToRefreshGoogleAccount:
    'Неможливо повторно імпортувати події з календаря Google',
  calendarEventBehaviorDescription:
    'Виберіть, як Galarm повинен обробляти події, на які ви запрошені.',
  ringAlarmsForCalendarEventsTooltip:
    'Вкажіть, коли ви хочете отримати нагадування про подію.\n\n  Щоб отримувати додаткові нагадування, ви можете увімкнути автоматичне відкладення в налаштуваннях «Звук і вібрація».',
  sortAlarmCategories: 'Сортувати категорії тривог за',
  byNumAlarms: 'Кількість тривог',
  byName: "Ім'я",
  preReminderRingtone: 'Мелодія попередження',
  timerRingtone: 'Мелодія таймера',
  sortAlarmCategoriesTooltipMessage:
    'Виберіть спосіб сортування категорій будильників. Ви можете сортувати їх за кількістю будильників у кожній категорії або за алфавітом за назвою.',
  resetFilters: 'Скинути фільтри',
  alarm: 'Особистий будильник',
  alarmWithContacts: 'Будильник з контактами',
  instantAlarm: 'Миттєве Сповіщення',
  buddyAlarm: 'Будильник для друга',
  proMembersSyncCompleted: 'Синхронізація членів Pro завершена.',
  errorSyncingProMembers: 'Помилка синхронізації членів Pro: {{error}}',
  label: 'Етикетка',
  iosNotificationsLimitReached:
    'Ви досягли межі повідомлень iOS для програми.\n\nУвімкніть «Розширену доставку будильників», щоб усі будильники спрацьовували. Коли ця функція увімкнена, Galarm запланує будильники, які перевищують дозволену межу, у хмарі та надішле push-повідомлення на ваш телефон, коли настане час цих будильників.',
  notificationLimitReached: 'Попередження про обмеження повідомлень',
  remoteAlarmCloudMessage:
    'Ця сигналізація налаштовується дистанційно в хмарі і вимагає активного підключення до Інтернету в момент спрацьовування сигналу тривоги.',
  signUpForMailingList: 'Підпишіться на важливі оголошення',
  signedUpForMailingList: 'Підписалися на важливі оголошення',
  unsubscribe: 'Відписатися',
  confirmUnsubscribeFromMailingList:
    'Ви впевнені, що хочете відписатися від важливих оголошень?',
  unsubscribingFromMailingList: 'Відписка від важливих оголошень...',
  successfullyUnsubscribedFromMailingList:
    'Успішно відписалися від важливих оголошень.',
  errorUnsubscribingFromMailingList:
    'Виникла помилка при відписці від важливих оголошень. Будь ласка, спробуйте пізніше.',
  signingUpForMailingList: 'Реєстрація для отримання важливих оголошень...',
  successfullySignedUpForMailingList:
    'Успішно зареєструвалися для отримання важливих оновлень.',
  errorSigningUpForMailingList:
    'Сталася помилка під час реєстрації для отримання важливих оновлень. Спробуйте ще раз пізніше.',
  recentlyUsed: 'Нещодавно використані',
  startStopWatch: 'Запустити секундомір',
  stopWatch: 'Секундомір',
  stopWatches: 'Секундоміри',
  utilities: 'Інструменти',
  addAlarmForTask: 'Додати будильник для завдання',
  noExpiredAlarmsToDelete: 'Немає пропущених будильників для видалення',
  noAlarmsToDelete: 'Немає будильників для видалення',
  noAlarmsToEnable: 'Немає будильників для увімкнення',
  noAlarmsToDisable: 'Немає будильників для вимкнення',
  noAlarmsToMarkAsComplete: 'Немає будильників для позначення як завершені',
  noIncidentsToConfirm: 'Немає інцидентів для підтвердження',
  noIncidentsToClose: 'Немає інцидентів для закриття',
  noEventsToIgnore: 'Немає подій для ігнорування',
  noEventsToSchedule: 'Немає подій для планування',
  addAlarmForChecklist: 'Додати будильник для списку завдань',
  openTaskList: 'Відкрити список завдань',
  alarmForTask: 'Завдання',
  alarmForTaskList: 'Список завдань',
  EnterpriseAlertIncidentTriggered:
    'Було запущено інцидент для оповіщення {{alertName}}.',
  docChatbotWelcome:
    'Привіт! Я тут, щоб допомогти вам навчитися користуватися Galarm Enterprise. Задавайте мені будь-які питання про функції, налаштування або виконання конкретних завдань.',
  docChatbotError:
    'Вибачте, сталася помилка. Спробуйте ще раз або зверніться до служби підтримки.',
  docChatbotTitle: 'Аллі',
  docChatbotPlaceholder: 'Запитайте...',
  helpAssistant: 'Допомога',
  needHelp: 'Потрібна допомога?',
  helpPopupMessage:
    '"Allie", наш чат-асистент, готовий допомогти вам! Ви можете запустити його в будь-який час з меню "Допомога" у верхній панелі.',
  askTheHelpAssistant: 'Запитайте "Еллі"',
  newConversation: 'Нова розмова',
  setupStep: 'Крок {{current}} з {{total}}',
  escalationPolicyTooltip:
    'Політика ескалації визначає, хто отримує сповіщення, коли відбувається інцидент, і в якому порядку. Ви можете додати кілька тригерів, щоб сповістити різних людей у різний час, якщо інцидент не буде підтверджено.',
  stopwatchTotal: 'Загалом',
  stopwatchCurrent: 'Поточний',
  stopwatchStart: 'Почати',
  stopwatchStop: 'Зупинити',
  stopwatchFinish: 'Завершити',
  stopwatchStartNextLap: 'Почати наступне коло',
  startTimer: 'Почати',
  stopwatchLapAndContinue: 'Коло і продовжити',
  stopwatchLapAndPause: 'Коло і пауза',
  stopwatchLapAndStop: 'Коло і завершити',
  savingStopwatch: 'Збереження секундоміра...',
  errorSavingStopwatch: 'Помилка збереження секундоміра.',
  timerRequiresValidDuration: 'Спочатку встановіть тривалість таймера.',
  stopwatchLapAndContinueHelp: 'Записує поточне коло і негайно починає нове.',
  stopwatchLapAndPauseHelp:
    'Записує поточне коло і зупиняє. Ви можете додати примітки до кола і продовжити, коли будете готові почати наступне коло.',
  stopwatchLapAndStopHelp:
    'Записує останнє коло і завершує секундомір. Ви можете додати мітку та примітки для кожного кола перед збереженням.',
  stopwatchDiscardConfirmMessage:
    'У вас є активний секундомір. Повернення назад скине його. Продовжити?',
  stopwatchLapLabel: 'Коло {{index}}',
  stopwatchAddNote: 'Додати примітку',
  stopwatchLabelPlaceholder: 'Додати мітку',
  stopwatchStoppedAt: 'Зупинено на',
  stopwatchDetails: 'Деталі секундоміра',
  deleteStopwatches: 'Видалити секундоміри',
  deleteStopwatch: 'Видалити секундомір',
  deleteStopwatchConfirmMessage:
    'Ви впевнені, що хочете видалити цей секундомір?',
  noStopwatchesToDelete: 'Немає секундомірів для видалення',
  noStopwatchesYet:
    'Натисніть +, щоб запустити секундомір. Ваші завершені секундоміри з проміжними часами будуть відображені тут.',
  stopwatchInProgress: 'Секундомір працює — натисніть, щоб відкрити',
  stopwatchLaps: {
    one: '1 коло',
    other: '{{count}} кіл'
  },
  newAlarmButtonBehavior: 'Поведінка кнопки нового будильника',
  newAlarmButtonBehaviorTooltipMessage:
    'Змініть параметри, що відображаються в кнопці нового будильника',
  classic: 'За замовчуванням',
  mode: 'Режим',
  classicFabDescription:
    'Показати параметри Швидкого нагадування та Будильника',
  classicAlarmDescription: 'Показує параметри для вибору типу будильника',
  custom: 'Користувацький',
  customFabDescription: 'Виберіть, які параметри показувати',
  chooseNewAlarmButtonOptions: 'Параметри кнопки нового будильника',
  fabOptionsMustHaveAtLeastOne: 'Потрібно вибрати принаймні один варіант',
  actUtilities: 'Дія',
  connectUtilities: 'Підключити',
  timer: 'Таймер',
  setTimer: 'Встановити таймер',
  timerFinished: 'Час вийшов!',
  hoursShort: 'Години',
  minutesShort: 'Хвилини',
  secondsShort: 'Секунди',
  adBelow: 'Реклама нижче',
  buyGalarmPremium: 'Купити Galarm Premium',
  phoneNumberForPremiumDescription: `Введіть номер телефону, зареєстрований у Galarm. Ми надішлемо код підтвердження у ваш додаток Galarm.

Щоб перевірити, чи зареєстрований ваш номер телефону, відкрийте вкладку Налаштування в Galarm. Ваш зареєстрований номер телефону відображається під іменем профілю.

Якщо ви ще не зареєстрували номер телефону, ви можете зробити це на вкладці Контакти в додатку Galarm. Після реєстрації введіть тут той самий номер телефону, щоб придбати підписку Premium.`,
  enterPhoneNumberForPremiumValidation:
    'Будь ласка, введіть код країни та номер телефону.',
  pleaseCompleteCaptcha: 'Будь ласка, пройдіть перевірку CAPTCHA.',
  requestVerificationCode: 'Запитати код',
  unableToSendAppVerificationCode:
    'Не вдалося відправити код перевірки. Будь ласка, спробуйте ще раз. {{error}}',
  enterVerificationCodeForPremium: 'Введіть код перевірки',
  verificationCodeForPremiumDescription: `Введіть код підтвердження, надісланий у ваш додаток Galarm.

Щоб знайти код, відкрийте вкладку Сповіщення та натисніть Системні повідомлення.

Якщо ви не бачите код:
  - Переконайтеся, що використовуєте останню версію додатка Galarm.
  - Переконайтеся, що ваш пристрій має активне підключення до Інтернету.
  - Якщо ви щойно оновили додаток, поверніться назад і знову запросіть код.

Якщо код усе ще не з'являється, зверніться до підтримки з додатка через вкладку Налаштування > Зворотний зв'язок.`,
  enterVerificationCodeForPremiumValidation:
    'Будь ласка, введіть код перевірки.',
  verifyCode: 'Перевірити',
  unableToVerifyAppCode:
    'Не вдалося перевірити код. Будь ласка, перевірте та спробуйте ще раз. {{error}}',
  buyPremiumMonthly: 'Щомісячно',
  buyPremiumYearly: 'Щорічно (Найкраща ціна)',
  monthlyPrice: '{{price}}/місяць',
  yearlyPrice: '{{price}}/рік',
  buyPremiumLifetime: 'Довічно',
  lifetimePrice: '{{price}} одноразово',
  creatingStripeCustomer: 'Підготовка вашого облікового запису...',
  problemCreatingStripeCustomer:
    'Виникла проблема з налаштуванням вашого облікового запису. Будь ласка, спробуйте ще раз. {{error}}',
  premiumPurchaseSuccessTitle: 'Ласкаво просимо до Galarm Premium!',
  premiumPurchaseSuccess:
    'Ваша покупка була успішною. Дякуємо за підписку на Galarm Premium. Відкрийте додаток Galarm на вашому телефоні, щоб насолоджуватися новими функціями.',
  goToGalarmWeb: 'Перейти на Galarm Web',
  premiumPurchaseCancelledTitle: 'Покупка скасована',
  premiumPurchaseCancelled:
    'Ваша покупка не була завершена. Ви можете спробувати ще раз у будь-який час.',
  countryCode: 'Код країни',
  appVerificationCodeToBuyPremiumSubscription:
    'Код підтвердження для покупки преміум-підписки: {{verificationCode}}',
  loadingProducts: 'Завантаження продуктів...',
  invoicesSentToThisEmail: 'Рахунки будуть надіслані на цю електронну адресу.',
  tryPremiumFreeCancelAnytime:
    '🎉 14-денна безкоштовна пробна версія — спробуйте преміум безкоштовно, скасуйте в будь-який час. Одна пробна версія на обліковий запис.',
  galarmWebPremium: 'Galarm Web - це преміум-функція',
  subscribeToGetAccess:
    'Підпишіться, щоб отримати доступ. Включає 14-денну безкоштовну пробну версію.',
  subscribeToPremium: 'Підписатися на Galarm Premium',
  havingTroubleWithPremium: 'Виникли проблеми з покупкою преміум?',
  purchaseOnWebsite: 'Купити на сайті',
  purchaseOnWebsiteDescription:
    'Якщо у вас виникли проблеми з придбанням преміуму в додатку, ви можете придбати його на нашому веб-сайті.',
  manageSubscriptionFromBillingPortal:
    'Ви можете змінити свою підписку через платіжний портал.',
  docChatbotDefaultResponse:
    "Вибачте, у мене немає інформації, яку ви шукаєте. Будь ласка, зверніться до нашої документації за адресою https://docs.galarmapp.com або зв'яжіться зі службою підтримки для отримання додаткової допомоги."
}
